/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** UserStatus */
export enum UserStatus {
  Active = "Active",
  Inactive = "Inactive",
  Suspended = "Suspended",
}

/**
 * UserRole
 * Describes the roles a user can have within the system.
 */
export enum UserRole {
  Admin = "Admin",
  User = "User",
  Employee = "Employee",
  Dev = "Dev",
  FieldWorker = "FieldWorker",
}

/** TicketStatus */
export enum TicketStatus {
  Open = "Open",
  InProgress = "In Progress",
  Resolved = "Resolved",
  Closed = "Closed",
}

/** TicketPriority */
export enum TicketPriority {
  Low = "Low",
  Medium = "Medium",
  High = "High",
  Urgent = "Urgent",
}

/** TicketCategory */
export enum TicketCategory {
  Technical = "Technical",
  Billing = "Billing",
  FeatureRequest = "Feature Request",
  BugReport = "Bug Report",
  General = "General",
  Account = "Account",
}

/**
 * SessionStatus
 * Describes the status of a project monitoring session.
 */
export enum SessionStatus {
  Upcoming = "upcoming",
  Active = "active",
  Completed = "completed",
}

/** ProjectType */
export enum ProjectType {
  Agroforestry = "Agroforestry",
  Conservation = "Conservation",
}

/** ProjectStatusEnum */
export enum ProjectStatusEnum {
  Draft = "Draft",
  UnderDevelopment = "Under development",
}

/**
 * MediaType
 * Describes the type of media file.
 */
export enum MediaType {
  IMAGE = "IMAGE",
  VIDEO = "VIDEO",
  AUDIO = "AUDIO",
}

/**
 * DeviceStatus
 * Describes the status of a device.
 */
export enum DeviceStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  DEFECTIVE = "DEFECTIVE",
  RETIRED = "RETIRED",
}

/**
 * DeploymentStatus
 * Describes the status of a deployment.
 */
export enum DeploymentStatus {
  Upcoming = "Upcoming",
  Past = "Past",
  Retrieved = "Retrieved",
  Completed = "Completed",
  Deployed = "Deployed",
  Inaccessible = "Inaccessible",
  Cancelled = "Cancelled",
}

/**
 * AcousticIndexEnum
 * Describes the acoustic indices
 */
export enum AcousticIndexEnum {
  Aci = "aci",
  Bi = "bi",
  Adi = "adi",
  Aei = "aei",
  Ndsi = "ndsi",
}

/** APIEndpointCreate */
export interface APIEndpointCreate {
  /**
   * Service Name
   * Service/module name (e.g., 'ESG Data', 'Reports')
   */
  service_name: string;
  /**
   * Path
   * API endpoint path (e.g., '/api/v2/esg/data')
   */
  path: string;
  /**
   * Method
   * HTTP method (GET, POST, PUT, DELETE)
   */
  method: string;
  /**
   * Description
   * Description of the endpoint
   */
  description?: string | null;
  /**
   * Enabled
   * Whether the endpoint is enabled
   * @default false
   */
  enabled?: boolean | null;
}

/** APIEndpointOut */
export interface APIEndpointOut {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Service Name */
  service_name: string;
  /** Path */
  path: string;
  /** Method */
  method: string;
  /** Description */
  description?: string | null;
  /** Enabled */
  enabled: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
}

/** APIEndpointQueryResult */
export interface APIEndpointQueryResult {
  /** Endpoints */
  endpoints: APIEndpointOut[];
  /** Count */
  count: number;
}

/** APIEndpointToggle */
export interface APIEndpointToggle {
  /**
   * Enabled
   * Enable or disable the endpoint
   */
  enabled: boolean;
}

/** APIEndpointUpdate */
export interface APIEndpointUpdate {
  /** Service Name */
  service_name?: string | null;
  /** Path */
  path?: string | null;
  /** Method */
  method?: string | null;
  /** Description */
  description?: string | null;
  /** Enabled */
  enabled?: boolean | null;
}

/**
 * APIKeyCreateResponse
 * Response schema for API key creation
 */
export interface APIKeyCreateResponse {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /**
   * Api Key
   * Full API key (shown only once)
   */
  api_key: string;
  /**
   * Key Prefix
   * @maxLength 20
   */
  key_prefix: string;
  /** Status */
  status: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Message
   * @default "API key created successfully. Store this key securely."
   */
  message?: string;
}

/**
 * APIKeyOut
 * Schema for API key output (no sensitive data)
 */
export interface APIKeyOut {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /**
   * Key Prefix
   * First 15 characters of the API key
   * @maxLength 20
   */
  key_prefix: string;
  /**
   * Status
   * Status: active, revoked
   */
  status: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Last Used At */
  last_used_at?: string | null;
  /** Expires At */
  expires_at?: string | null;
  /** User Name */
  user_name?: string | null;
  /** User Email */
  user_email?: string | null;
}

/**
 * APIKeyPermissionsResponse
 * Response schema for API key permissions
 */
export interface APIKeyPermissionsResponse {
  /**
   * Api Key Id
   * @format uuid
   */
  api_key_id: string;
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /**
   * Permissions
   * List of permissions
   */
  permissions: Record<string, any>[];
  /**
   * Message
   * @default "API key permissions retrieved successfully"
   */
  message?: string;
}

/**
 * APIKeyQueryResult
 * Response schema for paginated API key list
 */
export interface APIKeyQueryResult {
  /** Api Keys */
  api_keys: APIKeyOut[];
  /**
   * Count
   * Total number of API keys matching the query
   */
  count: number;
}

/**
 * APIKeyRegenerateResponse
 * Response schema for API key regeneration
 */
export interface APIKeyRegenerateResponse {
  /**
   * Api Key Id
   * @format uuid
   */
  api_key_id: string;
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /**
   * Api Key
   * New full API key (shown only once)
   */
  api_key: string;
  /**
   * Message
   * @default "API key regenerated successfully"
   */
  message?: string;
}

/**
 * APIKeyRevokeResponse
 * Response schema for API key revocation
 */
export interface APIKeyRevokeResponse {
  /**
   * Api Key Id
   * @format uuid
   */
  api_key_id: string;
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /**
   * Message
   * @default "API key revoked successfully"
   */
  message?: string;
}

/**
 * APIKeyUsageResponse
 * Response schema for API key usage statistics
 */
export interface APIKeyUsageResponse {
  /**
   * Api Key Id
   * @format uuid
   */
  api_key_id: string;
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /**
   * Usage
   * Usage statistics
   */
  usage: Record<string, any>;
  /**
   * Message
   * @default "API key usage retrieved successfully"
   */
  message?: string;
}

/** APIRequestLogOut */
export interface APIRequestLogOut {
  /**
   * User Id
   * User ID (DEV role) this API key belongs to
   */
  user_id?: string | null;
  /**
   * Api Key Prefix
   * API key prefix
   */
  api_key_prefix?: string | null;
  /**
   * Endpoint Path
   * API endpoint path
   */
  endpoint_path: string;
  /**
   * Method
   * HTTP method
   */
  method: string;
  /**
   * Status Code
   * HTTP status code
   */
  status_code: number;
  /**
   * Response Time Ms
   * Response time in milliseconds
   */
  response_time_ms?: number | null;
  /**
   * Ip Address
   * IP address
   */
  ip_address?: string | null;
  /**
   * User Agent
   * User agent
   */
  user_agent?: string | null;
  /**
   * Created At
   * Created at
   */
  created_at?: string | null;
  /**
   * Id
   * ID
   * @format uuid
   */
  id: string;
}

/**
 * ActiveDeviceResponse
 * Response containing the currently active device for a deployment.
 */
export interface ActiveDeviceResponse {
  /**
   * Deployment Device Id
   * @format uuid
   */
  deployment_device_id: string;
  /**
   * Device Id
   * @format uuid
   */
  device_id: string;
  /** Device Name */
  device_name?: string | null;
  /** Device Asset Tag */
  device_asset_tag?: string | null;
  /** Device Condition */
  device_condition?: string | null;
  /** Device Status */
  device_status?: string | null;
  /**
   * Assigned At
   * @format date-time
   */
  assigned_at: string;
  /** Assigned By */
  assigned_by?: string | null;
  /** Notes */
  notes?: string | null;
  /** Reason */
  reason?: string | null;
}

/**
 * ActivityTrend
 * Activity trend data for one deployment.
 */
export interface ActivityTrend {
  /** Time Slots */
  time_slots: string[];
  /** Species Trends */
  species_trends: Record<string, any>;
}

/** AssessmentMediaDownloadRequest */
export interface AssessmentMediaDownloadRequest {
  /** Media Url */
  media_url: string;
}

/** AssessmentMediaUploadRequest */
export interface AssessmentMediaUploadRequest {
  /** File Name */
  file_name: string;
  /** Folder */
  folder: string;
  /** Content Type */
  content_type: string;
}

/**
 * AssignDeviceRequest
 * Request to assign a device to a deployment.
 */
export interface AssignDeviceRequest {
  /**
   * Device Id
   * @format uuid
   */
  device_id: string;
  /**
   * Assigned By
   * @format uuid
   */
  assigned_by: string;
  /** Notes */
  notes?: string | null;
}

/**
 * Assignment
 * Schema for returning Assignment details to the client, including nested User and Project data.
 */
export interface Assignment {
  /**
   * User Id
   * ID of the assigned employee (User)
   * @format uuid
   * @example "7e03526e-dee5-436f-aa7b-901839406f85"
   */
  user_id: string;
  /**
   * Project Id
   * ID of the assigned project
   * @format uuid
   * @example "207e4805-7125-4759-83a1-04df7ee90b86"
   */
  project_id: string;
  /**
   * Assignment Id
   * @format uuid
   */
  assignment_id: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  user: UserResponse;
  project: ProjectResponse;
}

/**
 * AssignmentCreate
 * Schema for creating a new Assignment.
 */
export interface AssignmentCreate {
  /**
   * User Id
   * ID of the assigned employee (User)
   * @format uuid
   * @example "7e03526e-dee5-436f-aa7b-901839406f85"
   */
  user_id: string;
  /**
   * Project Id
   * ID of the assigned project
   * @format uuid
   * @example "207e4805-7125-4759-83a1-04df7ee90b86"
   */
  project_id: string;
}

/** AudioProcessingRequest */
export interface AudioProcessingRequest {
  /**
   * File Id
   * @format uuid
   */
  file_id: string;
  /** Gcs Path */
  gcs_path: string;
}

/** AuditLogOut */
export interface AuditLogOut {
  /**
   * Admin User Id
   * Admin user ID
   */
  admin_user_id?: string | null;
  /**
   * Action
   * Action
   */
  action: string;
  /**
   * Entity Type
   * Entity type
   */
  entity_type: string;
  /**
   * Entity Id
   * Entity ID
   */
  entity_id?: string | null;
  /**
   * Details
   * Details
   */
  details?: Record<string, any> | null;
  /**
   * Reason
   * Reason
   */
  reason?: string | null;
  /**
   * Created At
   * Created at
   * @format date-time
   */
  created_at: string;
  /**
   * Id
   * ID
   * @format uuid
   */
  id: string;
}

/**
 * BatchFileFinalizeItem
 * A single file entry in a batch finalize request.
 */
export interface BatchFileFinalizeItem {
  /** Gcs Path */
  gcs_path: string;
  /** File Name */
  file_name: string;
}

/**
 * BatchFileFinalizeRequest
 * Request body for batch finalize upload.
 */
export interface BatchFileFinalizeRequest {
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /** Files */
  files: BatchFileFinalizeItem[];
}

/**
 * BatchFileFinalizeResponse
 * Response for batch finalize — returns all created file records.
 */
export interface BatchFileFinalizeResponse {
  /** Queued */
  queued: number;
  /** Files */
  files: FileAdminDetailWithUser[];
}

/**
 * BatchFileUploadItem
 * A single file entry in a batch upload request.
 */
export interface BatchFileUploadItem {
  /** File Name */
  file_name: string;
  /** Content Type */
  content_type: string;
}

/**
 * BatchFileUploadRequest
 * Request body for batch signed URL generation.
 */
export interface BatchFileUploadRequest {
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /** Files */
  files: BatchFileUploadItem[];
}

/**
 * BatchFileUploadResponseItem
 * A single item in the batch upload URL response.
 */
export interface BatchFileUploadResponseItem {
  /** File Name */
  file_name: string;
  /** Upload Url */
  upload_url: string;
  /** Gcs Path */
  gcs_path: string;
}

/** BiodiversityProjectAnalysis */
export interface BiodiversityProjectAnalysis {
  /** Cameras Installed */
  cameras_installed?: number | null;
  /** Audio Devices Installed */
  audio_devices_installed?: number | null;
  /** Total Images Videos */
  total_images_videos?: number | null;
  /** Total Audiofiles */
  total_audiofiles?: number | null;
  /** Exsitu Species Distribution */
  exsitu_species_distribution?:
    | SpeciesDistribution
    | Record<string, any>
    | null;
  /** Insitu Species Distribution */
  insitu_species_distribution?:
    | SpeciesDistribution
    | Record<string, any>
    | null;
  /** Biodiversity Score */
  biodiversity_score?: number | null;
  /** Species Diversity */
  species_diversity?: number | null;
  /** Taxonomic Dissimilarity */
  taxonomic_dissimilarity?: number | null;
  /** Species Richness */
  species_richness?: number | null;
  /** Habitat Health */
  habitat_health?: number | null;
  /** Mean Species Abundance */
  mean_species_abundance?: number | null;
  /** Mean Ndvi */
  mean_ndvi?: number | null;
  /** Cp Land */
  cp_land?: number | null;
  /** Hdi */
  hdi?: number | null;
  /** Insitu Data */
  insitu_data?: InSituData[] | null;
  /** Insitu Species Count */
  insitu_species_count?: number | null;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
}

/** BiodiversitySiteAnalysis */
export interface BiodiversitySiteAnalysis {
  /**
   * Camera Installed
   * @default 0
   */
  camera_installed?: number | null;
  /**
   * Audio Devices
   * @default 0
   */
  audio_devices?: number | null;
  /**
   * Total Audiofiles
   * @default 0
   */
  total_audiofiles?: number | null;
  /**
   * Total Images Videos
   * @default 0
   */
  total_images_videos?: number | null;
  /** Biodiversity Score */
  biodiversity_score?: number | null;
  /** Mean Species Abundance */
  mean_species_abundance?: number | null;
  /** Species Richness */
  species_richness?: number | null;
  /** Species Diversity */
  species_diversity?: number | null;
  /** Taxonomic Dissimilarity */
  taxonomic_dissimilarity?: number | null;
  /** Habitat Health */
  habitat_health?: number | null;
  /** Mean Ndvi */
  mean_ndvi?: number | null;
  /** Cp Land */
  cp_land?: number | null;
  /** Hdi */
  hdi?: number | null;
  /** Insitu Data */
  insitu_data?: InSituData[] | null;
  /** Insitu Species Count */
  insitu_species_count?: number | null;
  /** Exsitu Species Distribution */
  exsitu_species_distribution?:
    | SpeciesDistribution
    | Record<string, any>
    | null;
  /** Insitu Species Distribution */
  insitu_species_distribution?:
    | SpeciesDistribution
    | Record<string, any>
    | null;
  /** Calculated At */
  calculated_at?: string | null;
  /**
   * Site Id
   * @format uuid
   */
  site_id: string;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
}

/** Body_add_audio_location_api_v2_sites__site_id__add_audio_location_put */
export interface BodyAddAudioLocationApiV2SitesSiteIdAddAudioLocationPut {
  /**
   * Audio Zip File
   * @format binary
   */
  audio_zip_file: File;
}

/** Body_add_camera_location_api_v2_sites__site_id__add_camera_location_put */
export interface BodyAddCameraLocationApiV2SitesSiteIdAddCameraLocationPut {
  /**
   * Camera Zip File
   * @format binary
   */
  camera_zip_file: File;
}

/** Body_upload_sites_from_file_api_v2_projects__project_id__sites_file_upload_post */
export interface BodyUploadSitesFromFileApiV2ProjectsProjectIdSitesFileUploadPost {
  /** Files */
  files: File[];
}

/** BulkSite */
export interface BulkSite {
  /** Site Name */
  site_name: string;
  /** Centroid Wkt */
  centroid_wkt: string;
  /** Boundary */
  boundary: string;
  /** Created At */
  created_at?: string | null;
}

/** CarbonProjectAnalysis */
export interface CarbonProjectAnalysis {
  /** Temperature */
  temperature?: number | null;
  /** Temperature Unit */
  temperature_unit?: string | null;
  /** Precipitation */
  precipitation?: number | null;
  /** Precipitation Unit */
  precipitation_unit?: string | null;
  /** Soil Type */
  soil_type?: string | null;
  /** Total Mean Biomass */
  total_mean_biomass?: number | null;
  /** Total Mean Biomass Unit */
  total_mean_biomass_unit?: string | null;
  /** Total Mean Carbon Stock */
  total_mean_carbon_stock?: number | null;
  /** Total Mean Carbon Stock Unit */
  total_mean_carbon_stock_unit?: string | null;
  /** Estimated Ghg Baseline Emissions */
  estimated_ghg_baseline_emissions?: number | null;
  /** Estimated Ghg Baseline Emissions Unit */
  estimated_ghg_baseline_emissions_unit?: string | null;
  /** Baseline Start Date */
  baseline_start_date?: number | null;
  /** Estimated Ghg Removals */
  estimated_ghg_removals?: Record<string, any> | null;
  /** Total Removals */
  total_removals?: number | null;
  /** Total Removals Unit */
  total_removals_unit?: string | null;
  /** Average Annual Removals */
  average_annual_removals?: number | null;
  /** Average Annual Removals Unit */
  average_annual_removals_unit?: string | null;
  /** Credits */
  credits?: Record<string, any> | null;
  /** Calculated At */
  calculated_at?: string | null;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
}

/** CarbonSequestrationCreate */
export interface CarbonSequestrationCreate {
  /** Dbh */
  dbh?: number | null;
  /** Age */
  age?: number | null;
  /** Height */
  height?: number | null;
  /** Species */
  species?: string | null;
  /** Deployment Id */
  deployment_id?: string | null;
}

/** CarbonSequestrationResponse */
export interface CarbonSequestrationResponse {
  /** Dbh */
  dbh?: number | null;
  /** Age */
  age?: number | null;
  /** Height */
  height?: number | null;
  /** Species */
  species?: string | null;
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
}

/** CarbonSiteAnalysis */
export interface CarbonSiteAnalysis {
  /** Plantation Area */
  plantation_area?: number | null;
  /** Plantation Area Unit */
  plantation_area_unit?: string | null;
  /** Planted Trees */
  planted_trees?: number | null;
  /** Lulc Timeseries */
  lulc_timeseries?: Record<string, any> | null;
  /** Lulc Transition Piechart */
  lulc_transition_piechart?: Record<string, any> | null;
  /** Surface Water Transition */
  surface_water_transition?: Record<string, any> | null;
  /** Agb */
  agb?: number | null;
  /** Agb Unit */
  agb_unit?: string | null;
  /** Mean Agb */
  mean_agb?: number | null;
  /** Mean Agb Unit */
  mean_agb_unit?: string | null;
  /** Cstock Agb */
  cstock_agb?: number | null;
  /** Cstock Agb Unit */
  cstock_agb_unit?: string | null;
  /** Mean Cstock Agb */
  mean_cstock_agb?: number | null;
  /** Mean Cstock Agb Unit */
  mean_cstock_agb_unit?: string | null;
  /** Bgb */
  bgb?: number | null;
  /** Bgb Unit */
  bgb_unit?: string | null;
  /** Mean Bgb */
  mean_bgb?: number | null;
  /** Mean Bgb Unit */
  mean_bgb_unit?: string | null;
  /** Cstock Bgb */
  cstock_bgb?: number | null;
  /** Cstock Bgb Unit */
  cstock_bgb_unit?: string | null;
  /** Mean Cstock Bgb */
  mean_cstock_bgb?: number | null;
  /** Mean Cstock Bgb Unit */
  mean_cstock_bgb_unit?: string | null;
  /** Soil Properties */
  soil_properties?: Record<string, any> | null;
  /** Soc */
  soc?: Record<string, any> | null;
  /** Agb Tif Gcs Path */
  agb_tif_gcs_path?: string | null;
  /** Calculated At */
  calculated_at?: string | null;
  /**
   * Site Id
   * @format uuid
   */
  site_id: string;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
}

/**
 * ChartRequest
 * Request schema for fetching chart data.
 */
export interface ChartRequest {
  /**
   * Deploymentids
   * List of Deployment UUIDs to fetch chart data for
   */
  deploymentIds: string[];
  /**
   * Index
   * List of acoustic indices to fetch. Options:
   * - `aci`: Acoustic Complexity Index
   * - `bi`: Bioacoustic Index
   * - `adi`: Acoustic Diversity Index
   * - `aei`: Acoustic Evenness Index
   * - `ndsi`: Normalized Difference Soundscape Index
   */
  index: AcousticIndexEnum[];
}

/**
 * ChartResponse
 * Response structure for combined chart data.
 */
export interface ChartResponse {
  /** Aggregation */
  aggregation: string;
  /** Time Slots */
  time_slots: string[];
  /** Comparison */
  comparison: AppSchemasChartDeploymentComparison[];
}

/** ChronicRisks */
export interface ChronicRisks {
  /** Risk Scenarios */
  risk_scenarios: RiskScenario[];
}

/**
 * ComputationLogEntry
 * Single tool computation entry in the status response.
 */
export interface ComputationLogEntry {
  /** Tool Slug */
  tool_slug: string;
  /** Tool Id */
  tool_id?: string | null;
  /** Status */
  status: string;
  /** Completed At */
  completed_at?: string | null;
  /** Error Message */
  error_message?: string | null;
}

/**
 * DeploymentDeviceDetailedResponse
 * Extended response with device details.
 */
export interface DeploymentDeviceDetailedResponse {
  /**
   * Deployment Device Id
   * @format uuid
   */
  deployment_device_id: string;
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /**
   * Device Id
   * @format uuid
   */
  device_id: string;
  /** Assigned By */
  assigned_by?: string | null;
  /**
   * Assigned At
   * @format date-time
   */
  assigned_at: string;
  /** Returned At */
  returned_at?: string | null;
  /** Notes */
  notes?: string | null;
  /** Reason */
  reason?: string | null;
  /** Device Name */
  device_name?: string | null;
  /** Device Asset Tag */
  device_asset_tag?: string | null;
  /** Device Condition */
  device_condition?: string | null;
  /** Device Status */
  device_status?: string | null;
  /** Device Type Id */
  device_type_id?: string | null;
}

/**
 * DeploymentDeviceHistoryResponse
 * Response containing device assignment history.
 */
export interface DeploymentDeviceHistoryResponse {
  /** Data */
  data: DeploymentDeviceDetailedResponse[];
  /** Count */
  count: number;
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
}

/**
 * DeploymentDeviceResponse
 * Response containing deployment device assignment information.
 */
export interface DeploymentDeviceResponse {
  /**
   * Deployment Device Id
   * @format uuid
   */
  deployment_device_id: string;
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /**
   * Device Id
   * @format uuid
   */
  device_id: string;
  /** Assigned By */
  assigned_by?: string | null;
  /**
   * Assigned At
   * @format date-time
   */
  assigned_at: string;
  /** Returned At */
  returned_at?: string | null;
  /** Notes */
  notes?: string | null;
  /** Reason */
  reason?: string | null;
}

/** DeploymentInfo */
export interface DeploymentInfo {
  /**
   * Is Predeployment Complete
   * @default false
   */
  is_predeployment_complete?: boolean | null;
  /** Flora Assessment */
  flora_assessment?: Record<string, any> | null;
  /** Fauna Assessment */
  fauna_assessment?: Record<string, any> | null;
  /** Human Activity */
  human_activity?: null;
  /** Habitat Condition */
  habitat_condition?: Record<string, any> | null;
  /** Photo Urls */
  photo_urls?: Record<string, any> | null;
  /**
   * Id
   * @format uuid
   */
  id: string;
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/** DeploymentInfoUpdate */
export interface DeploymentInfoUpdate {
  /**
   * Is Predeployment Complete
   * @default false
   */
  is_predeployment_complete?: boolean | null;
  /** Flora Assessment */
  flora_assessment?: Record<string, any> | null;
  /** Fauna Assessment */
  fauna_assessment?: Record<string, any> | null;
  /** Human Activity */
  human_activity?: null;
  /** Habitat Condition */
  habitat_condition?: Record<string, any> | null;
  /** Photo Urls */
  photo_urls?: Record<string, any> | null;
}

/** DeploymentQueryResult */
export interface DeploymentQueryResult {
  /** Deployments */
  deployments: AppSchemasDeploymentDeploymentAdminListDetail[];
  /** Count */
  count: number;
}

/**
 * DeveloperPermissionBulkCreate
 * Schema for bulk assigning endpoints to developer
 */
export interface DeveloperPermissionBulkCreate {
  /**
   * Endpoint Ids
   * List of endpoint IDs to assign
   */
  endpoint_ids: string[];
  /**
   * Status
   * Status for all permissions
   * @default "active"
   */
  status?: string;
}

/** DeveloperPermissionCreate */
export interface DeveloperPermissionCreate {
  /**
   * User Id
   * User ID
   * @format uuid
   */
  user_id: string;
  /**
   * Endpoint Id
   * API Endpoint ID
   * @format uuid
   */
  endpoint_id: string;
  /**
   * Status
   * Permission status: 'active' or 'inactive'
   * @default "active"
   */
  status?: string | null;
}

/**
 * DeveloperPermissionListResponse
 * Response for listing developer permissions
 */
export interface DeveloperPermissionListResponse {
  /** Permissions */
  permissions: DeveloperPermissionOut[];
  /** Count */
  count: number;
}

/** DeveloperPermissionOut */
export interface DeveloperPermissionOut {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /**
   * Endpoint Id
   * @format uuid
   */
  endpoint_id: string;
  /** Status */
  status: string;
  /**
   * Granted At
   * @format date-time
   */
  granted_at: string;
  endpoint?: APIEndpointOut | null;
}

/**
 * DeveloperPermissionToggle
 * Schema for toggling permission status
 */
export interface DeveloperPermissionToggle {
  /**
   * Status
   * New status: 'active' or 'inactive'
   */
  status: string;
}

/** DeviceAdminDetail */
export interface DeviceAdminDetail {
  /**
   * Device Id
   * @format uuid
   */
  device_id: string;
  device_type: DeviceTypeResponse;
  /** Name */
  name: string;
  /** Purchased At */
  purchased_at?: string | null;
  /** Asset Tag */
  asset_tag?: string | null;
  /** Condition */
  condition?: string | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Describes the status of a device. */
  status: DeviceStatus;
}

/** DeviceAdminDetailWithDeployment */
export interface DeviceAdminDetailWithDeployment {
  /**
   * Device Id
   * @format uuid
   */
  device_id: string;
  device_type: DeviceTypeResponse;
  /** Name */
  name: string;
  /** Purchased At */
  purchased_at?: string | null;
  /** Asset Tag */
  asset_tag?: string | null;
  /** Condition */
  condition?: string | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Describes the status of a device. */
  status: DeviceStatus;
  /** Deployment Id */
  deployment_id?: string | null;
  /** Assigned Project Id */
  assigned_project_id?: string | null;
  /** Operational Status */
  operational_status?: string | null;
}

/** DeviceCreate */
export interface DeviceCreate {
  /**
   * Device Type Id
   * @format uuid
   */
  device_type_id: string;
  /** Name */
  name: string;
  /** Purchased At */
  purchased_at?: string | null;
  /** @default "ACTIVE" */
  status?: DeviceStatus | null;
  /**
   * Condition
   * @default "NORMAL"
   */
  condition?: string | null;
}

/** DeviceCustodyCheckOut */
export interface DeviceCustodyCheckOut {
  /**
   * Device Id
   * @format uuid
   */
  device_id: string;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /** Notes */
  notes?: string | null;
}

/** DeviceCustodyHistory */
export interface DeviceCustodyHistory {
  /** Data */
  data: DeviceCustodyResponse[];
  /** Count */
  count: number;
}

/** DeviceCustodyResponse */
export interface DeviceCustodyResponse {
  /**
   * Custody Id
   * @format uuid
   */
  custody_id: string;
  /**
   * Device Id
   * @format uuid
   */
  device_id: string;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /** Assigned By */
  assigned_by?: string | null;
  /**
   * Assigned At
   * @format date-time
   */
  assigned_at: string;
  /** Returned At */
  returned_at?: string | null;
  /** Notes */
  notes?: string | null;
  device?: DeviceAdminDetail | null;
}

/** DeviceTypeResponse */
export interface DeviceTypeResponse {
  /** Name */
  name: string;
  /** Category */
  category: string;
  /** Prefix */
  prefix: string;
  /** Description */
  description?: string | null;
  /**
   * Is Active
   * @default true
   */
  is_active?: boolean;
  /**
   * Device Type Id
   * @format uuid
   */
  device_type_id: string;
}

/** DeviceUpdate */
export interface DeviceUpdate {
  /** Device Type Id */
  device_type_id?: string | null;
  /** Name */
  name?: string | null;
  /** Purchased At */
  purchased_at?: string | null;
  status?: DeviceStatus | null;
  /** Condition */
  condition?: string | null;
}

/** DroughtMetrics */
export interface DroughtMetrics {
  /** Days>1.0Spei */
  "days>1.0SPEI"?: number | null;
  /** Days>1.5Spei */
  "days>1.5SPEI"?: number | null;
  /** Days>2.0Spei */
  "days>2.0SPEI"?: number | null;
  /** Absolute Loss Days */
  absolute_loss_days?: number | null;
  /** Additional Loss Days */
  additional_loss_days?: number | null;
  /** Asset Damage Var Percent */
  asset_damage_var_percent?: number | null;
  /** Productivity Var Percent */
  productivity_var_percent?: number | null;
  /** Risk Category */
  risk_category?: string | null;
  /** Risk Increase Percent */
  risk_increase_percent?: number | null;
}

/** EnvironmentalProjectAnalysis */
export interface EnvironmentalProjectAnalysis {
  /** Overall Risk Score */
  overall_risk_score?: number | null;
  /** Overall Risk Category */
  overall_risk_category?: string | null;
  /** Value At Risk */
  value_at_risk?: number | null;
  chronic_risks?: ChronicRisks | null;
  /** Acute Risks */
  acute_risks?: null;
  /** Calculated At */
  calculated_at?: string | null;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
}

/** EnvironmentalSiteAnalysis */
export interface EnvironmentalSiteAnalysis {
  /** Site Risk Score */
  site_risk_score?: number | null;
  /** Site Risk Category */
  site_risk_category?: string | null;
  /** Site Value At Risk */
  site_value_at_risk?: number | null;
  chronic_risks?: ChronicRisks | null;
  /** Acute Risks */
  acute_risks?: null;
  /** Calculated At */
  calculated_at?: string | null;
  /**
   * Site Id
   * @format uuid
   */
  site_id: string;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
}

/** FileAdminDetail */
export interface FileAdminDetail {
  /**
   * File Id
   * @format uuid
   */
  file_id: string;
  /** Name */
  name: string;
  /** Url */
  url: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /**
   * Uploaded By
   * @format uuid
   */
  uploaded_by: string;
  /** Status */
  status: string;
  /** File Type */
  file_type: string;
}

/** FileAdminDetailWithLocation */
export interface FileAdminDetailWithLocation {
  /**
   * File Id
   * @format uuid
   */
  file_id: string;
  /** Name */
  name: string;
  /** Url */
  url: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /**
   * Uploaded By
   * @format uuid
   */
  uploaded_by: string;
  /** Status */
  status: string;
  location: LocationAdminDetail;
}

/** FileAdminDetailWithUser */
export interface FileAdminDetailWithUser {
  /**
   * File Id
   * @format uuid
   */
  file_id: string;
  /** Name */
  name: string;
  /** Url */
  url: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /**
   * Uploaded By
   * @format uuid
   */
  uploaded_by: string;
  /** Status */
  status: string;
  uploaded_by_user: User;
  /**
   * Inferences
   * @default []
   */
  inferences?: Inference[];
}

/** FileDetail */
export interface FileDetail {
  file: FileAdminDetail;
  inference: Inference;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /** Project Name */
  project_name: string;
  /**
   * Site Id
   * @format uuid
   */
  site_id: string;
  /** Site Name */
  site_name: string;
  /**
   * Location Id
   * @format uuid
   */
  location_id: string;
  /** Location Name */
  location_name: string;
}

/** FileDetailList */
export interface FileDetailList {
  /** Total */
  total: number;
  /** Data */
  data: FileDetail[];
}

/** FileDownloadResponse */
export interface FileDownloadResponse {
  /** Download Url */
  download_url: string;
}

/** FileFinalizeRequest */
export interface FileFinalizeRequest {
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /** Gcs Path */
  gcs_path: string;
  /** File Name */
  file_name: string;
}

/** FileUploadRequest */
export interface FileUploadRequest {
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /** File Name */
  file_name: string;
  /** Content Type */
  content_type: string;
}

/** FileUploadResponse */
export interface FileUploadResponse {
  /** Upload Url */
  upload_url: string;
  /** Gcs Path */
  gcs_path: string;
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/** HeatMetrics */
export interface HeatMetrics {
  /** Days>20C */
  "days>20C"?: number | null;
  /** Days>25C */
  "days>25C"?: number | null;
  /** Days>30C */
  "days>30C"?: number | null;
  /** Days>35C */
  "days>35C"?: number | null;
  /** Absolute Loss Days */
  absolute_loss_days?: number | null;
  /** Additional Loss Days */
  additional_loss_days?: number | null;
  /** Asset Damage Var Percent */
  asset_damage_var_percent?: number | null;
  /** Productivity Var Percent */
  productivity_var_percent?: number | null;
  /** Risk Category */
  risk_category?: string | null;
  /** Risk Increase Percent */
  risk_increase_percent?: number | null;
}

/** HighValueClip */
export interface HighValueClip {
  /**
   * Common Name
   * @default "Unknown"
   */
  common_name?: string | null;
  /**
   * Scientific Name
   * @default "Unknown"
   */
  scientific_name?: string | null;
  /** Date */
  date?: string | null;
  /** Time */
  time?: string | null;
  /** Confidence */
  confidence?: number | null;
  /** Url */
  url?: string | null;
  /** File Name */
  file_name?: string | null;
  /** Seq */
  seq?: number | null;
}

/** InSituData */
export interface InSituData {
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /**
   * Site Id
   * @format uuid
   */
  site_id: string;
  /** Acoustic Data */
  acoustic_data?: Record<string, any> | null;
  /** Activity Trend Data */
  activity_trend_data?: Record<string, any> | null;
  /** Species Count */
  species_count?: number | null;
  /** Unique Species */
  unique_species?: string[] | null;
}

/** Inference */
export interface Inference {
  /**
   * File Id
   * @format uuid
   */
  file_id: string;
  /** Data */
  data?: Record<string, any> | null;
  /** Acoustic Indices */
  acoustic_indices?: Record<string, any> | null;
  /** Spectrogram Url */
  spectrogram_url?: string | null;
  /** High Value Clip Audios */
  high_value_clip_audios?: Record<string, any>[] | null;
  /**
   * Inference Id
   * @format uuid
   */
  inference_id: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/** InferenceUpdate */
export interface InferenceUpdate {
  /** Data */
  data?: Record<string, any> | null;
  /** High Value Clip Audios */
  high_value_clip_audios?: Record<string, any>[] | null;
}

/** LocationAdminDetail */
export interface LocationAdminDetail {
  /**
   * Location Id
   * @format uuid
   */
  location_id: string;
  /** Location Name */
  location_name: string;
  /** Location */
  location: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Site Id
   * @format uuid
   */
  site_id: string;
  /**
   * Created By
   * @format uuid
   */
  created_by: string;
}

/** LocationCreate */
export interface LocationCreate {
  /**
   * Site Id
   * @format uuid
   */
  site_id: string;
  /** Location Name */
  location_name: string;
  /** Location */
  location: string;
}

/** LocationUpdate */
export interface LocationUpdate {
  /** Location Name */
  location_name?: string | null;
  /** Location */
  location?: string | null;
}

/** LoginRequest */
export interface LoginRequest {
  /**
   * Email
   * @format email
   */
  email: string;
  /** Password */
  password: string;
}

/** MapMarker */
export interface MapMarker {
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /**
   * Location Id
   * @format uuid
   */
  location_id: string;
  /** Latitude */
  latitude: number;
  /** Longitude */
  longitude: number;
  /** Deployment Name */
  deployment_name: string;
  /** Status */
  status?: string | null;
  /** Device Type */
  device_type?: string | null;
  /** Site Id */
  site_id?: string | null;
  /** Site Name */
  site_name?: string | null;
}

/** NotificationCheckResult */
export interface NotificationCheckResult {
  /** Deployments Checked */
  deployments_checked: number;
  /** Notifications Sent */
  notifications_sent: number;
  /**
   * Errors
   * @default []
   */
  errors?: string[];
}

/** OrgMemberAdd */
export interface OrgMemberAdd {
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /** Role */
  role: string;
}

/** OrgMemberList */
export interface OrgMemberList {
  /** Data */
  data: OrgMemberResponse[];
  /** Count */
  count: number;
}

/** OrgMemberResponse */
export interface OrgMemberResponse {
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /**
   * Org Id
   * @format uuid
   */
  org_id: string;
  /** Role */
  role: string;
  /**
   * Org Member Id
   * @format uuid
   */
  org_member_id: string;
  /** Status */
  status: string;
  /**
   * Joined At
   * @format date-time
   */
  joined_at: string;
  user?: UserResponse | null;
}

/** OrgMemberRoleUpdate */
export interface OrgMemberRoleUpdate {
  /** Role */
  role: string;
}

/** OrganisationCreate */
export interface OrganisationCreate {
  /** Name */
  name: string;
  /** Domain */
  domain?: string | null;
  /**
   * Status
   * @default "active"
   */
  status?: string;
}

/** OrganisationList */
export interface OrganisationList {
  /** Data */
  data: OrganisationResponse[];
  /** Count */
  count: number;
}

/** OrganisationResponse */
export interface OrganisationResponse {
  /** Name */
  name: string;
  /** Domain */
  domain?: string | null;
  /**
   * Status
   * @default "active"
   */
  status?: string;
  /**
   * Org Id
   * @format uuid
   */
  org_id: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/** OrganisationToolList */
export interface OrganisationToolList {
  /** Data */
  data: OrganisationToolResponse[];
  /** Count */
  count: number;
}

/** OrganisationToolProvision */
export interface OrganisationToolProvision {
  /**
   * Org Id
   * @format uuid
   */
  org_id: string;
  /**
   * Tool Id
   * @format uuid
   */
  tool_id: string;
  /** Config */
  config?: Record<string, any> | null;
}

/** OrganisationToolResponse */
export interface OrganisationToolResponse {
  /**
   * Org Tool Id
   * @format uuid
   */
  org_tool_id: string;
  /**
   * Org Id
   * @format uuid
   */
  org_id: string;
  /**
   * Tool Id
   * @format uuid
   */
  tool_id: string;
  /** Status */
  status: string;
  /** Config */
  config?: Record<string, any> | null;
  /**
   * Provisioned At
   * @format date-time
   */
  provisioned_at: string;
  /**
   * Provisioned By
   * @format uuid
   */
  provisioned_by: string;
  tool?: ToolResponse | null;
}

/** OrganisationToolUpdate */
export interface OrganisationToolUpdate {
  /** Status */
  status?: string | null;
  /** Config */
  config?: Record<string, any> | null;
}

/** OrganisationUpdate */
export interface OrganisationUpdate {
  /** Name */
  name?: string | null;
  /** Domain */
  domain?: string | null;
  /** Status */
  status?: string | null;
}

/** PluvialFloodMetrics */
export interface PluvialFloodMetrics {
  /** Max 1Day Ppt Mm */
  max_1day_ppt_mm?: number | null;
  /** Pluvial Flood Depth M */
  pluvial_flood_depth_m?: number | null;
  /** Absolute Loss Days */
  absolute_loss_days?: number | null;
  /** Additional Loss Days */
  additional_loss_days?: number | null;
  /** Asset Damage Var Percent */
  asset_damage_var_percent?: number | null;
  /** Productivity Var Percent */
  productivity_var_percent?: number | null;
  /** Risk Category */
  risk_category?: string | null;
  /** Risk Increase Percent */
  risk_increase_percent?: number | null;
}

/** PredeploymentStatusUpdate */
export interface PredeploymentStatusUpdate {
  /** Is Predeployment Complete */
  is_predeployment_complete: boolean;
}

/** Project */
export interface Project {
  /**
   * Project Name
   * @example "Mangrove Plantation Initiative"
   */
  project_name: string;
  /** Project Start Date */
  project_start_date?: string | null;
  /** Project End Date */
  project_end_date?: string | null;
  /**
   * Country
   * @example "India"
   */
  country?: string | null;
  /**
   * Project Description
   * @example "Restoring mangrove forests..."
   */
  project_description?: string | null;
  /** Project Type */
  project_type?: string | null;
  /**
   * Total Area
   * @example 160.55
   */
  total_area?: number | null;
  /**
   * Area Unit
   * @default "ha"
   * @example "ha"
   */
  area_unit?: string | null;
  /**
   * Project Developer
   * @example "South Asian Forum of Environment"
   */
  project_developer?: string | null;
  /**
   * Crediting Period
   * @example "20 years"
   */
  crediting_period?: string | null;
  /**
   * Registry
   * @example "Verra"
   */
  registry?: string | null;
  /**
   * Sdg
   * @example ["sdg13.png","sdg15.png"]
   */
  sdg?: string[] | null;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /** Org Id */
  org_id?: string | null;
  /**
   * Owner User Id
   * @format uuid
   */
  owner_user_id: string;
  project_status: ProjectStatusEnum;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Site Count
   * @default 0
   */
  site_count?: number;
  /** Active Tools */
  active_tools?: string[] | null;
}

/** ProjectAdminDetail */
export interface ProjectAdminDetail {
  /**
   * Project Name
   * @example "Mangrove Plantation Initiative"
   */
  project_name: string;
  /** Project Start Date */
  project_start_date?: string | null;
  /** Project End Date */
  project_end_date?: string | null;
  /**
   * Country
   * @example "India"
   */
  country?: string | null;
  /**
   * Project Description
   * @example "Restoring mangrove forests..."
   */
  project_description?: string | null;
  /** Project Type */
  project_type?: string | null;
  /**
   * Total Area
   * @example 160.55
   */
  total_area?: number | null;
  /**
   * Area Unit
   * @default "ha"
   * @example "ha"
   */
  area_unit?: string | null;
  /**
   * Project Developer
   * @example "South Asian Forum of Environment"
   */
  project_developer?: string | null;
  /**
   * Crediting Period
   * @example "20 years"
   */
  crediting_period?: string | null;
  /**
   * Registry
   * @example "Verra"
   */
  registry?: string | null;
  /**
   * Sdg
   * @example ["sdg13.png","sdg15.png"]
   */
  sdg?: string[] | null;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /** Org Id */
  org_id?: string | null;
  /**
   * Owner User Id
   * @format uuid
   */
  owner_user_id: string;
  project_status: ProjectStatusEnum;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Site Count
   * @default 0
   */
  site_count?: number;
  /** Active Tools */
  active_tools?: string[] | null;
  created_by: UserBase;
  /**
   * Sites
   * @default []
   */
  sites?: SiteResponse[];
}

/**
 * ProjectAdminSummary
 * Schema for summarizing project details for admin view.
 * Includes basic project information, owner, and assignment details.
 */
export interface ProjectAdminSummary {
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /** Project Name */
  project_name: string;
  /** Country */
  country?: string | null;
  /** Project Developer */
  project_developer?: string | null;
  /** Project Type */
  project_type?: string | null;
  project_status?: ProjectStatusEnum | null;
  /** Project Start Date */
  project_start_date?: string | null;
  /** Project End Date */
  project_end_date?: string | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  created_by: UserBase;
  assignment?: Assignment | null;
  /** Org Id */
  org_id?: string | null;
  organisation?: OrganisationResponse | null;
  /**
   * Sites Count
   * @default 0
   */
  sites_count?: number | null;
}

/** ProjectCreate */
export interface ProjectCreate {
  /**
   * Project Name
   * @example "Mangrove Plantation Initiative"
   */
  project_name: string;
  /** Project Start Date */
  project_start_date?: string | null;
  /** Project End Date */
  project_end_date?: string | null;
  /**
   * Country
   * @example "India"
   */
  country?: string | null;
  /**
   * Project Description
   * @example "Restoring mangrove forests..."
   */
  project_description?: string | null;
  /** @example "Agroforestry" */
  project_type?: ProjectType | null;
  /**
   * Total Area
   * @example 160.55
   */
  total_area?: number | null;
  /**
   * Area Unit
   * @default "ha"
   * @example "ha"
   */
  area_unit?: string | null;
  /**
   * Project Developer
   * @example "South Asian Forum of Environment"
   */
  project_developer?: string | null;
  /**
   * Crediting Period
   * @example "20 years"
   */
  crediting_period?: string | null;
  /**
   * Registry
   * @example "Verra"
   */
  registry?: string | null;
  /**
   * Sdg
   * @example ["sdg13.png","sdg15.png"]
   */
  sdg?: string[] | null;
}

/** ProjectMapData */
export interface ProjectMapData {
  /** Sites */
  sites: SiteResponse[];
  /** Locations */
  locations: LocationAdminDetail[];
  /** Deployments */
  deployments: AppSchemasDeploymentDeploymentAdminDetailBase[];
  /** Devices */
  devices: DeviceAdminDetail[];
}

/**
 * ProjectMedia
 * Schema for returning project media to the client, includes uploader details.
 */
export interface ProjectMedia {
  /**
   * File Name
   * @example "site_photo_1.jpg"
   */
  file_name: string;
  /** Describes the type of media file. */
  media_type: MediaType;
  /**
   * Caption
   * @example "Photo of the site from the north."
   */
  caption?: string | null;
  /**
   * Media Id
   * @format uuid
   */
  media_id: string;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /**
   * Uploaded By User Id
   * @format uuid
   */
  uploaded_by_user_id: string;
  /** Gcs Path */
  gcs_path: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  uploaded_by: User;
}

/**
 * ProjectMediaDownloadResponse
 * Response schema for a generated media download URL.
 */
export interface ProjectMediaDownloadResponse {
  /** Download Url */
  download_url: string;
}

/**
 * ProjectMediaFinalizeRequest
 * Request schema for finalizing a media upload.
 */
export interface ProjectMediaFinalizeRequest {
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /** File Name */
  file_name: string;
  /** Gcs Path */
  gcs_path: string;
  /** Describes the type of media file. */
  media_type: MediaType;
  /** Caption */
  caption?: string | null;
}

/**
 * ProjectMediaUpdate
 * Schema for updating a project media record, only caption is updatable.
 */
export interface ProjectMediaUpdate {
  /**
   * Caption
   * @example "A new caption for the media."
   */
  caption?: string | null;
}

/**
 * ProjectMediaUploadRequest
 * Request schema for generating a media upload URL.
 */
export interface ProjectMediaUploadRequest {
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /** File Name */
  file_name: string;
  /** Content Type */
  content_type: string;
  /** Describes the type of media file. */
  media_type: MediaType;
}

/**
 * ProjectMediaUploadResponse
 * Response schema for a generated media upload URL.
 */
export interface ProjectMediaUploadResponse {
  /** Upload Url */
  upload_url: string;
  /** Gcs Path */
  gcs_path: string;
}

/** ProjectResponse */
export interface ProjectResponse {
  /**
   * Project Name
   * @example "Mangrove Plantation Initiative"
   */
  project_name: string;
  /** Project Start Date */
  project_start_date?: string | null;
  /** Project End Date */
  project_end_date?: string | null;
  /**
   * Country
   * @example "India"
   */
  country?: string | null;
  /**
   * Project Description
   * @example "Restoring mangrove forests..."
   */
  project_description?: string | null;
  /** Project Type */
  project_type?: string | null;
  /**
   * Total Area
   * @example 160.55
   */
  total_area?: number | null;
  /**
   * Area Unit
   * @default "ha"
   * @example "ha"
   */
  area_unit?: string | null;
  /**
   * Project Developer
   * @example "South Asian Forum of Environment"
   */
  project_developer?: string | null;
  /**
   * Crediting Period
   * @example "20 years"
   */
  crediting_period?: string | null;
  /**
   * Registry
   * @example "Verra"
   */
  registry?: string | null;
  /**
   * Sdg
   * @example ["sdg13.png","sdg15.png"]
   */
  sdg?: string[] | null;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /** Org Id */
  org_id?: string | null;
  /**
   * Owner User Id
   * @format uuid
   */
  owner_user_id: string;
  project_status: ProjectStatusEnum;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Site Count
   * @default 0
   */
  site_count?: number;
  /** Active Tools */
  active_tools?: string[] | null;
}

/** ProjectSessionCreate */
export interface ProjectSessionCreate {
  /**
   * Session Name
   * @example "March 2024 Monitoring Cycle"
   */
  session_name: string;
  /**
   * Session Start Date
   * @format date
   */
  session_start_date: string;
  /** Session End Date */
  session_end_date?: string | null;
  /**
   * Describes the status of a project monitoring session.
   * @default "upcoming"
   */
  status?: SessionStatus;
}

/** ProjectSessionList */
export interface ProjectSessionList {
  /** Data */
  data: ProjectSessionResponse[];
  /** Count */
  count: number;
}

/** ProjectSessionResponse */
export interface ProjectSessionResponse {
  /**
   * Session Id
   * @format uuid
   */
  session_id: string;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /** Session Name */
  session_name: string;
  /**
   * Session Start Date
   * @format date
   */
  session_start_date: string;
  /** Session End Date */
  session_end_date?: string | null;
  /** Describes the status of a project monitoring session. */
  status: SessionStatus;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/** ProjectSessionUpdate */
export interface ProjectSessionUpdate {
  /** Session Name */
  session_name?: string | null;
  /** Session Start Date */
  session_start_date?: string | null;
  /** Session End Date */
  session_end_date?: string | null;
  status?: SessionStatus | null;
}

/** ProjectToolEnable */
export interface ProjectToolEnable {
  /**
   * Tool Id
   * @format uuid
   */
  tool_id: string;
}

/** ProjectToolList */
export interface ProjectToolList {
  /** Data */
  data: ProjectToolResponse[];
  /** Count */
  count: number;
}

/** ProjectToolResponse */
export interface ProjectToolResponse {
  /**
   * Project Tool Id
   * @format uuid
   */
  project_tool_id: string;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /**
   * Tool Id
   * @format uuid
   */
  tool_id: string;
  /**
   * Enabled At
   * @format date-time
   */
  enabled_at: string;
  /**
   * Enabled By
   * @format uuid
   */
  enabled_by: string;
  tool?: ToolResponse | null;
}

/** ProjectUpdate */
export interface ProjectUpdate {
  /** Project Name */
  project_name?: string | null;
  /** Project Start Date */
  project_start_date?: string | null;
  /** Project End Date */
  project_end_date?: string | null;
  /** Country */
  country?: string | null;
  /** Project Description */
  project_description?: string | null;
  /** Project Type */
  project_type?: string | null;
  /** Total Area */
  total_area?: number | null;
  /** Area Unit */
  area_unit?: string | null;
  /** Project Developer */
  project_developer?: string | null;
  /** Crediting Period */
  crediting_period?: string | null;
  /** Registry */
  registry?: string | null;
  /** Sdg */
  sdg?: string[] | null;
  /** Org Id */
  org_id?: string | null;
}

/**
 * ReplaceDeviceRequest
 * Request to replace the currently assigned device.
 */
export interface ReplaceDeviceRequest {
  /**
   * New Device Id
   * @format uuid
   */
  new_device_id: string;
  /**
   * Assigned By
   * @format uuid
   */
  assigned_by: string;
  /** Notes */
  notes?: string | null;
}

/**
 * ReportDeviceIssueRequest
 * Request to report a device issue (damaged or missing).
 */
export interface ReportDeviceIssueRequest {
  /** Replacement Device Id */
  replacement_device_id?: string | null;
  /** Notes */
  notes?: string | null;
}

/** RequestPasswordResetRequest */
export interface RequestPasswordResetRequest {
  /**
   * Email
   * @format email
   */
  email: string;
}

/** ResetPasswordRequest */
export interface ResetPasswordRequest {
  /** Token */
  token: string;
  /** New Password */
  new_password: string;
}

/** RetrievalInfo */
export interface RetrievalInfo {
  /** Flora Assessment */
  flora_assessment?: Record<string, any> | null;
  /** Fauna Assessment */
  fauna_assessment?: Record<string, any> | null;
  /** Human Activity */
  human_activity?: null;
  /** Photo Urls */
  photo_urls?: Record<string, any> | null;
  /** Device Condition */
  device_condition?: null;
  /**
   * Id
   * @format uuid
   */
  id: string;
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/** RetrievalInfoUpdate */
export interface RetrievalInfoUpdate {
  /** Flora Assessment */
  flora_assessment?: Record<string, any> | null;
  /** Fauna Assessment */
  fauna_assessment?: Record<string, any> | null;
  /** Human Activity */
  human_activity?: null;
  /** Photo Urls */
  photo_urls?: Record<string, any> | null;
  /** Device Condition */
  device_condition?: null;
}

/**
 * RetrieveDeviceRequest
 * Request to retrieve (return) a device from a deployment.
 */
export interface RetrieveDeviceRequest {
  /** Notes */
  notes?: string | null;
}

/** RiskScenario */
export interface RiskScenario {
  /** Scenario */
  scenario: string;
  /** Years */
  years: Record<string, YearData>;
}

/** SectorHazards */
export interface SectorHazards {
  heat?: HeatMetrics | null;
  drought?: DroughtMetrics | null;
  pluvial_flood_rain?: PluvialFloodMetrics | null;
}

/** ShowcaseCandidate */
export interface ShowcaseCandidate {
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /** Deployment Name */
  deployment_name: string;
  /** Source */
  source: string;
  /** Photo Key */
  photo_key: string;
  /** Gcs Path */
  gcs_path: string;
  /** View Url */
  view_url: string;
  /** Is Showcased */
  is_showcased: boolean;
}

/** ShowcaseCandidatesResponse */
export interface ShowcaseCandidatesResponse {
  /** Candidates */
  candidates: ShowcaseCandidate[];
  /** Count */
  count: number;
}

/** ShowcaseDeselectionRequest */
export interface ShowcaseDeselectionRequest {
  /** Gcs Paths */
  gcs_paths: string[];
}

/** ShowcaseSelectionItem */
export interface ShowcaseSelectionItem {
  /** Gcs Path */
  gcs_path: string;
  /** File Name */
  file_name?: string | null;
  /** Caption */
  caption?: string | null;
}

/** ShowcaseSelectionRequest */
export interface ShowcaseSelectionRequest {
  /** Photos */
  photos: ShowcaseSelectionItem[];
}

/** SiteAdminDetail */
export interface SiteAdminDetail {
  /**
   * Site Name
   * @example "Tipligheri"
   */
  site_name: string;
  /** Area */
  area?: number | null;
  /**
   * Site Id
   * @format uuid
   */
  site_id: string;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /** Shapefile Gcs Path */
  shapefile_gcs_path?: string | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Boundary */
  boundary?: string | null;
  /** Centroid Wkt */
  centroid_wkt?: string | null;
  /**
   * Boundary Status
   * @default "completed"
   */
  boundary_status?: string;
  /** Boundary Error */
  boundary_error?: string | null;
  /** Polygon Count */
  polygon_count?: number | null;
  /** Satellite Imagery */
  satellite_imagery: null;
  /**
   * Locations
   * @default []
   */
  locations?: LocationAdminDetail[];
}

/** SiteCreate */
export interface SiteCreate {
  /**
   * Site Name
   * @example "Tipligheri"
   */
  site_name: string;
  /** Shapefile Data */
  shapefile_data?: File | string | null;
  /** Shapefile Gcs Path */
  shapefile_gcs_path?: string | null;
  /** Area */
  area?: number | null;
  /** Boundary */
  boundary?: string | null;
  /** Centroid Wkt */
  centroid_wkt?: string | null;
}

/** SiteHydrationResponse */
export interface SiteHydrationResponse {
  /**
   * Site Id
   * @format uuid
   */
  site_id: string;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /**
   * Boundary
   * Dissolved site boundary as GeoJSON geometry (EPSG:4326).
   */
  boundary: Record<string, any>;
  /**
   * Area
   * Total area in hectares of the dissolved boundary.
   */
  area?: number | null;
  /**
   * Polygon Count
   * Number of original polygon features before dissolve.
   */
  polygon_count?: number | null;
  /**
   * Project Type
   * Free text, e.g. 'Agroforestry' | 'Conservation' | etc. Not a strict enum -- consumers should handle unrecognized values gracefully rather than assuming only these two exist.
   */
  project_type: string;
  /**
   * Enabled Tools
   * Tool slugs currently active for this project, resolved live from project_tools/tools at request time -- not a cached or event-driven value. Mirrors how site_processed publishing itself resolves active tools (see _get_active_tools in site_upload.py): no tool_enabled/tool_disabled events exist in this system; enablement is always read fresh.
   */
  enabled_tools: string[];
}

/** SiteResponse */
export interface SiteResponse {
  /**
   * Site Name
   * @example "Tipligheri"
   */
  site_name: string;
  /** Area */
  area?: number | null;
  /**
   * Site Id
   * @format uuid
   */
  site_id: string;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /** Shapefile Gcs Path */
  shapefile_gcs_path?: string | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Boundary */
  boundary?: string | null;
  /** Centroid Wkt */
  centroid_wkt?: string | null;
  /**
   * Boundary Status
   * @default "completed"
   */
  boundary_status?: string;
  /** Boundary Error */
  boundary_error?: string | null;
  /** Polygon Count */
  polygon_count?: number | null;
  /** Satellite Imagery */
  satellite_imagery: null;
}

/**
 * SiteSatelliteImagery
 * Schema for returning satellite imagery for a site.
 */
export interface SiteSatelliteImagery {
  /**
   * Site Id
   * @format uuid
   */
  site_id: string;
  /** Satellite Imagery */
  satellite_imagery?: null;
}

/**
 * SiteStatusResponse
 * Full status snapshot for a site.
 * Frontend polls GET /projects/{id}/sites/{id}/status every 5 seconds.
 *
 * boundary_status:
 *   pending    → site row created, file uploaded to GCS, CF not called yet
 *   processing → boundary CF is running geoprocessing
 *   completed  → geometry saved to DB, site_processed event published
 *   failed     → CF failed, boundary_error has the reason
 *
 * tools[]:
 *   One entry per active project tool, pre-created as pending when
 *   site_processed is published. Status moves to completed or failed
 *   as metrics_computed events arrive from tool microservices.
 *   Empty list = no tools active for this project (not an error).
 *
 * Frontend behaviour:
 *   Show boundary loading overlay while boundary_status != completed.
 *   Show tool status cards from tools[] immediately (pending state visible).
 *   Stop polling when boundary_status = completed and all tool statuses
 *   are completed or failed.
 */
export interface SiteStatusResponse {
  /**
   * Site Id
   * @format uuid
   */
  site_id: string;
  /** Boundary Status */
  boundary_status: string;
  /** Boundary Error */
  boundary_error?: string | null;
  /**
   * Tools
   * @default []
   */
  tools?: ComputationLogEntry[];
}

/** SiteUpdate */
export interface SiteUpdate {
  /** Site Name */
  site_name?: string | null;
  /** Area */
  area?: number | null;
  /** Shapefile Data */
  shapefile_data?: File | null;
  /** Shapefile Gcs Path */
  shapefile_gcs_path?: string | null;
}

/** SpeciesDistribution */
export interface SpeciesDistribution {
  /** Critically Endangered */
  critically_endangered?: SpeciesDistributionDetail[];
  /** Endangered */
  endangered?: SpeciesDistributionDetail[];
  /** Vulnerable */
  vulnerable?: SpeciesDistributionDetail[];
  /** Near Threatened */
  near_threatened?: SpeciesDistributionDetail[];
  /** Least Concerned */
  least_concerned?: SpeciesDistributionDetail[];
  /** Unknown */
  unknown?: SpeciesDistributionDetail[];
}

/** SpeciesDistributionDetail */
export interface SpeciesDistributionDetail {
  /** Total */
  total: number;
  /** Species List */
  species_list?: string[];
}

/** SupportTicket */
export interface SupportTicket {
  /**
   * Ticket Id
   * @format uuid
   */
  ticket_id: string;
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /** User Email */
  user_email: string;
  /** User Name */
  user_name?: string | null;
  /** Subject */
  subject: string;
  /** Message */
  message: string;
  /** Category */
  category: string;
  /** Status */
  status: string;
  /** Priority */
  priority: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Updated At */
  updated_at: string | null;
}

/** SupportTicketCreate */
export interface SupportTicketCreate {
  /**
   * Subject
   * @minLength 5
   * @maxLength 200
   * @example "Need help with project creation"
   */
  subject: string;
  /**
   * Message
   * @minLength 10
   * @maxLength 5000
   * @example "I'm having trouble creating a new project..."
   */
  message: string;
  /** @example "Technical" */
  category: TicketCategory;
  /**
   * @default "Medium"
   * @example "Medium"
   */
  priority?: TicketPriority | null;
}

/** SupportTicketList */
export interface SupportTicketList {
  /** Tickets */
  tickets: SupportTicket[];
  /** Total */
  total: number;
  /** Skip */
  skip: number;
  /** Limit */
  limit: number;
}

/** SupportTicketUpdate */
export interface SupportTicketUpdate {
  status?: TicketStatus | null;
  priority?: TicketPriority | null;
}

/** Token */
export interface Token {
  /** Access Token */
  access_token: string;
  /** Refresh Token */
  refresh_token?: string | null;
  /**
   * First Name
   * @default ""
   */
  first_name?: string;
  /**
   * Last Name
   * @default ""
   */
  last_name?: string;
  /**
   * Email
   * @format email
   */
  email: string;
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /** Role */
  role: UserRole[];
  status: UserStatus;
  /** Is Email Verified */
  is_email_verified: boolean;
}

/** ToolCreate */
export interface ToolCreate {
  /** Slug */
  slug: string;
  /** Name */
  name: string;
  /** Description */
  description?: string | null;
  /** Module */
  module: string[];
  /**
   * Is Active
   * @default true
   */
  is_active?: boolean;
  /** Trial Limit */
  trial_limit?: number | null;
}

/** ToolList */
export interface ToolList {
  /** Data */
  data: ToolResponse[];
  /** Count */
  count: number;
}

/** ToolResponse */
export interface ToolResponse {
  /** Slug */
  slug: string;
  /** Name */
  name: string;
  /** Description */
  description?: string | null;
  /** Module */
  module: string[];
  /**
   * Is Active
   * @default true
   */
  is_active?: boolean;
  /** Trial Limit */
  trial_limit?: number | null;
  /**
   * Tool Id
   * @format uuid
   */
  tool_id: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
}

/** ToolUpdate */
export interface ToolUpdate {
  /** Slug */
  slug?: string | null;
  /** Name */
  name?: string | null;
  /** Description */
  description?: string | null;
  /** Module */
  module?: string[] | null;
  /** Is Active */
  is_active?: boolean | null;
  /** Trial Limit */
  trial_limit?: number | null;
}

/** User */
export interface User {
  /**
   * Email
   * @format email
   * @example "user@example.com"
   */
  email: string;
  /**
   * First Name
   * @default ""
   * @example "John Doe"
   */
  first_name?: string;
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/** UserBase */
export interface UserBase {
  /**
   * Email
   * @format email
   * @example "user@example.com"
   */
  email: string;
  /**
   * First Name
   * @default ""
   * @example "John Doe"
   */
  first_name?: string;
}

/** UserCreate */
export interface UserCreate {
  /**
   * Email
   * @format email
   */
  email: string;
  /**
   * First Name
   * @default ""
   * @example "John Doe"
   */
  first_name?: string;
  /** Last Name */
  last_name: string;
  /** Password */
  password: string;
  /**
   * Tnc Checked
   * Terms and Conditions must be accepted
   * @example true
   */
  tnc_checked: boolean;
}

/**
 * UserCreateResponse
 * Response schema for user creation with API key
 */
export interface UserCreateResponse {
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /**
   * Email
   * @format email
   */
  email: string;
  /**
   * First Name
   * @default ""
   */
  first_name?: string;
  /** Last Name */
  last_name?: string | null;
  /** Role */
  role?: string[] | null;
  /** Status */
  status?: string | null;
  /** Is Email Verified */
  is_email_verified?: boolean | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Api Key */
  api_key?: string | null;
  /** Key Prefix */
  key_prefix?: string | null;
  /** Api Key Id */
  api_key_id?: string | null;
  /** Api Key Expires At */
  api_key_expires_at?: string | null;
  /** Message */
  message: string;
}

/** UserDevice */
export interface UserDevice {
  /** Expo Push Token */
  expo_push_token: string;
  /** Platform */
  platform?: string | null;
  /**
   * Device Id
   * @format uuid
   */
  device_id: string;
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/** UserDeviceCreate */
export interface UserDeviceCreate {
  /** Expo Push Token */
  expo_push_token: string;
  /** Platform */
  platform?: string | null;
}

/**
 * UserOut
 * Schema for returning user information in API responses
 */
export interface UserOut {
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /**
   * Email
   * @format email
   */
  email: string;
  /**
   * First Name
   * @default ""
   */
  first_name?: string;
  /** Last Name */
  last_name?: string | null;
  /** Role */
  role?: string[] | null;
  /** Status */
  status?: string | null;
  /** Is Email Verified */
  is_email_verified?: boolean | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Api Key Id */
  api_key_id?: string | null;
  /** Api Key Expires At */
  api_key_expires_at?: string | null;
}

/** UserQueryResult */
export interface UserQueryResult {
  /** Users */
  users: UserResponse[];
  /** Count */
  count: number;
}

/** UserResponse */
export interface UserResponse {
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /**
   * Email
   * @format email
   */
  email: string;
  /**
   * First Name
   * @default ""
   */
  first_name?: string;
  /**
   * Last Name
   * @default ""
   */
  last_name?: string;
  /** Role */
  role?: UserRole[] | null;
  /** Status */
  status?: string | null;
  /** Is Email Verified */
  is_email_verified?: boolean | null;
  /** Created At */
  created_at?: string | null;
  /** Updated At */
  updated_at?: string | null;
}

/** UserSignup */
export interface UserSignup {
  /**
   * Email
   * @format email
   */
  email: string;
  /** Password */
  password: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /**
   * Tnc Checked
   * Terms and Conditions must be accepted
   * @example true
   */
  tnc_checked: boolean;
}

/** UserStatusUpdate */
export interface UserStatusUpdate {
  /**
   * Status
   * @example "Active"
   */
  status: string;
}

/** UserUpdate */
export interface UserUpdate {
  /** Email */
  email?: string | null;
  /**
   * First Name
   * @default ""
   */
  first_name?: string;
  /**
   * Last Name
   * @default ""
   */
  last_name?: string;
  /** Role */
  role?: UserRole[] | null;
  /** Status */
  status?: string | null;
  /** Is Email Verified */
  is_email_verified?: boolean | null;
  /** Tnc Checked */
  tnc_checked?: boolean | null;
  /** Current Password */
  current_password?: string | null;
  /** Password */
  password?: string | null;
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
}

/** VerifyEmailRequest */
export interface VerifyEmailRequest {
  /** Token */
  token: string;
}

/** VerifyPasswordLinkRequest */
export interface VerifyPasswordLinkRequest {
  /** Token */
  token: string;
}

/** YearData */
export interface YearData {
  /** Sectors */
  sectors: Record<string, SectorHazards>;
}

/** DeploymentAdminDetail */
export interface AppSchemasAdminDeploymentAdminDetail {
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /** Deployment Name */
  deployment_name: string;
  /**
   * Start Date
   * @format date-time
   */
  start_date: string;
  /** End Date */
  end_date: string | null;
  /** Deployed Date */
  deployed_date?: string | null;
  /** Retrieved Date */
  retrieved_date?: string | null;
  /** Data Upload Status */
  data_upload_status: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Location Id
   * @format uuid
   */
  location_id: string;
  /**
   * Device Id
   * @format uuid
   */
  device_id: string;
  /**
   * Created By
   * @format uuid
   */
  created_by: string;
  /**
   * Site Id
   * @format uuid
   */
  site_id: string;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /** Describes the status of a deployment. */
  status: DeploymentStatus;
  device: DeviceAdminDetail;
  location: LocationAdminDetail;
  /** Total Files */
  total_files: number;
  /** Total Inferences */
  total_inferences: number;
}

/** DeploymentAdminDetailBase */
export interface AppSchemasAdminDeploymentAdminDetailBase {
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /** Deployment Name */
  deployment_name: string;
  /**
   * Start Date
   * @format date-time
   */
  start_date: string;
  /** End Date */
  end_date: string | null;
  /** Deployed Date */
  deployed_date?: string | null;
  /** Retrieved Date */
  retrieved_date?: string | null;
  /** Data Upload Status */
  data_upload_status: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Location Id
   * @format uuid
   */
  location_id: string;
  /**
   * Device Id
   * @format uuid
   */
  device_id: string;
  /**
   * Created By
   * @format uuid
   */
  created_by: string;
  /**
   * Site Id
   * @format uuid
   */
  site_id: string;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /** Describes the status of a deployment. */
  status: DeploymentStatus;
}

/** DeploymentAdminListDetail */
export interface AppSchemasAdminDeploymentAdminListDetail {
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /** Deployment Name */
  deployment_name: string;
  /**
   * Start Date
   * @format date-time
   */
  start_date: string;
  /** End Date */
  end_date: string | null;
  /** Deployed Date */
  deployed_date?: string | null;
  /** Retrieved Date */
  retrieved_date?: string | null;
  /** Data Upload Status */
  data_upload_status: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Location Id
   * @format uuid
   */
  location_id: string;
  /**
   * Device Id
   * @format uuid
   */
  device_id: string;
  /**
   * Created By
   * @format uuid
   */
  created_by: string;
  /**
   * Site Id
   * @format uuid
   */
  site_id: string;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /** Describes the status of a deployment. */
  status: DeploymentStatus;
  /** Project Name */
  project_name: string;
  /** Site Name */
  site_name: string;
  /** Location Name */
  location_name: string;
  /** File Count */
  file_count: number;
  /** Inference Count */
  inference_count: number;
  /** Device Name */
  device_name: string;
}

/** DeploymentCreate */
export interface AppSchemasAdminDeploymentCreate {
  /**
   * Location Id
   * @format uuid
   */
  location_id: string;
  /**
   * Device Id
   * @format uuid
   */
  device_id: string;
  /** Deployment Name */
  deployment_name: string;
  /**
   * Start Date
   * @format date-time
   */
  start_date: string;
  /** End Date */
  end_date?: string | null;
  /** Deployed Date */
  deployed_date?: string | null;
  /** Retrieved Date */
  retrieved_date?: string | null;
  /**
   * Data Upload Status
   * @default false
   */
  data_upload_status?: boolean | null;
  /**
   * Is Deployment Accessible
   * @default true
   */
  is_deployment_accessible?: boolean | null;
  /** Inaccessible Photo Url */
  inaccessible_photo_url?: string | null;
  /** @default "Upcoming" */
  status?: DeploymentStatus | null;
  /** Site Id */
  site_id?: string | null;
  /** Project Id */
  project_id?: string | null;
}

/** DeploymentDetailResponse */
export interface AppSchemasAdminDeploymentDetailResponse {
  deployment: AppSchemasAdminDeploymentAdminDetail;
  site: SiteResponse;
  project: Project;
  location: LocationAdminDetail;
  device: DeviceAdminDetail;
}

/** DeploymentUpdate */
export interface AppSchemasAdminDeploymentUpdate {
  /** Deployment Name */
  deployment_name?: string | null;
  /** Start Date */
  start_date?: string | null;
  /** End Date */
  end_date?: string | null;
  /** Deployed Date */
  deployed_date?: string | null;
  /** Retrieved Date */
  retrieved_date?: string | null;
  /** Data Upload Status */
  data_upload_status?: boolean | null;
  /** Is Deployment Accessible */
  is_deployment_accessible?: boolean | null;
  /** Inaccessible Photo Url */
  inaccessible_photo_url?: string | null;
  status?: DeploymentStatus | null;
  /** Site Id */
  site_id?: string | null;
  /** Project Id */
  project_id?: string | null;
}

/**
 * DeploymentComparison
 * Acoustic indices and activity trend data for a specific deployment.
 */
export interface AppSchemasChartDeploymentComparison {
  /** Deployment Id */
  deployment_id: string;
  /** Indices */
  indices: Record<string, (number | null)[]>;
  activity_trend?: ActivityTrend | null;
}

/** DeploymentAdminDetail */
export interface AppSchemasDeploymentDeploymentAdminDetail {
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /** Deployment Name */
  deployment_name: string;
  /**
   * Start Date
   * @format date-time
   */
  start_date: string;
  /** End Date */
  end_date: string | null;
  /** Deployed Date */
  deployed_date?: string | null;
  /** Retrieved Date */
  retrieved_date?: string | null;
  /** Data Upload Status */
  data_upload_status: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Location Id
   * @format uuid
   */
  location_id: string;
  /** Device Id */
  device_id?: string | null;
  /** Device Type Id */
  device_type_id?: string | null;
  /**
   * Created By
   * @format uuid
   */
  created_by: string;
  /**
   * Site Id
   * @format uuid
   */
  site_id: string;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /** Describes the status of a deployment. */
  status: DeploymentStatus;
  device?: DeviceAdminDetail | null;
  location: LocationAdminDetail;
  /** Total Files */
  total_files: number;
  /** Total Inferences */
  total_inferences: number;
}

/** DeploymentAdminDetailBase */
export interface AppSchemasDeploymentDeploymentAdminDetailBase {
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /** Deployment Name */
  deployment_name: string;
  /**
   * Start Date
   * @format date-time
   */
  start_date: string;
  /** End Date */
  end_date: string | null;
  /** Deployed Date */
  deployed_date?: string | null;
  /** Retrieved Date */
  retrieved_date?: string | null;
  /** Data Upload Status */
  data_upload_status: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Location Id
   * @format uuid
   */
  location_id: string;
  /** Device Id */
  device_id?: string | null;
  /** Device Type Id */
  device_type_id?: string | null;
  /**
   * Created By
   * @format uuid
   */
  created_by: string;
  /**
   * Site Id
   * @format uuid
   */
  site_id: string;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /** Describes the status of a deployment. */
  status: DeploymentStatus;
}

/** DeploymentAdminListDetail */
export interface AppSchemasDeploymentDeploymentAdminListDetail {
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  /** Deployment Name */
  deployment_name: string;
  /**
   * Start Date
   * @format date-time
   */
  start_date: string;
  /** End Date */
  end_date: string | null;
  /** Deployed Date */
  deployed_date?: string | null;
  /** Retrieved Date */
  retrieved_date?: string | null;
  /** Data Upload Status */
  data_upload_status: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /**
   * Location Id
   * @format uuid
   */
  location_id: string;
  /** Device Id */
  device_id?: string | null;
  /** Device Type Id */
  device_type_id?: string | null;
  /**
   * Created By
   * @format uuid
   */
  created_by: string;
  /**
   * Site Id
   * @format uuid
   */
  site_id: string;
  /**
   * Project Id
   * @format uuid
   */
  project_id: string;
  /** Describes the status of a deployment. */
  status: DeploymentStatus;
  /** Project Name */
  project_name: string;
  /** Site Name */
  site_name: string;
  /** Location Name */
  location_name: string;
  /** File Count */
  file_count: number;
  /** Inference Count */
  inference_count: number;
  /** Device Name */
  device_name?: string | null;
}

/** DeploymentCreate */
export interface AppSchemasDeploymentDeploymentCreate {
  /**
   * Location Id
   * @format uuid
   */
  location_id: string;
  /**
   * Device Type Id
   * @format uuid
   */
  device_type_id: string;
  /** Device Id */
  device_id?: string | null;
  /** Deployment Name */
  deployment_name: string;
  /**
   * Start Date
   * @format date-time
   */
  start_date: string;
  /** End Date */
  end_date?: string | null;
  /** Deployed Date */
  deployed_date?: string | null;
  /** Retrieved Date */
  retrieved_date?: string | null;
  /**
   * Data Upload Status
   * @default false
   */
  data_upload_status?: boolean | null;
  /**
   * Is Deployment Accessible
   * @default true
   */
  is_deployment_accessible?: boolean | null;
  /** Inaccessible Photo Url */
  inaccessible_photo_url?: string | null;
  /** @default "Upcoming" */
  status?: DeploymentStatus | null;
}

/** DeploymentDetailResponse */
export interface AppSchemasDeploymentDeploymentDetailResponse {
  deployment: AppSchemasDeploymentDeploymentAdminDetail;
  site: SiteResponse;
  project: Project;
  location: LocationAdminDetail;
  device?: DeviceAdminDetail | null;
}

/** DeploymentUpdate */
export interface AppSchemasDeploymentDeploymentUpdate {
  /** Deployment Name */
  deployment_name?: string | null;
  /** Device Type Id */
  device_type_id?: string | null;
  /** Start Date */
  start_date?: string | null;
  /** End Date */
  end_date?: string | null;
  /** Deployed Date */
  deployed_date?: string | null;
  /** Retrieved Date */
  retrieved_date?: string | null;
  /** Data Upload Status */
  data_upload_status?: boolean | null;
  /** Is Deployment Accessible */
  is_deployment_accessible?: boolean | null;
  /** Inaccessible Photo Url */
  inaccessible_photo_url?: string | null;
  status?: DeploymentStatus | null;
}

/** DeploymentComparison */
export interface AppSchemasDeploymentDataDeploymentComparison {
  /**
   * Deployment Id
   * @format uuid
   */
  deployment_id: string;
  deployment_info?: DeploymentInfo | null;
  retrieval_info?: RetrievalInfo | null;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title MRV Backend API
 * @version 0.1.0
 *
 * API for the MRV Backend Application
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name ReadRootGet
   * @summary Read Root
   * @request GET:/
   */
  readRootGet = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/`,
      method: "GET",
      format: "json",
      ...params,
    });

  api = {
    /**
     * @description Basic health check endpoint. Returns a status message indicating the API is operational.
     *
     * @tags Health
     * @name HealthCheckApiV2HealthGet
     * @summary Check API Health
     * @request GET:/api/v2/health
     */
    healthCheckApiV2HealthGet: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/api/v2/health`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Create new user.
     *
     * @tags Authentication
     * @name SignupApiV1AuthSignupPost
     * @summary Signup
     * @request POST:/api/v1/auth/signup
     */
    signupApiV1AuthSignupPost: (data: UserSignup, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/api/v1/auth/signup`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Send verification email to user after signup.
     *
     * @tags Authentication
     * @name SendVerificationEmailAfterSignupApiV1AuthSendVerificationEmailPostSignupPost
     * @summary Send Verification Email After Signup
     * @request POST:/api/v1/auth/send-verification-email-post-signup
     */
    sendVerificationEmailAfterSignupApiV1AuthSendVerificationEmailPostSignupPost:
      (
        query: {
          /** Email */
          email: string;
        },
        params: RequestParams = {},
      ) =>
        this.request<any, HTTPValidationError>({
          path: `/api/v1/auth/send-verification-email-post-signup`,
          method: "POST",
          query: query,
          format: "json",
          ...params,
        }),

    /**
     * @description Verify user's email after signup via GET query parameter.
     *
     * @tags Authentication
     * @name VerifyEmailAfterSignupGetApiV1AuthVerifyEmailPostSignupGet
     * @summary Verify Email After Signup Get
     * @request GET:/api/v1/auth/verify-email-post-signup
     */
    verifyEmailAfterSignupGetApiV1AuthVerifyEmailPostSignupGet: (
      query: {
        /** Token */
        token: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/api/v1/auth/verify-email-post-signup`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Verify user's email after signup.
     *
     * @tags Authentication
     * @name VerifyEmailAfterSignupApiV1AuthVerifyEmailPostSignupPost
     * @summary Verify Email After Signup
     * @request POST:/api/v1/auth/verify-email-post-signup
     */
    verifyEmailAfterSignupApiV1AuthVerifyEmailPostSignupPost: (
      data: VerifyEmailRequest,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/api/v1/auth/verify-email-post-signup`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description OAuth2 compatible token login.
     *
     * @tags Authentication
     * @name LoginApiV1AuthLoginPost
     * @summary Login
     * @request POST:/api/v1/auth/login
     */
    loginApiV1AuthLoginPost: (data: LoginRequest, params: RequestParams = {}) =>
      this.request<Token, HTTPValidationError>({
        path: `/api/v1/auth/login`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Test access token.
     *
     * @tags Authentication
     * @name TestTokenApiV1AuthTestTokenPost
     * @summary Test Token
     * @request POST:/api/v1/auth/test-token
     */
    testTokenApiV1AuthTestTokenPost: (params: RequestParams = {}) =>
      this.request<UserResponse, any>({
        path: `/api/v1/auth/test-token`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description Logout endpoint. Invalidates the current token by removing it from the database and deletes the refresh cookie.
     *
     * @tags Authentication
     * @name LogoutApiV1AuthLogoutPost
     * @summary Logout
     * @request POST:/api/v1/auth/logout
     */
    logoutApiV1AuthLogoutPost: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/api/v1/auth/logout`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description Use refresh token from HttpOnly cookie or Authorization header to get a new access token.
     *
     * @tags Authentication
     * @name RefreshTokenApiV1AuthRefreshPost
     * @summary Refresh Token
     * @request POST:/api/v1/auth/refresh
     */
    refreshTokenApiV1AuthRefreshPost: (params: RequestParams = {}) =>
      this.request<Token, any>({
        path: `/api/v1/auth/refresh`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description Get current user information.
     *
     * @tags Authentication
     * @name GetUserApiV1AuthUserGet
     * @summary Get User
     * @request GET:/api/v1/auth/user
     */
    getUserApiV1AuthUserGet: (params: RequestParams = {}) =>
      this.request<UserResponse, any>({
        path: `/api/v1/auth/user`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update current user information.
     *
     * @tags Authentication
     * @name UpdateUserApiV1AuthUserPut
     * @summary Update User
     * @request PUT:/api/v1/auth/user
     */
    updateUserApiV1AuthUserPut: (
      data: UserUpdate,
      params: RequestParams = {},
    ) =>
      this.request<UserResponse, HTTPValidationError>({
        path: `/api/v1/auth/user`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Create new user.
     *
     * @tags Authentication
     * @name SignupApiV2AuthSignupPost
     * @summary Signup
     * @request POST:/api/v2/auth/signup
     */
    signupApiV2AuthSignupPost: (data: UserSignup, params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/api/v2/auth/signup`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Send verification email to user after signup.
     *
     * @tags Authentication
     * @name SendVerificationEmailAfterSignupApiV2AuthSendVerificationEmailPostSignupPost
     * @summary Send Verification Email After Signup
     * @request POST:/api/v2/auth/send-verification-email-post-signup
     */
    sendVerificationEmailAfterSignupApiV2AuthSendVerificationEmailPostSignupPost:
      (
        query: {
          /** Email */
          email: string;
        },
        params: RequestParams = {},
      ) =>
        this.request<any, HTTPValidationError>({
          path: `/api/v2/auth/send-verification-email-post-signup`,
          method: "POST",
          query: query,
          format: "json",
          ...params,
        }),

    /**
     * @description Verify user's email after signup via GET query parameter.
     *
     * @tags Authentication
     * @name VerifyEmailAfterSignupGetApiV2AuthVerifyEmailPostSignupGet
     * @summary Verify Email After Signup Get
     * @request GET:/api/v2/auth/verify-email-post-signup
     */
    verifyEmailAfterSignupGetApiV2AuthVerifyEmailPostSignupGet: (
      query: {
        /** Token */
        token: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/api/v2/auth/verify-email-post-signup`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Verify user's email after signup.
     *
     * @tags Authentication
     * @name VerifyEmailAfterSignupApiV2AuthVerifyEmailPostSignupPost
     * @summary Verify Email After Signup
     * @request POST:/api/v2/auth/verify-email-post-signup
     */
    verifyEmailAfterSignupApiV2AuthVerifyEmailPostSignupPost: (
      data: VerifyEmailRequest,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/api/v2/auth/verify-email-post-signup`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description OAuth2 compatible token login.
     *
     * @tags Authentication
     * @name LoginApiV2AuthLoginPost
     * @summary Login
     * @request POST:/api/v2/auth/login
     */
    loginApiV2AuthLoginPost: (data: LoginRequest, params: RequestParams = {}) =>
      this.request<Token, HTTPValidationError>({
        path: `/api/v2/auth/login`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Test access token.
     *
     * @tags Authentication
     * @name TestTokenApiV2AuthTestTokenPost
     * @summary Test Token
     * @request POST:/api/v2/auth/test-token
     */
    testTokenApiV2AuthTestTokenPost: (params: RequestParams = {}) =>
      this.request<UserResponse, any>({
        path: `/api/v2/auth/test-token`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description Logout endpoint. Invalidates the current token by removing it from the database and deletes the refresh cookie.
     *
     * @tags Authentication
     * @name LogoutApiV2AuthLogoutPost
     * @summary Logout
     * @request POST:/api/v2/auth/logout
     */
    logoutApiV2AuthLogoutPost: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/api/v2/auth/logout`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description Use refresh token from HttpOnly cookie or Authorization header to get a new access token.
     *
     * @tags Authentication
     * @name RefreshTokenApiV2AuthRefreshPost
     * @summary Refresh Token
     * @request POST:/api/v2/auth/refresh
     */
    refreshTokenApiV2AuthRefreshPost: (params: RequestParams = {}) =>
      this.request<Token, any>({
        path: `/api/v2/auth/refresh`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description Get current user information.
     *
     * @tags Authentication
     * @name GetUserApiV2AuthUserGet
     * @summary Get User
     * @request GET:/api/v2/auth/user
     */
    getUserApiV2AuthUserGet: (params: RequestParams = {}) =>
      this.request<UserResponse, any>({
        path: `/api/v2/auth/user`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update current user information.
     *
     * @tags Authentication
     * @name UpdateUserApiV2AuthUserPut
     * @summary Update User
     * @request PUT:/api/v2/auth/user
     */
    updateUserApiV2AuthUserPut: (
      data: UserUpdate,
      params: RequestParams = {},
    ) =>
      this.request<UserResponse, HTTPValidationError>({
        path: `/api/v2/auth/user`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Generate chart data for multiple deployments including both acoustic indices and activity trend per deployment.
     *
     * @tags Charts
     * @name CreateDeploymentChartsApiV2DeploymentsBioInsituChartPost
     * @summary Get Chart Data (Activity Trend & Acoustic Indices) for Deployments
     * @request POST:/api/v2/deployments/bio-insitu-chart
     */
    createDeploymentChartsApiV2DeploymentsBioInsituChartPost: (
      data: ChartRequest,
      params: RequestParams = {},
    ) =>
      this.request<ChartResponse, HTTPValidationError>({
        path: `/api/v2/deployments/bio-insitu-chart`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Assign a device to a deployment**. This endpoint assigns a physical device to a deployment. The device will be tracked as "active" until it is retrieved or replaced. **Validation**: - Deployment must exist and be in UPCOMING or DEPLOYED status - Device must exist and belong to the same project as the deployment - Device type must match the deployment's required device type - Device condition must be NORMAL (deployable) - Device must have an active custody record in the deployment's project - Device must not already be assigned to another active deployment - Deployment must not already have an active device assignment **Errors**: - `404 Not Found`: Deployment or device doesn't exist - `400 Bad Request`: Validation fails (status, type, condition, custody mismatch) - `409 Conflict`: Device already assigned elsewhere or deployment already has active device **Example Request**: ```json { "device_id": "00000000-0000-0000-0000-000000000001", "assigned_by": "00000000-0000-0000-0000-000000000002", "notes": "Assigned during field prep" } ```
     *
     * @tags Deployment Devices
     * @name AssignDeviceEndpointApiV2DeploymentsDeploymentIdAssignDevicePost
     * @summary Assign a device to a deployment
     * @request POST:/api/v2/deployments/{deployment_id}/assign-device
     */
    assignDeviceEndpointApiV2DeploymentsDeploymentIdAssignDevicePost: (
      deploymentId: string,
      data: AssignDeviceRequest,
      params: RequestParams = {},
    ) =>
      this.request<DeploymentDeviceResponse, HTTPValidationError>({
        path: `/api/v2/deployments/${deploymentId}/assign-device`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Replace the currently assigned device with a new one**. This endpoint replaces the active device assignment with a new device while preserving complete assignment history. The previous assignment is marked as returned and a new assignment is created. **Process**: 1. Finds the current active device assignment 2. Marks it as returned (closes the assignment period) 3. Validates the replacement device using same rules as assign_device 4. Creates a new assignment record 5. Returns the new assignment (history is preserved in database) **Validation**: Same as assign_device_endpoint, plus: - A current active device assignment must exist in the deployment **Errors**: - `404 Not Found`: Deployment doesn't exist or no active device to replace - `400/409`: Replacement device validation failures **Example Request**: ```json { "new_device_id": "00000000-0000-0000-0000-000000000003", "assigned_by": "00000000-0000-0000-0000-000000000002", "notes": "Previous device malfunction, replaced on site" } ```
     *
     * @tags Deployment Devices
     * @name ReplaceDeviceEndpointApiV2DeploymentsDeploymentIdReplaceDevicePatch
     * @summary Replace the currently assigned device
     * @request PATCH:/api/v2/deployments/{deployment_id}/replace-device
     */
    replaceDeviceEndpointApiV2DeploymentsDeploymentIdReplaceDevicePatch: (
      deploymentId: string,
      data: ReplaceDeviceRequest,
      params: RequestParams = {},
    ) =>
      this.request<DeploymentDeviceResponse, HTTPValidationError>({
        path: `/api/v2/deployments/${deploymentId}/replace-device`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Retrieve (return) a device from a deployment**. This endpoint marks a device as physically returned from a deployment. The assignment record is not deleted, only marked with a return timestamp. This preserves the complete assignment history. **Behavior**: - Sets `returned_at` timestamp to current time - Appends notes to the assignment record (does not overwrite) - Device can be assigned to a different deployment or project after retrieval - Assignment history is preserved in database **Errors**: - `404 Not Found`: Deployment doesn't exist or no active device to retrieve **Example Request**: ```json { "notes": "Device retrieved successfully, good condition" } ```
     *
     * @tags Deployment Devices
     * @name RetrieveDeviceEndpointApiV2DeploymentsDeploymentIdRetrieveDevicePatch
     * @summary Retrieve (return) a device from a deployment
     * @request PATCH:/api/v2/deployments/{deployment_id}/retrieve-device
     */
    retrieveDeviceEndpointApiV2DeploymentsDeploymentIdRetrieveDevicePatch: (
      deploymentId: string,
      data: RetrieveDeviceRequest,
      params: RequestParams = {},
    ) =>
      this.request<DeploymentDeviceResponse, HTTPValidationError>({
        path: `/api/v2/deployments/${deploymentId}/retrieve-device`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Get the currently active device assigned to a deployment**. This endpoint returns the device that is currently assigned to the deployment (where `returned_at` is NULL). If no active assignment exists, returns 404. **Returns**: ```json { "deployment_device_id": "...", "device_id": "...", "device_name": "...", "device_asset_tag": "...", "device_condition": "NORMAL", "device_status": "ACTIVE", "assigned_at": "2026-07-06T12:00:00Z", "assigned_by": "...", "notes": "..." } ``` **Errors**: - `404 Not Found`: Deployment not found or no active device assignment exists
     *
     * @tags Deployment Devices
     * @name GetActiveDeviceEndpointApiV2DeploymentsDeploymentIdActiveDeviceGet
     * @summary Get the currently active device for a deployment
     * @request GET:/api/v2/deployments/{deployment_id}/active-device
     */
    getActiveDeviceEndpointApiV2DeploymentsDeploymentIdActiveDeviceGet: (
      deploymentId: string,
      params: RequestParams = {},
    ) =>
      this.request<ActiveDeviceResponse, HTTPValidationError>({
        path: `/api/v2/deployments/${deploymentId}/active-device`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description **Get the complete device assignment history for a deployment**. This endpoint returns all device assignments (active and returned) for a deployment, ordered by `assigned_at` in descending order (most recent first). Each record includes: - Assignment tracking: `assigned_at`, `returned_at`, `assigned_by` - Device details: `device_id`, `device_name`, `asset_tag`, condition, status - Notes: Any notes recorded during assignment, replacement, or retrieval **Returns**: ```json { "data": [ { "deployment_device_id": "...", "deployment_id": "...", "device_id": "...", "device_name": "...", "device_asset_tag": "...", "device_condition": "NORMAL", "device_status": "ACTIVE", "assigned_at": "2026-07-06T14:00:00Z", "returned_at": null, "assigned_by": "...", "notes": "..." }, { "deployment_device_id": "...", "deployment_id": "...", "device_id": "...", "device_name": "...", "device_asset_tag": "...", "device_condition": "NORMAL", "device_status": "ACTIVE", "assigned_at": "2026-07-06T12:00:00Z", "returned_at": "2026-07-06T13:30:00Z", "assigned_by": "...", "notes": "Replaced due to malfunction" } ], "count": 2, "deployment_id": "..." } ``` **Errors**: - `404 Not Found`: Deployment not found
     *
     * @tags Deployment Devices
     * @name GetDeviceHistoryEndpointApiV2DeploymentsDeploymentIdDeviceHistoryGet
     * @summary Get assignment history for a deployment
     * @request GET:/api/v2/deployments/{deployment_id}/device-history
     */
    getDeviceHistoryEndpointApiV2DeploymentsDeploymentIdDeviceHistoryGet: (
      deploymentId: string,
      params: RequestParams = {},
    ) =>
      this.request<DeploymentDeviceHistoryResponse, HTTPValidationError>({
        path: `/api/v2/deployments/${deploymentId}/device-history`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description **Get all devices eligible to be assigned to the deployment**. These devices: - Must belong to the project of the deployment. - Must have active custody in the project. - Must not be actively assigned to another deployment. - Condition must be NORMAL. - Device type must match the deployment's required device type.
     *
     * @tags Deployment Devices
     * @name GetEligibleDevicesEndpointApiV2DeploymentsDeploymentIdDevicesEligibleGet
     * @summary Get all devices eligible to be assigned to the deployment
     * @request GET:/api/v2/deployments/{deployment_id}/devices/eligible
     */
    getEligibleDevicesEndpointApiV2DeploymentsDeploymentIdDevicesEligibleGet: (
      deploymentId: string,
      params: RequestParams = {},
    ) =>
      this.request<DeviceAdminDetail[], HTTPValidationError>({
        path: `/api/v2/deployments/${deploymentId}/devices/eligible`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description **Report the active device assigned to the deployment as DAMAGED**. This endpoint: 1. Closes the currently active assignment with reason `"DAMAGED"`. 2. Updates the physical device's condition to `"DAMAGED"`. 3. If `replacement_device_id` is provided, validates and assigns the new device.
     *
     * @tags Deployment Devices
     * @name ReportDamagedDeviceEndpointApiV2DeploymentsDeploymentIdReportDamagedPatch
     * @summary Report active device as damaged
     * @request PATCH:/api/v2/deployments/{deployment_id}/report-damaged
     */
    reportDamagedDeviceEndpointApiV2DeploymentsDeploymentIdReportDamagedPatch: (
      deploymentId: string,
      data: ReportDeviceIssueRequest,
      params: RequestParams = {},
    ) =>
      this.request<DeploymentDeviceResponse, HTTPValidationError>({
        path: `/api/v2/deployments/${deploymentId}/report-damaged`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Report the active device assigned to the deployment as MISSING**. This endpoint: 1. Closes the currently active assignment with reason `"MISSING"`. 2. Updates the physical device's condition to `"MISSING"`. 3. If `replacement_device_id` is provided, validates and assigns the new device.
     *
     * @tags Deployment Devices
     * @name ReportMissingDeviceEndpointApiV2DeploymentsDeploymentIdReportMissingPatch
     * @summary Report active device as missing
     * @request PATCH:/api/v2/deployments/{deployment_id}/report-missing
     */
    reportMissingDeviceEndpointApiV2DeploymentsDeploymentIdReportMissingPatch: (
      deploymentId: string,
      data: ReportDeviceIssueRequest,
      params: RequestParams = {},
    ) =>
      this.request<DeploymentDeviceResponse, HTTPValidationError>({
        path: `/api/v2/deployments/${deploymentId}/report-missing`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Assign/checkout a device to a project so it can be deployed by field workers.
     *
     * @tags Device Custody
     * @name CheckoutDeviceApiV2DeviceCustodyCheckoutPost
     * @summary Check out a device to a project
     * @request POST:/api/v2/device-custody/checkout
     */
    checkoutDeviceApiV2DeviceCustodyCheckoutPost: (
      data: DeviceCustodyCheckOut,
      params: RequestParams = {},
    ) =>
      this.request<DeviceCustodyResponse, HTTPValidationError>({
        path: `/api/v2/device-custody/checkout`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Return/checkin (unassign) a device from its project, making it available for checkout to other projects.
     *
     * @tags Device Custody
     * @name CheckinDeviceApiV2DeviceCustodyCheckinDeviceIdPost
     * @summary Check in a device from its project
     * @request POST:/api/v2/device-custody/checkin/{device_id}
     */
    checkinDeviceApiV2DeviceCustodyCheckinDeviceIdPost: (
      deviceId: string,
      params: RequestParams = {},
    ) =>
      this.request<DeviceCustodyResponse, HTTPValidationError>({
        path: `/api/v2/device-custody/checkin/${deviceId}`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description Get all device custody checkout/checkin history for a project.
     *
     * @tags Device Custody
     * @name GetProjectCustodyHistoryApiV2DeviceCustodyProjectProjectIdGet
     * @summary Get custody history for a project
     * @request GET:/api/v2/device-custody/project/{project_id}
     */
    getProjectCustodyHistoryApiV2DeviceCustodyProjectProjectIdGet: (
      projectId: string,
      params: RequestParams = {},
    ) =>
      this.request<DeviceCustodyHistory, HTTPValidationError>({
        path: `/api/v2/device-custody/project/${projectId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Get all project checkout/checkin history for a device.
     *
     * @tags Device Custody
     * @name GetDeviceCustodyHistoryApiV2DeviceCustodyDeviceDeviceIdGet
     * @summary Get custody history for a device
     * @request GET:/api/v2/device-custody/device/{device_id}
     */
    getDeviceCustodyHistoryApiV2DeviceCustodyDeviceDeviceIdGet: (
      deviceId: string,
      params: RequestParams = {},
    ) =>
      this.request<DeviceCustodyHistory, HTTPValidationError>({
        path: `/api/v2/device-custody/device/${deviceId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new project. The project will be owned by the currently authenticated user. Access Control: - **Admins**: Can create projects. - **Users**: Can create projects. - **Employees**: Cannot create projects.
     *
     * @tags Projects
     * @name CreateProjectApiV2ProjectsPost
     * @summary Create a New Project
     * @request POST:/api/v2/projects/
     */
    createProjectApiV2ProjectsPost: (
      data: ProjectCreate,
      params: RequestParams = {},
    ) =>
      this.request<Project, HTTPValidationError>({
        path: `/api/v2/projects/`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve projects based on the user's role. Access Control: - **Admins**: Retrieve all projects in the system. - **Employees**: Retrieve only projects they are assigned to. - **Users**: Retrieve only projects they own. - **DEV**: Retrieve only assigned projects from their organization. Authentication: - Supports both JWT Bearer token and API key (X-API-Key header or Bearer token starting with 'drk_').
     *
     * @tags Projects
     * @name ReadProjectsApiV2ProjectsGet
     * @summary List Projects by Role
     * @request GET:/api/v2/projects/
     */
    readProjectsApiV2ProjectsGet: (
      query?: {
        /**
         * Skip
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<Project[], HTTPValidationError>({
        path: `/api/v2/projects/`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a single project by its unique ID. Access Control: - **Admins**: Can retrieve any project. - **Employees**: Can retrieve projects they are assigned to. - **Users**: Can only retrieve projects they own. - **DEV**: Can retrieve projects assigned to them from their organization. Authentication: - Supports both JWT Bearer token and API key (X-API-Key header or Bearer token starting with 'drk_').
     *
     * @tags Projects
     * @name ReadProjectApiV2ProjectsProjectIdGet
     * @summary Get a Single Project by ID
     * @request GET:/api/v2/projects/{project_id}
     */
    readProjectApiV2ProjectsProjectIdGet: (
      projectId: string,
      query?: {
        /**
         * Get Satellite Images
         * @default false
         */
        get_satellite_images?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<Project, HTTPValidationError>({
        path: `/api/v2/projects/${projectId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Update an existing project. Access Control: - **Admins**: Can update any project. - **Employees**: Can update projects they are assigned to. - **Users**: Can only update projects they own.
     *
     * @tags Projects
     * @name UpdateProjectApiV2ProjectsProjectIdPut
     * @summary Update a Project
     * @request PUT:/api/v2/projects/{project_id}
     */
    updateProjectApiV2ProjectsProjectIdPut: (
      projectId: string,
      data: ProjectUpdate,
      params: RequestParams = {},
    ) =>
      this.request<Project, HTTPValidationError>({
        path: `/api/v2/projects/${projectId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a project. Access Control: - **Admins**: Can delete any project. - **Users**: Can only delete projects they own. - **Employees**: Cannot delete projects.
     *
     * @tags Projects
     * @name DeleteProjectApiV2ProjectsProjectIdDelete
     * @summary Delete a Project
     * @request DELETE:/api/v2/projects/{project_id}
     */
    deleteProjectApiV2ProjectsProjectIdDelete: (
      projectId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/api/v2/projects/${projectId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * @description Get all the necessary data for the interactive map for a specific project. This includes sites, locations, deployments, and devices. The endpoint is available for projects with status "Under development".
     *
     * @tags Projects
     * @name GetProjectMapDataApiV2ProjectsProjectIdMapGet
     * @summary Get Project Data for Interactive Map
     * @request GET:/api/v2/projects/{project_id}/map
     */
    getProjectMapDataApiV2ProjectsProjectIdMapGet: (
      projectId: string,
      params: RequestParams = {},
    ) =>
      this.request<ProjectMapData, HTTPValidationError>({
        path: `/api/v2/projects/${projectId}/map`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Get map markers (deployments) within a bounding box for a project.
     *
     * @tags Projects
     * @name GetProjectMapMarkersApiV2ProjectsProjectIdMapMarkersGet
     * @summary Get Project Map Markers via spatial bbox filter
     * @request GET:/api/v2/projects/{project_id}/map/markers
     */
    getProjectMapMarkersApiV2ProjectsProjectIdMapMarkersGet: (
      projectId: string,
      query: {
        /**
         * Bbox
         * min_lng,min_lat,max_lng,max_lat
         */
        bbox: string;
        /**
         * Device Type
         * Optional device type category filter
         */
        device_type?: string | null;
        /**
         * Skip
         * @min 0
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @min 1
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<MapMarker[], HTTPValidationError>({
        path: `/api/v2/projects/${projectId}/map/markers`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name ListShowcaseCandidatesApiV2ProjectsProjectIdMediaShowcaseCandidatesGet
     * @summary List Candidate Photos for Showcase
     * @request GET:/api/v2/projects/{project_id}/media/showcase/candidates
     */
    listShowcaseCandidatesApiV2ProjectsProjectIdMediaShowcaseCandidatesGet: (
      projectId: string,
      query?: {
        /**
         * Skip
         * @min 0
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @min 1
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ShowcaseCandidatesResponse, HTTPValidationError>({
        path: `/api/v2/projects/${projectId}/media/showcase/candidates`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name ShowcasePhotosApiV2ProjectsProjectIdMediaShowcasePost
     * @summary Promote Candidate Photos to Project Showcase
     * @request POST:/api/v2/projects/{project_id}/media/showcase
     */
    showcasePhotosApiV2ProjectsProjectIdMediaShowcasePost: (
      projectId: string,
      data: ShowcaseSelectionRequest,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/api/v2/projects/${projectId}/media/showcase`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name RemoveShowcasePhotosApiV2ProjectsProjectIdMediaShowcaseDelete
     * @summary Remove Photos from Project Showcase
     * @request DELETE:/api/v2/projects/{project_id}/media/showcase
     */
    removeShowcasePhotosApiV2ProjectsProjectIdMediaShowcaseDelete: (
      projectId: string,
      data: ShowcaseDeselectionRequest,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/api/v2/projects/${projectId}/media/showcase`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project Sessions
     * @name CreateProjectSessionApiV2ProjectsProjectIdSessionsPost
     * @summary Create a Project Session
     * @request POST:/api/v2/projects/{project_id}/sessions
     */
    createProjectSessionApiV2ProjectsProjectIdSessionsPost: (
      projectId: string,
      data: ProjectSessionCreate,
      params: RequestParams = {},
    ) =>
      this.request<ProjectSessionResponse, HTTPValidationError>({
        path: `/api/v2/projects/${projectId}/sessions`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project Sessions
     * @name ListProjectSessionsApiV2ProjectsProjectIdSessionsGet
     * @summary List Project Sessions
     * @request GET:/api/v2/projects/{project_id}/sessions
     */
    listProjectSessionsApiV2ProjectsProjectIdSessionsGet: (
      projectId: string,
      params: RequestParams = {},
    ) =>
      this.request<ProjectSessionList, HTTPValidationError>({
        path: `/api/v2/projects/${projectId}/sessions`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project Sessions
     * @name GetProjectSessionApiV2ProjectsProjectIdSessionsSessionIdGet
     * @summary Get a Project Session
     * @request GET:/api/v2/projects/{project_id}/sessions/{session_id}
     */
    getProjectSessionApiV2ProjectsProjectIdSessionsSessionIdGet: (
      projectId: string,
      sessionId: string,
      params: RequestParams = {},
    ) =>
      this.request<ProjectSessionResponse, HTTPValidationError>({
        path: `/api/v2/projects/${projectId}/sessions/${sessionId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project Sessions
     * @name UpdateProjectSessionApiV2ProjectsProjectIdSessionsSessionIdPut
     * @summary Update a Project Session
     * @request PUT:/api/v2/projects/{project_id}/sessions/{session_id}
     */
    updateProjectSessionApiV2ProjectsProjectIdSessionsSessionIdPut: (
      projectId: string,
      sessionId: string,
      data: ProjectSessionUpdate,
      params: RequestParams = {},
    ) =>
      this.request<ProjectSessionResponse, HTTPValidationError>({
        path: `/api/v2/projects/${projectId}/sessions/${sessionId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project Sessions
     * @name DeleteProjectSessionApiV2ProjectsProjectIdSessionsSessionIdDelete
     * @summary Delete a Project Session
     * @request DELETE:/api/v2/projects/{project_id}/sessions/{session_id}
     */
    deleteProjectSessionApiV2ProjectsProjectIdSessionsSessionIdDelete: (
      projectId: string,
      sessionId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/v2/projects/${projectId}/sessions/${sessionId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Create multiple sites for a project in a single bulk operation. Access Control: - Requires write access to the parent project (Admin, assigned Employee, or Owner).
     *
     * @tags Sites
     * @name CreateBulkSiteApiV2ProjectsProjectIdSitesBulkPost
     * @summary Create Multiple Sites for a Project
     * @request POST:/api/v2/projects/{project_id}/sites/bulk
     */
    createBulkSiteApiV2ProjectsProjectIdSitesBulkPost: (
      projectId: string,
      data: BulkSite[],
      params: RequestParams = {},
    ) =>
      this.request<SiteResponse[], HTTPValidationError>({
        path: `/api/v2/projects/${projectId}/sites/bulk`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new site within a specific project. If shapefile data is provided, it will be uploaded and processed asynchronously. Access Control: - **Admins**: Can create a site in any project. - **Employees**: Can create a site in projects they are assigned to. - **Users**: Can only create a site in projects they own.
     *
     * @tags Sites
     * @name CreateSiteApiV2ProjectsProjectIdSitesPost
     * @summary Create a New Site
     * @request POST:/api/v2/projects/{project_id}/sites
     */
    createSiteApiV2ProjectsProjectIdSitesPost: (
      projectId: string,
      data: SiteCreate,
      params: RequestParams = {},
    ) =>
      this.request<SiteResponse, HTTPValidationError>({
        path: `/api/v2/projects/${projectId}/sites`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve all sites belonging to a specific project. Access Control: - **Admins**: Can list sites for any project. - **Employees**: Can list sites for projects they are assigned to. - **Users**: Can only list sites for projects they own. - **DEV**: Can list sites for assigned projects.
     *
     * @tags Sites
     * @name ReadSitesForProjectApiV2ProjectsProjectIdSitesGet
     * @summary List All Sites for a Project
     * @request GET:/api/v2/projects/{project_id}/sites
     */
    readSitesForProjectApiV2ProjectsProjectIdSitesGet: (
      projectId: string,
      query?: {
        /**
         * Skip
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<SiteResponse[], HTTPValidationError>({
        path: `/api/v2/projects/${projectId}/sites`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get satellite imagery for multiple sites in a single request. More efficient than loading one by one.
     *
     * @tags Sites
     * @name GetBatchSatelliteImageryApiV2SitesSatelliteImageryBatchPost
     * @summary Get Satellite Imagery for Multiple Sites
     * @request POST:/api/v2/sites/satellite-imagery/batch
     */
    getBatchSatelliteImageryApiV2SitesSatelliteImageryBatchPost: (
      data: string[],
      params: RequestParams = {},
    ) =>
      this.request<SiteSatelliteImagery[], HTTPValidationError>({
        path: `/api/v2/sites/satellite-imagery/batch`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update an existing site's properties. Access Control: - **Admins**: Can update any site. - **Employees**: Can update sites in projects they are assigned to. - **Users**: Can only update sites in projects they own.
     *
     * @tags Sites
     * @name UpdateSiteApiV2SitesSiteIdPatch
     * @summary Update a Site
     * @request PATCH:/api/v2/sites/{site_id}
     */
    updateSiteApiV2SitesSiteIdPatch: (
      siteId: string,
      data: SiteUpdate,
      params: RequestParams = {},
    ) =>
      this.request<SiteResponse, HTTPValidationError>({
        path: `/api/v2/sites/${siteId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a specific site by its unique ID. Access Control: - **Admins**: Can retrieve any site. - **Employees**: Can retrieve sites in projects they are assigned to. - **Users**: Can only retrieve sites in projects they own. - **DEV**: Can retrieve assigned sites.
     *
     * @tags Sites
     * @name ReadSiteApiV2SitesSiteIdGet
     * @summary Get a Single Site by ID
     * @request GET:/api/v2/sites/{site_id}
     */
    readSiteApiV2SitesSiteIdGet: (siteId: string, params: RequestParams = {}) =>
      this.request<SiteResponse, HTTPValidationError>({
        path: `/api/v2/sites/${siteId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a site and its associated data. Access Control: - **Admins**: Can delete any site. - **Employees**: Can delete sites in projects they are assigned to. - **Users**: Can only delete sites in projects they own.
     *
     * @tags Sites
     * @name DeleteSiteApiV2SitesSiteIdDelete
     * @summary Delete a Site
     * @request DELETE:/api/v2/sites/{site_id}
     */
    deleteSiteApiV2SitesSiteIdDelete: (
      siteId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/api/v2/sites/${siteId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * @description Upload camera location data (zip file) for a specific site. Access Control: - **Admins**: Can add data to any site. - **Employees**: Can add data to sites in projects they are assigned to. - **Users**: Can only add data to sites in projects they own.
     *
     * @tags Sites
     * @name AddCameraLocationApiV2SitesSiteIdAddCameraLocationPut
     * @summary Add Camera Location Data to a Site
     * @request PUT:/api/v2/sites/{site_id}/add-camera-location
     */
    addCameraLocationApiV2SitesSiteIdAddCameraLocationPut: (
      siteId: string,
      data: BodyAddCameraLocationApiV2SitesSiteIdAddCameraLocationPut,
      params: RequestParams = {},
    ) =>
      this.request<SiteResponse, HTTPValidationError>({
        path: `/api/v2/sites/${siteId}/add-camera-location`,
        method: "PUT",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Upload audio location data (zip file) for a specific site. Access Control: - **Admins**: Can add data to any site. - **Employees**: Can add data to sites in projects they are assigned to. - **Users**: Can only add data to sites in projects they own.
     *
     * @tags Sites
     * @name AddAudioLocationApiV2SitesSiteIdAddAudioLocationPut
     * @summary Add Audio Location Data to a Site
     * @request PUT:/api/v2/sites/{site_id}/add-audio-location
     */
    addAudioLocationApiV2SitesSiteIdAddAudioLocationPut: (
      siteId: string,
      data: BodyAddAudioLocationApiV2SitesSiteIdAddAudioLocationPut,
      params: RequestParams = {},
    ) =>
      this.request<SiteResponse, HTTPValidationError>({
        path: `/api/v2/sites/${siteId}/add-audio-location`,
        method: "PUT",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve the Carbon Analysis summary for a specific project. Access Control: - **Admins**: Can access analysis for any project. - **Employees**: Can access analysis for projects they are assigned to. - **Users**: Can only access analysis for projects they own.
     *
     * @tags Analysis (Carbon)
     * @name ReadCarbonProjectSummaryApiV2ProjectsProjectIdCarbonSummaryGet
     * @summary Get Carbon Analysis Summary for a Project
     * @request GET:/api/v2/projects/{project_id}/carbon/summary
     */
    readCarbonProjectSummaryApiV2ProjectsProjectIdCarbonSummaryGet: (
      projectId: string,
      params: RequestParams = {},
    ) =>
      this.request<CarbonProjectAnalysis, HTTPValidationError>({
        path: `/api/v2/projects/${projectId}/carbon/summary`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve Carbon Analysis details for a specific site. Access Control: - **Admins**: Can access analysis for any site. - **Employees**: Can access analysis for sites in projects they are assigned to. - **Users**: Can only access analysis for sites in projects they own.
     *
     * @tags Analysis (Carbon)
     * @name ReadCarbonSiteDetailsApiV2SitesSiteIdCarbonGet
     * @summary Get Carbon Analysis for a Site
     * @request GET:/api/v2/sites/{site_id}/carbon
     */
    readCarbonSiteDetailsApiV2SitesSiteIdCarbonGet: (
      siteId: string,
      params: RequestParams = {},
    ) =>
      this.request<CarbonSiteAnalysis, HTTPValidationError>({
        path: `/api/v2/sites/${siteId}/carbon`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve Carbon Analysis details for all sites within a specific project. Access Control: - **Admins**: Can access analysis for any project. - **Employees**: Can access analysis for projects they are assigned to. - **Users**: Can only access analysis for projects they own.
     *
     * @tags Analysis (Carbon)
     * @name ReadCarbonAllSitesForProjectApiV2ProjectsProjectIdCarbonSitesGet
     * @summary Get Carbon Analysis for All Sites in a Project
     * @request GET:/api/v2/projects/{project_id}/carbon/sites
     */
    readCarbonAllSitesForProjectApiV2ProjectsProjectIdCarbonSitesGet: (
      projectId: string,
      params: RequestParams = {},
    ) =>
      this.request<CarbonSiteAnalysis[], HTTPValidationError>({
        path: `/api/v2/projects/${projectId}/carbon/sites`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve the Biodiversity Analysis summary for a specific project. Access Control: - **Admins**: Can access analysis for any project. - **Employees**: Can access analysis for projects they are assigned to. - **Users**: Can only access analysis for projects they own. - **DEV**: Can access analysis for projects assigned to them from their organization.
     *
     * @tags Analysis (Biodiversity)
     * @name ReadBiodiversityProjectSummaryApiV2ProjectsProjectIdBiodiversitySummaryGet
     * @summary Get Biodiversity Analysis Summary for a Project
     * @request GET:/api/v2/projects/{project_id}/biodiversity/summary
     */
    readBiodiversityProjectSummaryApiV2ProjectsProjectIdBiodiversitySummaryGet:
      (projectId: string, params: RequestParams = {}) =>
        this.request<BiodiversityProjectAnalysis, HTTPValidationError>({
          path: `/api/v2/projects/${projectId}/biodiversity/summary`,
          method: "GET",
          format: "json",
          ...params,
        }),

    /**
     * @description Retrieve Biodiversity Analysis details for a specific site. Access Control: - **Admins**: Can access analysis for any site. - **Employees**: Can access analysis for sites in projects they are assigned to. - **Users**: Can only access analysis for sites in projects they own. - **DEV**: Can access analysis for sites in projects assigned to them.
     *
     * @tags Analysis (Biodiversity)
     * @name ReadBiodiversitySiteDetailsApiV2SitesSiteIdBiodiversityGet
     * @summary Get Biodiversity Analysis for a Site
     * @request GET:/api/v2/sites/{site_id}/biodiversity
     */
    readBiodiversitySiteDetailsApiV2SitesSiteIdBiodiversityGet: (
      siteId: string,
      params: RequestParams = {},
    ) =>
      this.request<BiodiversitySiteAnalysis, HTTPValidationError>({
        path: `/api/v2/sites/${siteId}/biodiversity`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve Biodiversity Analysis details for all sites within a specific project. Access Control: - **Admins**: Can access analysis for any project. - **Employees**: Can access analysis for projects they are assigned to. - **Users**: Can only access analysis for projects they own. - **DEV**: Can access analysis for projects assigned to them.
     *
     * @tags Analysis (Biodiversity)
     * @name ReadBiodiversityAllSitesForProjectApiV2ProjectsProjectIdBiodiversitySitesGet
     * @summary Get Biodiversity Analysis for All Sites in a Project
     * @request GET:/api/v2/projects/{project_id}/biodiversity/sites
     */
    readBiodiversityAllSitesForProjectApiV2ProjectsProjectIdBiodiversitySitesGet:
      (projectId: string, params: RequestParams = {}) =>
        this.request<BiodiversitySiteAnalysis[], HTTPValidationError>({
          path: `/api/v2/projects/${projectId}/biodiversity/sites`,
          method: "GET",
          format: "json",
          ...params,
        }),

    /**
     * @description Retrieve the in-situ species conservation status distribution for a project. Behavior: - Validate user authorization and project access. - Ensure biodiversity module is enabled for the project. - Attempt to fetch precomputed in-situ species distribution from BiodiversityProjectAnalysis table. - If distribution exists, return the stored value. - If not stored, compute the distribution dynamically from available in-situ summaries (without persisting it).
     *
     * @tags Analysis (Biodiversity)
     * @name ReadBiodiversityInsituSummaryApiV2ProjectsProjectIdBiodiversityInsituSummaryGet
     * @summary Get In-situ Species Distribution for a Project
     * @request GET:/api/v2/projects/{project_id}/biodiversity/insitu-summary
     */
    readBiodiversityInsituSummaryApiV2ProjectsProjectIdBiodiversityInsituSummaryGet:
      (projectId: string, params: RequestParams = {}) =>
        this.request<SpeciesDistribution, HTTPValidationError>({
          path: `/api/v2/projects/${projectId}/biodiversity/insitu-summary`,
          method: "GET",
          format: "json",
          ...params,
        }),

    /**
     * @description Retrieve the in-situ species conservation status distribution for a site. Behavior: - Validate user authorization and site access. - Ensure biodiversity module is enabled for the parent project. - Attempt to fetch precomputed in-situ species distribution from BiodiversitySiteAnalysis table. - If distribution exists, return the stored value. - If not stored, compute the distribution dynamically from available in-situ summaries (without persisting it).
     *
     * @tags Analysis (Biodiversity)
     * @name ReadBiodiversityInsituSummaryForSiteApiV2SitesSiteIdBiodiversityInsituSummaryGet
     * @summary Get In-situ Species Distribution for a Site
     * @request GET:/api/v2/sites/{site_id}/biodiversity/insitu-summary
     */
    readBiodiversityInsituSummaryForSiteApiV2SitesSiteIdBiodiversityInsituSummaryGet:
      (siteId: string, params: RequestParams = {}) =>
        this.request<SpeciesDistribution, HTTPValidationError>({
          path: `/api/v2/sites/${siteId}/biodiversity/insitu-summary`,
          method: "GET",
          format: "json",
          ...params,
        }),

    /**
     * @description Retrieve top audio clips for a project grouped by species. Behavior: - Fetch all high-value clips for the project. - Normalize clip fields. - Group clips by scientific_name (species string). - For each species, sort clips by confidence (desc) and return up to 10 clips.
     *
     * @tags Analysis (Biodiversity)
     * @name GetTopUniqueSpeciesClipsApiV2ProjectsProjectIdBiodiversityAudioClipsGet
     * @summary Get Top 10 Unique Species Audio Clips for a Project
     * @request GET:/api/v2/projects/{project_id}/biodiversity/audio-clips
     */
    getTopUniqueSpeciesClipsApiV2ProjectsProjectIdBiodiversityAudioClipsGet: (
      projectId: string,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, HighValueClip[]>, HTTPValidationError>({
        path: `/api/v2/projects/${projectId}/biodiversity/audio-clips`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve the top 10 high-value audio clips for a site.
     *
     * @tags Analysis (Biodiversity)
     * @name GetSiteTopUniqueSpeciesClipsApiV2SitesSiteIdBiodiversityAudioClipsGet
     * @summary Get Top 10 Unique Species Audio Clips for a Site
     * @request GET:/api/v2/sites/{site_id}/biodiversity/audio-clips
     */
    getSiteTopUniqueSpeciesClipsApiV2SitesSiteIdBiodiversityAudioClipsGet: (
      siteId: string,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, HighValueClip[]>, HTTPValidationError>({
        path: `/api/v2/sites/${siteId}/biodiversity/audio-clips`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve the Environmental Analysis summary for a specific project. Access Control: - **Admins**: Can access analysis for any project. - **Employees**: Can access analysis for projects they are assigned to. - **Users**: Can only access analysis for projects they own. - **DEV**: Can access analysis for projects assigned to them.
     *
     * @tags Analysis (Environmental)
     * @name ReadEnvironmentalProjectSummaryApiV2ProjectsProjectIdEnvironmentalSummaryGet
     * @summary Get Environmental Analysis Summary for a Project
     * @request GET:/api/v2/projects/{project_id}/environmental/summary
     */
    readEnvironmentalProjectSummaryApiV2ProjectsProjectIdEnvironmentalSummaryGet:
      (projectId: string, params: RequestParams = {}) =>
        this.request<EnvironmentalProjectAnalysis, HTTPValidationError>({
          path: `/api/v2/projects/${projectId}/environmental/summary`,
          method: "GET",
          format: "json",
          ...params,
        }),

    /**
     * @description Retrieve Environmental Analysis details for a specific site. Access Control: - **Admins**: Can access analysis for any site. - **Employees**: Can access analysis for sites in projects they are assigned to. - **Users**: Can only access analysis for sites in projects they own. - **DEV**: Can access analysis for sites in projects assigned to them.
     *
     * @tags Analysis (Environmental)
     * @name ReadEnvironmentalSiteDetailsApiV2SitesSiteIdEnvironmentalGet
     * @summary Get Environmental Analysis for a Site
     * @request GET:/api/v2/sites/{site_id}/environmental
     */
    readEnvironmentalSiteDetailsApiV2SitesSiteIdEnvironmentalGet: (
      siteId: string,
      params: RequestParams = {},
    ) =>
      this.request<EnvironmentalSiteAnalysis, HTTPValidationError>({
        path: `/api/v2/sites/${siteId}/environmental`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve Environmental Analysis details for all sites within a specific project. Access Control: - **Admins**: Can access analysis for any project. - **Employees**: Can access analysis for projects they are assigned to. - **Users**: Can only access analysis for projects they own. - **DEV**: Can access analysis for projects assigned to them.
     *
     * @tags Analysis (Environmental)
     * @name ReadEnvironmentalAllSitesForProjectApiV2ProjectsProjectIdEnvironmentalSitesGet
     * @summary Get Environmental Analysis for All Sites in a Project
     * @request GET:/api/v2/projects/{project_id}/environmental/sites
     */
    readEnvironmentalAllSitesForProjectApiV2ProjectsProjectIdEnvironmentalSitesGet:
      (projectId: string, params: RequestParams = {}) =>
        this.request<EnvironmentalSiteAnalysis[], HTTPValidationError>({
          path: `/api/v2/projects/${projectId}/environmental/sites`,
          method: "GET",
          format: "json",
          ...params,
        }),

    /**
     * @description Request a password reset link to be sent to the user's email.
     *
     * @tags Password
     * @name RequestPasswordResetApiV2RequestPasswordResetPost
     * @summary Request Password Reset
     * @request POST:/api/v2/request-password-reset
     */
    requestPasswordResetApiV2RequestPasswordResetPost: (
      data: RequestPasswordResetRequest,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/api/v2/request-password-reset`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Verify that the password reset token is valid and not expired.
     *
     * @tags Password
     * @name VerifyPasswordResetLinkApiV2VerifyPasswordLinkPost
     * @summary Verify Password Reset Link
     * @request POST:/api/v2/verify-password-link
     */
    verifyPasswordResetLinkApiV2VerifyPasswordLinkPost: (
      data: VerifyPasswordLinkRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/v2/verify-password-link`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Reset the user's password using a valid password reset token.
     *
     * @tags Password
     * @name ResetUserPasswordApiV2ResetPasswordPost
     * @summary Reset User Password
     * @request POST:/api/v2/reset-password
     */
    resetUserPasswordApiV2ResetPasswordPost: (
      data: ResetPasswordRequest,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/api/v2/reset-password`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organisations
     * @name CreateOrganisationApiV2OrganisationsPost
     * @summary Create Organisation
     * @request POST:/api/v2/organisations
     */
    createOrganisationApiV2OrganisationsPost: (
      data: OrganisationCreate,
      params: RequestParams = {},
    ) =>
      this.request<OrganisationResponse, HTTPValidationError>({
        path: `/api/v2/organisations`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organisations
     * @name ListOrganisationsApiV2OrganisationsGet
     * @summary List Organisations
     * @request GET:/api/v2/organisations
     */
    listOrganisationsApiV2OrganisationsGet: (
      query?: {
        /**
         * Skip
         * @min 0
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @min 1
         * @max 500
         * @default 100
         */
        limit?: number;
        /** Status */
        status?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<OrganisationList, HTTPValidationError>({
        path: `/api/v2/organisations`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organisations
     * @name GetOrganisationApiV2OrganisationsOrgIdGet
     * @summary Get Organisation
     * @request GET:/api/v2/organisations/{org_id}
     */
    getOrganisationApiV2OrganisationsOrgIdGet: (
      orgId: string,
      params: RequestParams = {},
    ) =>
      this.request<OrganisationResponse, HTTPValidationError>({
        path: `/api/v2/organisations/${orgId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organisations
     * @name UpdateOrganisationApiV2OrganisationsOrgIdPatch
     * @summary Update Organisation
     * @request PATCH:/api/v2/organisations/{org_id}
     */
    updateOrganisationApiV2OrganisationsOrgIdPatch: (
      orgId: string,
      data: OrganisationUpdate,
      params: RequestParams = {},
    ) =>
      this.request<OrganisationResponse, HTTPValidationError>({
        path: `/api/v2/organisations/${orgId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organisations
     * @name SuspendOrganisationApiV2OrganisationsOrgIdSuspendPatch
     * @summary Suspend Organisation
     * @request PATCH:/api/v2/organisations/{org_id}/suspend
     */
    suspendOrganisationApiV2OrganisationsOrgIdSuspendPatch: (
      orgId: string,
      params: RequestParams = {},
    ) =>
      this.request<OrganisationResponse, HTTPValidationError>({
        path: `/api/v2/organisations/${orgId}/suspend`,
        method: "PATCH",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organisations
     * @name ActivateOrganisationApiV2OrganisationsOrgIdActivatePatch
     * @summary Activate Organisation
     * @request PATCH:/api/v2/organisations/{org_id}/activate
     */
    activateOrganisationApiV2OrganisationsOrgIdActivatePatch: (
      orgId: string,
      params: RequestParams = {},
    ) =>
      this.request<OrganisationResponse, HTTPValidationError>({
        path: `/api/v2/organisations/${orgId}/activate`,
        method: "PATCH",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organisation Members
     * @name AddOrganisationMemberApiV2OrganisationsOrgIdMembersPost
     * @summary Add Organisation Member
     * @request POST:/api/v2/organisations/{org_id}/members
     */
    addOrganisationMemberApiV2OrganisationsOrgIdMembersPost: (
      orgId: string,
      data: OrgMemberAdd,
      params: RequestParams = {},
    ) =>
      this.request<OrgMemberResponse, HTTPValidationError>({
        path: `/api/v2/organisations/${orgId}/members`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organisation Members
     * @name ListOrganisationMembersApiV2OrganisationsOrgIdMembersGet
     * @summary List Organisation Members
     * @request GET:/api/v2/organisations/{org_id}/members
     */
    listOrganisationMembersApiV2OrganisationsOrgIdMembersGet: (
      orgId: string,
      query?: {
        /** Role */
        role?: string | null;
        /** Status */
        status?: string | null;
        /**
         * Skip
         * @min 0
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @min 1
         * @max 500
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<OrgMemberList, HTTPValidationError>({
        path: `/api/v2/organisations/${orgId}/members`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organisation Members
     * @name GetMyOrgMembershipApiV2OrgMembersMeGet
     * @summary Get My Org Membership
     * @request GET:/api/v2/org-members/me
     */
    getMyOrgMembershipApiV2OrgMembersMeGet: (params: RequestParams = {}) =>
      this.request<OrgMemberResponse, any>({
        path: `/api/v2/org-members/me`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organisation Members
     * @name UpdateOrgMemberRoleApiV2OrgMembersOrgMemberIdRolePatch
     * @summary Update Org Member Role
     * @request PATCH:/api/v2/org-members/{org_member_id}/role
     */
    updateOrgMemberRoleApiV2OrgMembersOrgMemberIdRolePatch: (
      orgMemberId: string,
      data: OrgMemberRoleUpdate,
      params: RequestParams = {},
    ) =>
      this.request<OrgMemberResponse, HTTPValidationError>({
        path: `/api/v2/org-members/${orgMemberId}/role`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organisation Members
     * @name SuspendOrgMemberApiV2OrgMembersOrgMemberIdSuspendPatch
     * @summary Suspend Org Member
     * @request PATCH:/api/v2/org-members/{org_member_id}/suspend
     */
    suspendOrgMemberApiV2OrgMembersOrgMemberIdSuspendPatch: (
      orgMemberId: string,
      params: RequestParams = {},
    ) =>
      this.request<OrgMemberResponse, HTTPValidationError>({
        path: `/api/v2/org-members/${orgMemberId}/suspend`,
        method: "PATCH",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organisation Members
     * @name ActivateOrgMemberApiV2OrgMembersOrgMemberIdActivatePatch
     * @summary Activate Org Member
     * @request PATCH:/api/v2/org-members/{org_member_id}/activate
     */
    activateOrgMemberApiV2OrgMembersOrgMemberIdActivatePatch: (
      orgMemberId: string,
      params: RequestParams = {},
    ) =>
      this.request<OrgMemberResponse, HTTPValidationError>({
        path: `/api/v2/org-members/${orgMemberId}/activate`,
        method: "PATCH",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organisation Members
     * @name DeleteOrgMemberApiV2OrgMembersOrgMemberIdDelete
     * @summary Delete Org Member
     * @request DELETE:/api/v2/org-members/{org_member_id}
     */
    deleteOrgMemberApiV2OrgMembersOrgMemberIdDelete: (
      orgMemberId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/v2/org-members/${orgMemberId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Retrieve a list of projects for the admin dashboard. Access Control: - **Admins**: Retrieve all projects in the system. - **Employees**: Retrieve only projects they are assigned to.
     *
     * @tags Admin (Projects)
     * @name GetAllProjectsAdminApiV2AdminProjectsGet
     * @summary List Projects (Admin/Employee)
     * @request GET:/api/v2/admin/projects
     */
    getAllProjectsAdminApiV2AdminProjectsGet: (params: RequestParams = {}) =>
      this.request<ProjectAdminSummary[], any>({
        path: `/api/v2/admin/projects`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve detailed information for a specific project, including its sites. Access Control: - **Admins / Employees**: Can retrieve details for any project they have access to view.
     *
     * @tags Admin (Projects)
     * @name GetProjectDetailsAdminApiV2AdminProjectsProjectIdGet
     * @summary Get Project Details (Admin/Employee)
     * @request GET:/api/v2/admin/projects/{project_id}
     */
    getProjectDetailsAdminApiV2AdminProjectsProjectIdGet: (
      projectId: string,
      params: RequestParams = {},
    ) =>
      this.request<ProjectAdminDetail, HTTPValidationError>({
        path: `/api/v2/admin/projects/${projectId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update project details from the admin interface.
     *
     * @tags Admin (Projects)
     * @name UpdateProjectAdminApiV2AdminProjectsProjectIdPatch
     * @summary Update Project details (Admin/Employee)
     * @request PATCH:/api/v2/admin/projects/{project_id}
     */
    updateProjectAdminApiV2AdminProjectsProjectIdPatch: (
      projectId: string,
      data: ProjectUpdate,
      params: RequestParams = {},
    ) =>
      this.request<ProjectAdminDetail, HTTPValidationError>({
        path: `/api/v2/admin/projects/${projectId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve detailed information for a specific site, including locations and deployments. Access Control: - **Admins / Employees**: Can retrieve details for any site they have access to view.
     *
     * @tags Admin (Sites)
     * @name GetSiteDetailsAdminApiV2AdminSitesSiteIdGet
     * @summary Get Site Details (Admin/Employee)
     * @request GET:/api/v2/admin/sites/{site_id}
     */
    getSiteDetailsAdminApiV2AdminSitesSiteIdGet: (
      siteId: string,
      params: RequestParams = {},
    ) =>
      this.request<SiteAdminDetail, HTTPValidationError>({
        path: `/api/v2/admin/sites/${siteId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve details of a specific deployment, including files, site, and project. Access Control: - **Admins / Employees**: Can retrieve details for any deployment they have access to view. - **Field Workers**: Can retrieve details for any deployment they have access to view.
     *
     * @tags Deployments
     * @name GetDeploymentDetailsAdminApiV2AdminDeploymentsDeploymentIdGet
     * @summary Get Deployment Details (Admin/Employee/FieldWorker)
     * @request GET:/api/v2/admin/deployments/{deployment_id}
     */
    getDeploymentDetailsAdminApiV2AdminDeploymentsDeploymentIdGet: (
      deploymentId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        AppSchemasDeploymentDeploymentDetailResponse,
        HTTPValidationError
      >({
        path: `/api/v2/admin/deployments/${deploymentId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update an existing deployment record. Access Control: - Admins and Employees can update all fields. - FieldWorkers can only update status to 'Deployed' or 'Retrieved'.
     *
     * @tags Deployments
     * @name UpdateApiDeploymentApiV2AdminDeploymentsDeploymentIdPut
     * @summary Update a Deployment (Admin/Employee/FieldWorker)
     * @request PUT:/api/v2/admin/deployments/{deployment_id}
     */
    updateApiDeploymentApiV2AdminDeploymentsDeploymentIdPut: (
      deploymentId: string,
      data: AppSchemasDeploymentDeploymentUpdate,
      params: RequestParams = {},
    ) =>
      this.request<
        AppSchemasDeploymentDeploymentAdminDetailBase,
        HTTPValidationError
      >({
        path: `/api/v2/admin/deployments/${deploymentId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a deployment and all its children. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Deployments
     * @name DeleteApiDeploymentApiV2AdminDeploymentsDeploymentIdDelete
     * @summary Delete a Deployment (Admin/Employee)
     * @request DELETE:/api/v2/admin/deployments/{deployment_id}
     */
    deleteApiDeploymentApiV2AdminDeploymentsDeploymentIdDelete: (
      deploymentId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/v2/admin/deployments/${deploymentId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Retrieve a list of all deployments with detailed information. Access Control: - **Admins**: Retrieve all deployments in the system. - **Employees**: Retrieve only deployments from projects they are assigned to. - **Users**: Retrieve only deployments from projects they created.
     *
     * @tags Admin (Deployments)
     * @name GetAllDeploymentsApiV2AdminDeploymentsGet
     * @summary List All Deployments (Admin/Employee)
     * @request GET:/api/v2/admin/deployments
     */
    getAllDeploymentsApiV2AdminDeploymentsGet: (params: RequestParams = {}) =>
      this.request<AppSchemasAdminDeploymentAdminListDetail[], any>({
        path: `/api/v2/admin/deployments`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new deployment record. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Admin (Deployments)
     * @name CreateApiDeploymentApiV2AdminDeploymentsPost
     * @summary Create a New Deployment (Admin/Employee)
     * @request POST:/api/v2/admin/deployments
     */
    createApiDeploymentApiV2AdminDeploymentsPost: (
      data: AppSchemasAdminDeploymentCreate,
      params: RequestParams = {},
    ) =>
      this.request<
        AppSchemasAdminDeploymentAdminDetailBase,
        HTTPValidationError
      >({
        path: `/api/v2/admin/deployments`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Create or partial update deployment info.
     *
     * @tags Deployments
     * @name CreateOrUpdateDeploymentInfoApiApiV2AdminDeploymentsDeploymentIdInfoPost
     * @summary Create or Update Deployment Info
     * @request POST:/api/v2/admin/deployments/{deployment_id}/info
     */
    createOrUpdateDeploymentInfoApiApiV2AdminDeploymentsDeploymentIdInfoPost: (
      deploymentId: string,
      data: DeploymentInfoUpdate,
      params: RequestParams = {},
    ) =>
      this.request<DeploymentInfo, HTTPValidationError>({
        path: `/api/v2/admin/deployments/${deploymentId}/info`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve info for a specific deployment.
     *
     * @tags Deployments
     * @name GetDeploymentInfoApiApiV2AdminDeploymentsDeploymentIdInfoGet
     * @summary Get Deployment Info (Admin/Employee/FieldWorker)
     * @request GET:/api/v2/admin/deployments/{deployment_id}/info
     */
    getDeploymentInfoApiApiV2AdminDeploymentsDeploymentIdInfoGet: (
      deploymentId: string,
      params: RequestParams = {},
    ) =>
      this.request<DeploymentInfo, HTTPValidationError>({
        path: `/api/v2/admin/deployments/${deploymentId}/info`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update only the is_predeployment_complete flag.
     *
     * @tags Deployments
     * @name UpdatePredeploymentStatusApiApiV2AdminDeploymentsDeploymentIdPredeploymentStatusPatch
     * @summary Update Pre-deployment Completion Status
     * @request PATCH:/api/v2/admin/deployments/{deployment_id}/predeployment-status
     */
    updatePredeploymentStatusApiApiV2AdminDeploymentsDeploymentIdPredeploymentStatusPatch:
      (
        deploymentId: string,
        data: PredeploymentStatusUpdate,
        params: RequestParams = {},
      ) =>
        this.request<DeploymentInfo, HTTPValidationError>({
          path: `/api/v2/admin/deployments/${deploymentId}/predeployment-status`,
          method: "PATCH",
          body: data,
          type: ContentType.Json,
          format: "json",
          ...params,
        }),

    /**
     * @description Create or update retrieval info for a deployment.
     *
     * @tags Deployments
     * @name CreateOrUpdateRetrievalInfoApiApiV2AdminDeploymentsDeploymentIdRetrievalPost
     * @summary Create or Update Retrieval Info
     * @request POST:/api/v2/admin/deployments/{deployment_id}/retrieval
     */
    createOrUpdateRetrievalInfoApiApiV2AdminDeploymentsDeploymentIdRetrievalPost:
      (
        deploymentId: string,
        data: RetrievalInfoUpdate,
        params: RequestParams = {},
      ) =>
        this.request<RetrievalInfo, HTTPValidationError>({
          path: `/api/v2/admin/deployments/${deploymentId}/retrieval`,
          method: "POST",
          body: data,
          type: ContentType.Json,
          format: "json",
          ...params,
        }),

    /**
     * @description Retrieve retrieval data for a specific deployment.
     *
     * @tags Deployments
     * @name GetRetrievalInfoApiApiV2AdminDeploymentsDeploymentIdRetrievalGet
     * @summary Get Retrieval Info (Admin/Employee/FieldWorker)
     * @request GET:/api/v2/admin/deployments/{deployment_id}/retrieval
     */
    getRetrievalInfoApiApiV2AdminDeploymentsDeploymentIdRetrievalGet: (
      deploymentId: string,
      params: RequestParams = {},
    ) =>
      this.request<RetrievalInfo, HTTPValidationError>({
        path: `/api/v2/admin/deployments/${deploymentId}/retrieval`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve both deployment and retrieval info side-by-side for comparison.
     *
     * @tags Deployments
     * @name GetDeploymentComparisonApiApiV2AdminDeploymentsDeploymentIdComparisonGet
     * @summary Get Deployment vs Retrieval Comparison (Admin/Employee/FieldWorker)
     * @request GET:/api/v2/admin/deployments/{deployment_id}/comparison
     */
    getDeploymentComparisonApiApiV2AdminDeploymentsDeploymentIdComparisonGet: (
      deploymentId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        AppSchemasDeploymentDataDeploymentComparison,
        HTTPValidationError
      >({
        path: `/api/v2/admin/deployments/${deploymentId}/comparison`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Generate a secure signed URL for assessment photos (deployment/retrieval). The server constructs the GCS path to prevent unauthorized bucket access.
     *
     * @tags Deployments
     * @name GetAssessmentMediaSignedUrlApiApiV2AdminDeploymentsDeploymentIdAssessmentMediaUrlPost
     * @summary Generate Secure Presigned URL for Assessment Media
     * @request POST:/api/v2/admin/deployments/{deployment_id}/assessment-media-url
     */
    getAssessmentMediaSignedUrlApiApiV2AdminDeploymentsDeploymentIdAssessmentMediaUrlPost:
      (
        deploymentId: string,
        data: AssessmentMediaUploadRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, HTTPValidationError>({
          path: `/api/v2/admin/deployments/${deploymentId}/assessment-media-url`,
          method: "POST",
          body: data,
          type: ContentType.Json,
          format: "json",
          ...params,
        }),

    /**
     * @description Generate a secure signed URL for downloading/viewing assessment photos.
     *
     * @tags Admin (Deployments)
     * @name GetAssessmentMediaDownloadUrlApiApiV2AdminDeploymentsDeploymentIdAssessmentMediaDownloadUrlPost
     * @summary Generate Secure Presigned Download URL for Assessment Media
     * @request POST:/api/v2/admin/deployments/{deployment_id}/assessment-media-download-url
     */
    getAssessmentMediaDownloadUrlApiApiV2AdminDeploymentsDeploymentIdAssessmentMediaDownloadUrlPost:
      (
        deploymentId: string,
        data: AssessmentMediaDownloadRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, HTTPValidationError>({
          path: `/api/v2/admin/deployments/${deploymentId}/assessment-media-download-url`,
          method: "POST",
          body: data,
          type: ContentType.Json,
          format: "json",
          ...params,
        }),

    /**
     * @description Retrieve all deployments for a specific location. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Admin (Deployments)
     * @name GetDeploymentsByLocationIdApiV2AdminLocationsLocationIdDeploymentsGet
     * @summary List Deployments for a Location (Admin/Employee/FieldWorker)
     * @request GET:/api/v2/admin/locations/{location_id}/deployments
     */
    getDeploymentsByLocationIdApiV2AdminLocationsLocationIdDeploymentsGet: (
      locationId: string,
      params: RequestParams = {},
    ) =>
      this.request<AppSchemasAdminDeploymentAdminDetail[], HTTPValidationError>(
        {
          path: `/api/v2/admin/locations/${locationId}/deployments`,
          method: "GET",
          format: "json",
          ...params,
        },
      ),

    /**
     * @description Create a new location within a site. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Admin (Locations)
     * @name CreateApiLocationApiV2AdminLocationsPost
     * @summary Create a New Location (Admin/Employee)
     * @request POST:/api/v2/admin/locations
     */
    createApiLocationApiV2AdminLocationsPost: (
      data: LocationCreate,
      params: RequestParams = {},
    ) =>
      this.request<LocationAdminDetail, HTTPValidationError>({
        path: `/api/v2/admin/locations`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update an existing location. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Locations
     * @name UpdateApiLocationApiV2AdminLocationsLocationIdPut
     * @summary Update a Location (Admin/Employee)
     * @request PUT:/api/v2/admin/locations/{location_id}
     */
    updateApiLocationApiV2AdminLocationsLocationIdPut: (
      locationId: string,
      data: LocationUpdate,
      params: RequestParams = {},
    ) =>
      this.request<LocationAdminDetail, HTTPValidationError>({
        path: `/api/v2/admin/locations/${locationId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a location and all its children (deployments). Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Locations
     * @name DeleteApiLocationApiV2AdminLocationsLocationIdDelete
     * @summary Delete a Location (Admin/Employee)
     * @request DELETE:/api/v2/admin/locations/{location_id}
     */
    deleteApiLocationApiV2AdminLocationsLocationIdDelete: (
      locationId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/v2/admin/locations/${locationId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Retrieve all devices in the system. For each device, add deployment_id if the device is in an active deployment. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Admin (Devices)
     * @name GetAllDevicesAdminApiV2AdminDevicesGet
     * @summary List All Devices (Admin/Employee)
     * @request GET:/api/v2/admin/devices
     */
    getAllDevicesAdminApiV2AdminDevicesGet: (params: RequestParams = {}) =>
      this.request<DeviceAdminDetailWithDeployment[], any>({
        path: `/api/v2/admin/devices`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new device record. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Admin (Devices)
     * @name CreateApiDeviceApiV2AdminDevicesPost
     * @summary Create a New Device (Admin/Employee)
     * @request POST:/api/v2/admin/devices
     */
    createApiDeviceApiV2AdminDevicesPost: (
      data: DeviceCreate,
      params: RequestParams = {},
    ) =>
      this.request<DeviceAdminDetail, HTTPValidationError>({
        path: `/api/v2/admin/devices`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update an existing device record. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Admin (Devices)
     * @name UpdateApiDeviceApiV2AdminDevicesDeviceIdPut
     * @summary Update a Device (Admin/Employee)
     * @request PUT:/api/v2/admin/devices/{device_id}
     */
    updateApiDeviceApiV2AdminDevicesDeviceIdPut: (
      deviceId: string,
      data: DeviceUpdate,
      params: RequestParams = {},
    ) =>
      this.request<DeviceAdminDetail, HTTPValidationError>({
        path: `/api/v2/admin/devices/${deviceId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retire a device record by setting its status to 'RETIRED'. This preserves the device's data for historical purposes instead of permanent deletion. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Admin (Devices)
     * @name DeleteApiDeviceApiV2AdminDevicesDeviceIdDelete
     * @summary Retire a Device (Admin/Employee)
     * @request DELETE:/api/v2/admin/devices/{device_id}
     */
    deleteApiDeviceApiV2AdminDevicesDeviceIdDelete: (
      deviceId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/v2/admin/devices/${deviceId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Generate a signed URL for uploading a file to Google Cloud Storage. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Admin (Files)
     * @name GenerateUploadUrlApiV2AdminFilesGenerateUploadUrlPost
     * @summary Generate GCS Upload URL (Admin/Employee)
     * @request POST:/api/v2/admin/files/generate-upload-url
     */
    generateUploadUrlApiV2AdminFilesGenerateUploadUrlPost: (
      data: FileUploadRequest,
      params: RequestParams = {},
    ) =>
      this.request<FileUploadResponse, HTTPValidationError>({
        path: `/api/v2/admin/files/generate-upload-url`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Finalize a file upload: - Synchronously create the file record. - Run deployment/location lookup, lat/lon decoding, inference, spectrogram, and acoustic metrics in a background task.
     *
     * @tags Admin (Files)
     * @name FinalizeUploadApiV2AdminFilesFinalizeUploadPost
     * @summary Finalize File Upload (Admin/Employee)
     * @request POST:/api/v2/admin/files/finalize-upload
     */
    finalizeUploadApiV2AdminFilesFinalizeUploadPost: (
      data: FileFinalizeRequest,
      params: RequestParams = {},
    ) =>
      this.request<FileAdminDetailWithUser, HTTPValidationError>({
        path: `/api/v2/admin/files/finalize-upload`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Generate signed GCS upload URLs for a batch of files in a single request. Runs the 4 DB lookups (deployment → location → site → project) exactly ONCE regardless of how many files are in the batch. Previously this was called N times (once per file), causing N×4 redundant DB queries. The frontend should: 1. Call this endpoint once with all file names. 2. Upload each file directly to its signed URL (GCS, no backend involved). 3. Call /files/finalize-uploads once with all gcs_paths.
     *
     * @tags Admin (Files)
     * @name BatchGenerateUploadUrlsApiV2AdminFilesGenerateUploadUrlsPost
     * @summary Batch Generate GCS Upload URLs (Admin/Employee)
     * @request POST:/api/v2/admin/files/generate-upload-urls
     */
    batchGenerateUploadUrlsApiV2AdminFilesGenerateUploadUrlsPost: (
      data: BatchFileUploadRequest,
      params: RequestParams = {},
    ) =>
      this.request<BatchFileUploadResponseItem[], HTTPValidationError>({
        path: `/api/v2/admin/files/generate-upload-urls`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Finalize a batch of file uploads in a single request. - 1 bulk INSERT for all file records. - Cloud Tasks created concurrently via asyncio.gather (non-blocking).
     *
     * @tags Admin (Files)
     * @name BatchFinalizeUploadsApiV2AdminFilesFinalizeUploadsPost
     * @summary Batch Finalize File Uploads (Admin/Employee)
     * @request POST:/api/v2/admin/files/finalize-uploads
     */
    batchFinalizeUploadsApiV2AdminFilesFinalizeUploadsPost: (
      data: BatchFileFinalizeRequest,
      params: RequestParams = {},
    ) =>
      this.request<BatchFileFinalizeResponse, HTTPValidationError>({
        path: `/api/v2/admin/files/finalize-uploads`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve all files for a specific deployment with uploader details. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Admin (Files)
     * @name GetFilesForDeploymentApiV2AdminFilesDeploymentIdGet
     * @summary List Files for a Deployment (Admin/Employee)
     * @request GET:/api/v2/admin/files/{deployment_id}
     */
    getFilesForDeploymentApiV2AdminFilesDeploymentIdGet: (
      deploymentId: string,
      params: RequestParams = {},
    ) =>
      this.request<FileAdminDetailWithUser[], HTTPValidationError>({
        path: `/api/v2/admin/files/${deploymentId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve files for a deployment that do not have an inference record. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Admin (Files)
     * @name GetFilesForDeploymentForInferenceApiV2AdminFilesDeploymentIdInferenceGet
     * @summary List Files Needing Inference (Admin/Employee)
     * @request GET:/api/v2/admin/files/{deployment_id}/inference
     */
    getFilesForDeploymentForInferenceApiV2AdminFilesDeploymentIdInferenceGet: (
      deploymentId: string,
      params: RequestParams = {},
    ) =>
      this.request<FileAdminDetailWithLocation[], HTTPValidationError>({
        path: `/api/v2/admin/files/${deploymentId}/inference`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Generate a signed URL for downloading a file from Google Cloud Storage. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Admin (Files)
     * @name GetDownloadUrlApiV2AdminFilesFileIdDownloadUrlGet
     * @summary Generate GCS Download URL (Admin/Employee)
     * @request GET:/api/v2/admin/files/{file_id}/download-url
     */
    getDownloadUrlApiV2AdminFilesFileIdDownloadUrlGet: (
      fileId: string,
      params: RequestParams = {},
    ) =>
      this.request<FileDownloadResponse, HTTPValidationError>({
        path: `/api/v2/admin/files/${fileId}/download-url`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Generate a signed URL for downloading a spectrogram from Google Cloud Storage. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Admin (Files)
     * @name GetSpectrogramUrlApiV2AdminFilesFileIdSpectrogramUrlGet
     * @summary Generate GCS Spectrogram Download URL
     * @request GET:/api/v2/admin/files/{file_id}/spectrogram-url
     */
    getSpectrogramUrlApiV2AdminFilesFileIdSpectrogramUrlGet: (
      fileId: string,
      params: RequestParams = {},
    ) =>
      this.request<FileDownloadResponse, HTTPValidationError>({
        path: `/api/v2/admin/files/${fileId}/spectrogram-url`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a file record and its object in GCS. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Admin (Files)
     * @name DeleteApiFileApiV2AdminFilesFileIdDelete
     * @summary Delete a File (Admin/Employee)
     * @request DELETE:/api/v2/admin/files/{file_id}
     */
    deleteApiFileApiV2AdminFilesFileIdDelete: (
      fileId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/v2/admin/files/${fileId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Retrieve a list of users with optional filtering, pagination, and sorting. Access Control: - Requires **Admin** role.
     *
     * @tags Admin (Users)
     * @name ListUsersApiV2AdminUsersGet
     * @summary List and Filter Users (Admin Only)
     * @request GET:/api/v2/admin/users
     */
    listUsersApiV2AdminUsersGet: (
      query?: {
        /**
         * Sort By
         * @default "created_at"
         */
        sort_by?: string;
        /**
         * Sort Order
         * @default "desc"
         */
        sort_order?: string;
        /**
         * Page
         * @default 1
         */
        page?: number;
        /**
         * Per Page
         * @default 10
         */
        per_page?: number;
        /** Query */
        query?: string | null;
        /** Role */
        role?: UserRole | null;
        /** Status */
        status?: string | null;
        /** Is Email Verified */
        is_email_verified?: boolean | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserQueryResult, HTTPValidationError>({
        path: `/api/v2/admin/users`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve details of a specific user by ID. Access Control: - Requires **Admin** role.
     *
     * @tags Admin (Users)
     * @name GetUserByIdApiV2AdminUsersUserIdGet
     * @summary Get User by ID (Admin Only)
     * @request GET:/api/v2/admin/users/{user_id}
     */
    getUserByIdApiV2AdminUsersUserIdGet: (
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<UserResponse, HTTPValidationError>({
        path: `/api/v2/admin/users/${userId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update an existing user's details, including role and status. Access Control: - Requires **Admin** role.
     *
     * @tags Admin (Users)
     * @name UpdateUserApiV2AdminUsersUserIdPatch
     * @summary Update a User (Admin Only)
     * @request PATCH:/api/v2/admin/users/{user_id}
     */
    updateUserApiV2AdminUsersUserIdPatch: (
      userId: string,
      data: UserUpdate,
      params: RequestParams = {},
    ) =>
      this.request<UserResponse, HTTPValidationError>({
        path: `/api/v2/admin/users/${userId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a user from the system. **Warning**: Deleting a user will permanently delete: - All projects owned by the user (including sites, locations, deployments, analysis data) - All assignments where the user is assigned - All API keys and permissions associated with the user Access Control: - Requires **Admin** role. Parameters: - **force**: If False (default), deletion will be prevented if user owns projects. If True, deletion will proceed even if user owns projects (with warning logged).
     *
     * @tags Admin (Users)
     * @name DeleteUserApiV2AdminUsersUserIdDelete
     * @summary Delete a User (Admin Only)
     * @request DELETE:/api/v2/admin/users/{user_id}
     */
    deleteUserApiV2AdminUsersUserIdDelete: (
      userId: string,
      query?: {
        /**
         * Force
         * Force deletion even if user owns projects
         * @default false
         */
        force?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserResponse, HTTPValidationError>({
        path: `/api/v2/admin/users/${userId}`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Generate a signed URL for uploading a media file for a project.
     *
     * @tags Admin (Project Media)
     * @name GenerateProjectMediaUploadUrlApiV2AdminProjectMediaGenerateUploadUrlPost
     * @summary Generate GCS Upload URL for Project Media
     * @request POST:/api/v2/admin/project-media/generate-upload-url
     */
    generateProjectMediaUploadUrlApiV2AdminProjectMediaGenerateUploadUrlPost: (
      data: ProjectMediaUploadRequest,
      params: RequestParams = {},
    ) =>
      this.request<ProjectMediaUploadResponse, HTTPValidationError>({
        path: `/api/v2/admin/project-media/generate-upload-url`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Finalize a project media upload and create its database record.
     *
     * @tags Admin (Project Media)
     * @name FinalizeProjectMediaUploadApiV2AdminProjectMediaFinalizeUploadPost
     * @summary Finalize Project Media Upload
     * @request POST:/api/v2/admin/project-media/finalize-upload
     */
    finalizeProjectMediaUploadApiV2AdminProjectMediaFinalizeUploadPost: (
      data: ProjectMediaFinalizeRequest,
      params: RequestParams = {},
    ) =>
      this.request<ProjectMedia, HTTPValidationError>({
        path: `/api/v2/admin/project-media/finalize-upload`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve all media files for a specific project.
     *
     * @tags Project Media
     * @name GetProjectMediaListApiV2AdminProjectsProjectIdMediaGet
     * @summary List Media for a Project (All Roles)
     * @request GET:/api/v2/admin/projects/{project_id}/media
     */
    getProjectMediaListApiV2AdminProjectsProjectIdMediaGet: (
      projectId: string,
      params: RequestParams = {},
    ) =>
      this.request<ProjectMedia[], HTTPValidationError>({
        path: `/api/v2/admin/projects/${projectId}/media`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Generate a signed URL for downloading a project media file.
     *
     * @tags Project Media
     * @name GetProjectMediaDownloadUrlApiV2AdminProjectMediaMediaIdDownloadUrlGet
     * @summary Generate GCS Download URL for Project Media (All Roles)
     * @request GET:/api/v2/admin/project-media/{media_id}/download-url
     */
    getProjectMediaDownloadUrlApiV2AdminProjectMediaMediaIdDownloadUrlGet: (
      mediaId: string,
      params: RequestParams = {},
    ) =>
      this.request<ProjectMediaDownloadResponse, HTTPValidationError>({
        path: `/api/v2/admin/project-media/${mediaId}/download-url`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update the caption of a project media file.
     *
     * @tags Admin (Project Media)
     * @name UpdateProjectMediaCaptionApiV2AdminProjectMediaMediaIdPatch
     * @summary Update Project Media Caption
     * @request PATCH:/api/v2/admin/project-media/{media_id}
     */
    updateProjectMediaCaptionApiV2AdminProjectMediaMediaIdPatch: (
      mediaId: string,
      data: ProjectMediaUpdate,
      params: RequestParams = {},
    ) =>
      this.request<ProjectMedia, HTTPValidationError>({
        path: `/api/v2/admin/project-media/${mediaId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a project media file record and its object in GCS.
     *
     * @tags Admin (Project Media)
     * @name DeleteProjectMediaApiV2AdminProjectMediaMediaIdDelete
     * @summary Delete Project Media
     * @request DELETE:/api/v2/admin/project-media/{media_id}
     */
    deleteProjectMediaApiV2AdminProjectMediaMediaIdDelete: (
      mediaId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/v2/admin/project-media/${mediaId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Sends a weekly status report for deployments (On Track & Delayed). Automatically disables notifications for projects inactive for > 2 months. Allows authentication via Admin token OR X-Scheduler-Secret header.
     *
     * @tags Admin (Deployments)
     * @name SendWeeklyDeploymentReportApiV2AdminDeploymentsWeeklyReportPost
     * @summary Send Weekly Deployment Status Reports
     * @request POST:/api/v2/admin/deployments/weekly-report
     */
    sendWeeklyDeploymentReportApiV2AdminDeploymentsWeeklyReportPost: (
      query?: {
        /**
         * Project Id
         * Optional project ID to send report for.
         */
        project_id?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/api/v2/admin/deployments/weekly-report`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Save tree DBH/Age/Height data for carbon sequestration.
     *
     * @tags Admin (Deployments)
     * @name CreateOrUpdateCarbonSequestrationApiApiV2AdminDeploymentsDeploymentIdCarbonSequestrationPost
     * @summary Create or Update Carbon Sequestration Data
     * @request POST:/api/v2/admin/deployments/{deployment_id}/carbon-sequestration
     */
    createOrUpdateCarbonSequestrationApiApiV2AdminDeploymentsDeploymentIdCarbonSequestrationPost:
      (
        deploymentId: string,
        data: CarbonSequestrationCreate,
        params: RequestParams = {},
      ) =>
        this.request<CarbonSequestrationResponse, HTTPValidationError>({
          path: `/api/v2/admin/deployments/${deploymentId}/carbon-sequestration`,
          method: "POST",
          body: data,
          type: ContentType.Json,
          format: "json",
          ...params,
        }),

    /**
     * @description Run batch inference for all pending/failed files when triggered via a specific file.
     *
     * @tags Inference
     * @name RunInferenceOnFileApiV2AdminInferenceFileFileIdPost
     * @summary Run Inference On File
     * @request POST:/api/v2/admin/inference/file/{file_id}
     */
    runInferenceOnFileApiV2AdminInferenceFileFileIdPost: (
      fileId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/api/v2/admin/inference/file/${fileId}`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a single inference record by ID.
     *
     * @tags Inference
     * @name GetApiInferenceApiV2AdminInferenceInferenceIdGet
     * @summary Get Api Inference
     * @request GET:/api/v2/admin/inference/{inference_id}
     */
    getApiInferenceApiV2AdminInferenceInferenceIdGet: (
      inferenceId: string,
      params: RequestParams = {},
    ) =>
      this.request<Inference, HTTPValidationError>({
        path: `/api/v2/admin/inference/${inferenceId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update an existing inference record.
     *
     * @tags Inference
     * @name UpdateApiInferenceApiV2AdminInferenceInferenceIdPut
     * @summary Update Api Inference
     * @request PUT:/api/v2/admin/inference/{inference_id}
     */
    updateApiInferenceApiV2AdminInferenceInferenceIdPut: (
      inferenceId: string,
      data: InferenceUpdate,
      params: RequestParams = {},
    ) =>
      this.request<Inference, HTTPValidationError>({
        path: `/api/v2/admin/inference/${inferenceId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete an inference record.
     *
     * @tags Inference
     * @name DeleteApiInferenceApiV2AdminInferenceInferenceIdDelete
     * @summary Delete Api Inference
     * @request DELETE:/api/v2/admin/inference/{inference_id}
     */
    deleteApiInferenceApiV2AdminInferenceInferenceIdDelete: (
      inferenceId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/v2/admin/inference/${inferenceId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Retrieve all inference records for a given file ID.
     *
     * @tags Inference
     * @name GetApiInferencesByFileIdApiV2AdminInferenceByFileFileIdGet
     * @summary Get Api Inferences By File Id
     * @request GET:/api/v2/admin/inference/by_file/{file_id}
     */
    getApiInferencesByFileIdApiV2AdminInferenceByFileFileIdGet: (
      fileId: string,
      params: RequestParams = {},
    ) =>
      this.request<Inference[], HTTPValidationError>({
        path: `/api/v2/admin/inference/by_file/${fileId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Callback endpoint for Vertex AI / BirdNET to push inference results when a file is processed.
     *
     * @tags Inference
     * @name InferenceCallbackApiV2AdminInferenceCallbackFileIdPost
     * @summary Inference Callback
     * @request POST:/api/v2/admin/inference/callback/{file_id}
     */
    inferenceCallbackApiV2AdminInferenceCallbackFileIdPost: (
      fileId: string,
      data: Record<string, any>,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/api/v2/admin/inference/callback/${fileId}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve details of a specific deployment, including files, site, and project. Access Control: - **Admins / Employees**: Can retrieve details for any deployment they have access to view. - **Field Workers**: Can retrieve details for any deployment they have access to view.
     *
     * @tags Deployments
     * @name GetDeploymentDetailsAdminApiV2DeploymentsDeploymentIdGet
     * @summary Get Deployment Details (Admin/Employee/FieldWorker)
     * @request GET:/api/v2/deployments/{deployment_id}
     */
    getDeploymentDetailsAdminApiV2DeploymentsDeploymentIdGet: (
      deploymentId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        AppSchemasDeploymentDeploymentDetailResponse,
        HTTPValidationError
      >({
        path: `/api/v2/deployments/${deploymentId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update an existing deployment record. Access Control: - Admins and Employees can update all fields. - FieldWorkers can only update status to 'Deployed' or 'Retrieved'.
     *
     * @tags Deployments
     * @name UpdateApiDeploymentApiV2DeploymentsDeploymentIdPut
     * @summary Update a Deployment (Admin/Employee/FieldWorker)
     * @request PUT:/api/v2/deployments/{deployment_id}
     */
    updateApiDeploymentApiV2DeploymentsDeploymentIdPut: (
      deploymentId: string,
      data: AppSchemasDeploymentDeploymentUpdate,
      params: RequestParams = {},
    ) =>
      this.request<
        AppSchemasDeploymentDeploymentAdminDetailBase,
        HTTPValidationError
      >({
        path: `/api/v2/deployments/${deploymentId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a deployment and all its children. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Deployments
     * @name DeleteApiDeploymentApiV2DeploymentsDeploymentIdDelete
     * @summary Delete a Deployment (Admin/Employee)
     * @request DELETE:/api/v2/deployments/{deployment_id}
     */
    deleteApiDeploymentApiV2DeploymentsDeploymentIdDelete: (
      deploymentId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/v2/deployments/${deploymentId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Create a new deployment record. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Deployments
     * @name CreateApiDeploymentApiV2DeploymentsPost
     * @summary Create a New Deployment (Admin/Employee)
     * @request POST:/api/v2/deployments/
     */
    createApiDeploymentApiV2DeploymentsPost: (
      data: AppSchemasDeploymentDeploymentCreate,
      params: RequestParams = {},
    ) =>
      this.request<
        AppSchemasDeploymentDeploymentAdminDetailBase,
        HTTPValidationError
      >({
        path: `/api/v2/deployments/`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a list of all deployments with detailed information. Access Control: - **Admins**: Retrieve all deployments in the system. - **Employees**: Retrieve only deployments from projects they are assigned to. - **Users**: Retrieve only deployments from projects they created.
     *
     * @tags Deployments
     * @name GetAllDeploymentsApiV2DeploymentsGet
     * @summary List All Deployments (Admin/Employee)
     * @request GET:/api/v2/deployments/
     */
    getAllDeploymentsApiV2DeploymentsGet: (
      query?: {
        /**
         * Skip
         * @min 0
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @min 1
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<DeploymentQueryResult, HTTPValidationError>({
        path: `/api/v2/deployments/`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Create or partial update deployment info.
     *
     * @tags Deployments
     * @name CreateOrUpdateDeploymentInfoApiApiV2DeploymentsDeploymentIdInfoPost
     * @summary Create or Update Deployment Info
     * @request POST:/api/v2/deployments/{deployment_id}/info
     */
    createOrUpdateDeploymentInfoApiApiV2DeploymentsDeploymentIdInfoPost: (
      deploymentId: string,
      data: DeploymentInfoUpdate,
      params: RequestParams = {},
    ) =>
      this.request<DeploymentInfo, HTTPValidationError>({
        path: `/api/v2/deployments/${deploymentId}/info`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve info for a specific deployment.
     *
     * @tags Deployments
     * @name GetDeploymentInfoApiApiV2DeploymentsDeploymentIdInfoGet
     * @summary Get Deployment Info (Admin/Employee/FieldWorker)
     * @request GET:/api/v2/deployments/{deployment_id}/info
     */
    getDeploymentInfoApiApiV2DeploymentsDeploymentIdInfoGet: (
      deploymentId: string,
      params: RequestParams = {},
    ) =>
      this.request<DeploymentInfo, HTTPValidationError>({
        path: `/api/v2/deployments/${deploymentId}/info`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update only the is_predeployment_complete flag.
     *
     * @tags Deployments
     * @name UpdatePredeploymentStatusApiApiV2DeploymentsDeploymentIdPredeploymentStatusPatch
     * @summary Update Pre-deployment Completion Status
     * @request PATCH:/api/v2/deployments/{deployment_id}/predeployment-status
     */
    updatePredeploymentStatusApiApiV2DeploymentsDeploymentIdPredeploymentStatusPatch:
      (
        deploymentId: string,
        data: PredeploymentStatusUpdate,
        params: RequestParams = {},
      ) =>
        this.request<DeploymentInfo, HTTPValidationError>({
          path: `/api/v2/deployments/${deploymentId}/predeployment-status`,
          method: "PATCH",
          body: data,
          type: ContentType.Json,
          format: "json",
          ...params,
        }),

    /**
     * @description Create or update retrieval info for a deployment.
     *
     * @tags Deployments
     * @name CreateOrUpdateRetrievalInfoApiApiV2DeploymentsDeploymentIdRetrievalPost
     * @summary Create or Update Retrieval Info
     * @request POST:/api/v2/deployments/{deployment_id}/retrieval
     */
    createOrUpdateRetrievalInfoApiApiV2DeploymentsDeploymentIdRetrievalPost: (
      deploymentId: string,
      data: RetrievalInfoUpdate,
      params: RequestParams = {},
    ) =>
      this.request<RetrievalInfo, HTTPValidationError>({
        path: `/api/v2/deployments/${deploymentId}/retrieval`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve retrieval data for a specific deployment.
     *
     * @tags Deployments
     * @name GetRetrievalInfoApiApiV2DeploymentsDeploymentIdRetrievalGet
     * @summary Get Retrieval Info (Admin/Employee/FieldWorker)
     * @request GET:/api/v2/deployments/{deployment_id}/retrieval
     */
    getRetrievalInfoApiApiV2DeploymentsDeploymentIdRetrievalGet: (
      deploymentId: string,
      params: RequestParams = {},
    ) =>
      this.request<RetrievalInfo, HTTPValidationError>({
        path: `/api/v2/deployments/${deploymentId}/retrieval`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve both deployment and retrieval info side-by-side for comparison.
     *
     * @tags Deployments
     * @name GetDeploymentComparisonApiApiV2DeploymentsDeploymentIdComparisonGet
     * @summary Get Deployment vs Retrieval Comparison (Admin/Employee/FieldWorker)
     * @request GET:/api/v2/deployments/{deployment_id}/comparison
     */
    getDeploymentComparisonApiApiV2DeploymentsDeploymentIdComparisonGet: (
      deploymentId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        AppSchemasDeploymentDataDeploymentComparison,
        HTTPValidationError
      >({
        path: `/api/v2/deployments/${deploymentId}/comparison`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Generate a secure signed URL for assessment photos (deployment/retrieval). The server constructs the GCS path to prevent unauthorized bucket access.
     *
     * @tags Deployments
     * @name GetAssessmentMediaSignedUrlApiApiV2DeploymentsDeploymentIdAssessmentMediaUrlPost
     * @summary Generate Secure Presigned URL for Assessment Media
     * @request POST:/api/v2/deployments/{deployment_id}/assessment-media-url
     */
    getAssessmentMediaSignedUrlApiApiV2DeploymentsDeploymentIdAssessmentMediaUrlPost:
      (
        deploymentId: string,
        data: AssessmentMediaUploadRequest,
        params: RequestParams = {},
      ) =>
        this.request<any, HTTPValidationError>({
          path: `/api/v2/deployments/${deploymentId}/assessment-media-url`,
          method: "POST",
          body: data,
          type: ContentType.Json,
          format: "json",
          ...params,
        }),

    /**
     * @description Retrieve all deployments for a specific location. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Deployments
     * @name GetDeploymentsByLocationIdApiV2DeploymentsLocationsLocationIdGet
     * @summary List Deployments for a Location (Admin/Employee/FieldWorker)
     * @request GET:/api/v2/deployments/locations/{location_id}
     */
    getDeploymentsByLocationIdApiV2DeploymentsLocationsLocationIdGet: (
      locationId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        AppSchemasDeploymentDeploymentAdminDetail[],
        HTTPValidationError
      >({
        path: `/api/v2/deployments/locations/${locationId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new deployment record. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Deployments
     * @name CreateApiDeploymentApiV2AdminDeploymentsPost2
     * @summary Create a New Deployment (Admin/Employee)
     * @request POST:/api/v2/admin/deployments/
     * @originalName createApiDeploymentApiV2AdminDeploymentsPost
     * @duplicate
     */
    createApiDeploymentApiV2AdminDeploymentsPost2: (
      data: AppSchemasDeploymentDeploymentCreate,
      params: RequestParams = {},
    ) =>
      this.request<
        AppSchemasDeploymentDeploymentAdminDetailBase,
        HTTPValidationError
      >({
        path: `/api/v2/admin/deployments/`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a list of all deployments with detailed information. Access Control: - **Admins**: Retrieve all deployments in the system. - **Employees**: Retrieve only deployments from projects they are assigned to. - **Users**: Retrieve only deployments from projects they created.
     *
     * @tags Deployments
     * @name GetAllDeploymentsApiV2AdminDeploymentsGet2
     * @summary List All Deployments (Admin/Employee)
     * @request GET:/api/v2/admin/deployments/
     * @originalName getAllDeploymentsApiV2AdminDeploymentsGet
     * @duplicate
     */
    getAllDeploymentsApiV2AdminDeploymentsGet2: (
      query?: {
        /**
         * Skip
         * @min 0
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @min 1
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<DeploymentQueryResult, HTTPValidationError>({
        path: `/api/v2/admin/deployments/`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve all deployments for a specific location. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Deployments
     * @name GetDeploymentsByLocationIdApiV2AdminDeploymentsLocationsLocationIdGet
     * @summary List Deployments for a Location (Admin/Employee/FieldWorker)
     * @request GET:/api/v2/admin/deployments/locations/{location_id}
     */
    getDeploymentsByLocationIdApiV2AdminDeploymentsLocationsLocationIdGet: (
      locationId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        AppSchemasDeploymentDeploymentAdminDetail[],
        HTTPValidationError
      >({
        path: `/api/v2/admin/deployments/locations/${locationId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new location within a site. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Locations
     * @name CreateApiLocationApiV2LocationsPost
     * @summary Create a New Location (Admin/Employee)
     * @request POST:/api/v2/locations/
     */
    createApiLocationApiV2LocationsPost: (
      data: LocationCreate,
      params: RequestParams = {},
    ) =>
      this.request<LocationAdminDetail, HTTPValidationError>({
        path: `/api/v2/locations/`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description List locations. If site_id is provided, filters by site.
     *
     * @tags Locations
     * @name ListLocationsApiV2LocationsGet
     * @summary List Locations by Site (Admin/Employee)
     * @request GET:/api/v2/locations/
     */
    listLocationsApiV2LocationsGet: (
      query?: {
        /** Site Id */
        site_id?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<LocationAdminDetail[], HTTPValidationError>({
        path: `/api/v2/locations/`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Update an existing location. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Locations
     * @name UpdateApiLocationApiV2LocationsLocationIdPut
     * @summary Update a Location (Admin/Employee)
     * @request PUT:/api/v2/locations/{location_id}
     */
    updateApiLocationApiV2LocationsLocationIdPut: (
      locationId: string,
      data: LocationUpdate,
      params: RequestParams = {},
    ) =>
      this.request<LocationAdminDetail, HTTPValidationError>({
        path: `/api/v2/locations/${locationId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a location and all its children (deployments). Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Locations
     * @name DeleteApiLocationApiV2LocationsLocationIdDelete
     * @summary Delete a Location (Admin/Employee)
     * @request DELETE:/api/v2/locations/{location_id}
     */
    deleteApiLocationApiV2LocationsLocationIdDelete: (
      locationId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/v2/locations/${locationId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Create a new location within a site. Access Control: - Accessible by both **Admins** and **Employees**.
     *
     * @tags Locations
     * @name CreateApiLocationApiV2AdminLocationsPost2
     * @summary Create a New Location (Admin/Employee)
     * @request POST:/api/v2/admin/locations/
     * @originalName createApiLocationApiV2AdminLocationsPost
     * @duplicate
     */
    createApiLocationApiV2AdminLocationsPost2: (
      data: LocationCreate,
      params: RequestParams = {},
    ) =>
      this.request<LocationAdminDetail, HTTPValidationError>({
        path: `/api/v2/admin/locations/`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description List locations. If site_id is provided, filters by site.
     *
     * @tags Locations
     * @name ListLocationsApiV2AdminLocationsGet
     * @summary List Locations by Site (Admin/Employee)
     * @request GET:/api/v2/admin/locations/
     */
    listLocationsApiV2AdminLocationsGet: (
      query?: {
        /** Site Id */
        site_id?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<LocationAdminDetail[], HTTPValidationError>({
        path: `/api/v2/admin/locations/`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description **Create a new assignment**, linking a user (Employee, FieldWorker, or DEV) to a project. - Requires **Admin** or **Employee** role. Employees can only assign FieldWorkers to projects they manage. - Business Rules: - Maximum 1 DEV user per project (must be from same organization as project owner) - Maximum 1 Employee user per project (can be from any organization) - Employee users can be assigned to multiple different projects - DEV users must be from the same organization as the project owner
     *
     * @tags Assignments
     * @name CreateAssignmentEndpointApiV2AssignmentsPost
     * @summary Create Assignment Endpoint
     * @request POST:/api/v2/assignments/
     */
    createAssignmentEndpointApiV2AssignmentsPost: (
      data: AssignmentCreate,
      params: RequestParams = {},
    ) =>
      this.request<Assignment, HTTPValidationError>({
        path: `/api/v2/assignments/`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Retrieve all assignments in the system.** - Requires **Admin** role. - Returns a list of assignment objects with nested user and project details. - Supports pagination with `skip` and `limit` parameters.
     *
     * @tags Assignments
     * @name ListAllAssignmentsApiV2AssignmentsGet
     * @summary List All Assignments
     * @request GET:/api/v2/assignments/
     */
    listAllAssignmentsApiV2AssignmentsGet: (
      query?: {
        /**
         * Skip
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<Assignment[], HTTPValidationError>({
        path: `/api/v2/assignments/`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description **Create multiple assignments** linking a DEV user to multiple projects. - Requires **Admin** role. - Business Rules (same as single assignment): - Maximum 1 DEV user per project - User must be from same organization as project owner - Returns a list of created assignment objects with nested user and project details. - Returns an empty list if no assignments are created.
     *
     * @tags Assignments
     * @name CreateBulkAssignmentsApiV2AssignmentsBulkPost
     * @summary Create Bulk Assignments
     * @request POST:/api/v2/assignments/bulk
     */
    createBulkAssignmentsApiV2AssignmentsBulkPost: (
      query: {
        /**
         * User Id
         * @format uuid
         */
        user_id: string;
      },
      data: string[],
      params: RequestParams = {},
    ) =>
      this.request<Assignment[], HTTPValidationError>({
        path: `/api/v2/assignments/bulk`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description **Retrieve all projects by organization email.** - Requires **Admin** role - Returns a list of project objects for all users in the organization (based on email domain). - Supports pagination with `skip` and `limit` parameters. - The org_email can be any email from the organization (e.g., "user@example.com"). - It will find all users with the same domain (e.g., "@example.com") and return their projects.
     *
     * @tags Assignments
     * @name GetProjectsByOrgEmailApiV2AssignmentsProjectsByOrgEmailOrgEmailGet
     * @summary Get Projects By Org Email
     * @request GET:/api/v2/assignments/projects-by-org-email/{org_email}
     */
    getProjectsByOrgEmailApiV2AssignmentsProjectsByOrgEmailOrgEmailGet: (
      orgEmail: string,
      query?: {
        /**
         * Skip
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<Project[], HTTPValidationError>({
        path: `/api/v2/assignments/projects-by-org-email/${orgEmail}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description **Retrieve all assignments for a specific project.** - Requires **Admin** role. - Returns a list of assignment objects with nested user and project details. - A project can have maximum 1 DEV user (from same org as owner) and 1 Employee user. - Returns an empty list if no assignments are found for the given project ID.
     *
     * @tags Assignments
     * @name GetAssignmentsByProjectApiV2AssignmentsProjectProjectIdGet
     * @summary Get Assignments By Project
     * @request GET:/api/v2/assignments/project/{project_id}
     */
    getAssignmentsByProjectApiV2AssignmentsProjectProjectIdGet: (
      projectId: string,
      params: RequestParams = {},
    ) =>
      this.request<Assignment[], HTTPValidationError>({
        path: `/api/v2/assignments/project/${projectId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description **Retrieve all assignments for a specific user (employee/fieldworker).** - Requires **Admin** or **Employee** role. - Returns a list of assignment objects with nested user and project details. - Returns an empty list if the user has no assignments.
     *
     * @tags Assignments
     * @name GetAssignmentsByUserApiV2AssignmentsUserUserIdGet
     * @summary Get Assignments By User
     * @request GET:/api/v2/assignments/user/{user_id}
     */
    getAssignmentsByUserApiV2AssignmentsUserUserIdGet: (
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<Assignment[], HTTPValidationError>({
        path: `/api/v2/assignments/user/${userId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description **Retrieve a single assignment by its unique ID.** - Requires **Admin** role. - Returns the assignment object with nested user and project details. - Raises 404 if the assignment is not found.
     *
     * @tags Assignments
     * @name GetAssignmentByIdApiV2AssignmentsAssignmentIdGet
     * @summary Get Assignment By Id
     * @request GET:/api/v2/assignments/{assignment_id}
     */
    getAssignmentByIdApiV2AssignmentsAssignmentIdGet: (
      assignmentId: string,
      params: RequestParams = {},
    ) =>
      this.request<Assignment, HTTPValidationError>({
        path: `/api/v2/assignments/${assignmentId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description **Delete an assignment** by its unique ID. - Requires **Admin** or **Employee** role. - Returns 204 No Content on successful deletion. - Raises 404 if the assignment is not found.
     *
     * @tags Assignments
     * @name DeleteAssignmentEndpointApiV2AssignmentsAssignmentIdDelete
     * @summary Delete Assignment Endpoint
     * @request DELETE:/api/v2/assignments/{assignment_id}
     */
    deleteAssignmentEndpointApiV2AssignmentsAssignmentIdDelete: (
      assignmentId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/v2/assignments/${assignmentId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Retrieve files with their inference data.
     *
     * @tags Inferences
     * @name ReadFilesWithInferencesApiV2InferencesFilesGet
     * @summary Read Files With Inferences
     * @request GET:/api/v2/inferences/files
     */
    readFilesWithInferencesApiV2InferencesFilesGet: (
      query?: {
        /**
         * Skip
         * @min 0
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @min 1
         * @max 200
         * @default 100
         */
        limit?: number;
        /** Device Type Id */
        device_type_id?: string | null;
        /**
         * Sort By
         * @default "created_at"
         */
        sort_by?: string;
        /**
         * Sort Order
         * @default "desc"
         * @pattern ^(asc|desc)$
         */
        sort_order?: string;
        /**
         * Entityid
         * Filter by entity, e.g., "enr:site:..."
         */
        entityId?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<FileDetailList, HTTPValidationError>({
        path: `/api/v2/inferences/files`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new support ticket.
     *
     * @tags Support
     * @name CreateSupportTicketApiV2SupportTicketsPost
     * @summary Create Support Ticket
     * @request POST:/api/v2/support/tickets
     */
    createSupportTicketApiV2SupportTicketsPost: (
      data: SupportTicketCreate,
      params: RequestParams = {},
    ) =>
      this.request<SupportTicket, HTTPValidationError>({
        path: `/api/v2/support/tickets`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get support tickets for the current user. Admins can see all tickets.
     *
     * @tags Support
     * @name GetSupportTicketsApiV2SupportTicketsGet
     * @summary Get Support Tickets
     * @request GET:/api/v2/support/tickets
     */
    getSupportTicketsApiV2SupportTicketsGet: (
      query?: {
        /**
         * Skip
         * @min 0
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @min 1
         * @max 100
         * @default 100
         */
        limit?: number;
        /** Status */
        status?: string | null;
        /** Category */
        category?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<SupportTicketList, HTTPValidationError>({
        path: `/api/v2/support/tickets`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a specific support ticket by ID.
     *
     * @tags Support
     * @name GetSupportTicketApiV2SupportTicketsTicketIdGet
     * @summary Get Support Ticket
     * @request GET:/api/v2/support/tickets/{ticket_id}
     */
    getSupportTicketApiV2SupportTicketsTicketIdGet: (
      ticketId: string,
      params: RequestParams = {},
    ) =>
      this.request<SupportTicket, HTTPValidationError>({
        path: `/api/v2/support/tickets/${ticketId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update a support ticket (admin only).
     *
     * @tags Support
     * @name UpdateSupportTicketApiV2SupportTicketsTicketIdPatch
     * @summary Update Support Ticket
     * @request PATCH:/api/v2/support/tickets/{ticket_id}
     */
    updateSupportTicketApiV2SupportTicketsTicketIdPatch: (
      ticketId: string,
      data: SupportTicketUpdate,
      params: RequestParams = {},
    ) =>
      this.request<SupportTicket, HTTPValidationError>({
        path: `/api/v2/support/tickets/${ticketId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Worker endpoint called by Cloud Tasks to process audio files. Status flow: PENDING → RUNNING → COMPLETED | FAILED
     *
     * @tags Worker
     * @name ProcessAudioApiV2WorkerProcessPost
     * @summary Process Audio
     * @request POST:/api/v2/worker/process
     */
    processAudioApiV2WorkerProcessPost: (
      data: AudioProcessingRequest,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/api/v2/worker/process`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Worker endpoint called by a scheduled job (e.g. Cloud Scheduler) to delete expired tokens from the database.
     *
     * @tags Worker
     * @name CleanupExpiredTokensApiV2WorkerCleanupTokensPost
     * @summary Cleanup Expired Tokens
     * @request POST:/api/v2/worker/cleanup-tokens
     */
    cleanupExpiredTokensApiV2WorkerCleanupTokensPost: (
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/api/v2/worker/cleanup-tokens`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description Register or update a user's device push token.
     *
     * @tags Notifications
     * @name RegisterDeviceApiV2NotificationsDevicesPost
     * @summary Register Device
     * @request POST:/api/v2/notifications/devices
     */
    registerDeviceApiV2NotificationsDevicesPost: (
      data: UserDeviceCreate,
      params: RequestParams = {},
    ) =>
      this.request<UserDevice, HTTPValidationError>({
        path: `/api/v2/notifications/devices`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Remove a device push token (e.g., on logout).
     *
     * @tags Notifications
     * @name UnregisterDeviceApiV2NotificationsDevicesDelete
     * @summary Unregister Device
     * @request DELETE:/api/v2/notifications/devices
     */
    unregisterDeviceApiV2NotificationsDevicesDelete: (
      query: {
        /** Expo Push Token */
        expo_push_token: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/api/v2/notifications/devices`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Periodic task to check for upcoming deployments (24h before start/end). Sends push notifications to assigned field workers using Expo. This endpoint is designed for automation via Cloud Scheduler (every 5 min). Access is restricted by a shared secret set in the environment.
     *
     * @tags Notifications
     * @name CheckDeploymentsForNotificationsApiV2NotificationsCheckDeploymentsPost
     * @summary Check Deployments For Notifications
     * @request POST:/api/v2/notifications/check-deployments
     */
    checkDeploymentsForNotificationsApiV2NotificationsCheckDeploymentsPost: (
      params: RequestParams = {},
    ) =>
      this.request<NotificationCheckResult, HTTPValidationError>({
        path: `/api/v2/notifications/check-deployments`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Developers, Developers
     * @name CreateDeveloperApiV2DevelopersPost
     * @summary Create Developer
     * @request POST:/api/v2/developers
     */
    createDeveloperApiV2DevelopersPost: (
      data: UserCreate,
      params: RequestParams = {},
    ) =>
      this.request<UserCreateResponse, HTTPValidationError>({
        path: `/api/v2/developers`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Developers, Developers
     * @name ListDevelopersUsersApiV2DevelopersGet
     * @summary List Developers Users
     * @request GET:/api/v2/developers
     */
    listDevelopersUsersApiV2DevelopersGet: (
      query?: {
        /**
         * Sort By
         * @default "created_at"
         */
        sort_by?: string;
        /**
         * Sort Order
         * @default "desc"
         */
        sort_order?: string;
        /**
         * Page
         * @default 1
         */
        page?: number;
        /**
         * Per Page
         * @default 10
         */
        per_page?: number;
        /** Query */
        query?: string | null;
        /** Role */
        role?: UserRole | null;
        /** Status */
        status?: string | null;
        /** Is Email Verified */
        is_email_verified?: boolean | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserQueryResult, HTTPValidationError>({
        path: `/api/v2/developers`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get current developer profile. Requires X-API-Key or Authorization: Bearer <api_key>
     *
     * @tags Developers, Developers
     * @name ReadDeveloperMeApiV2DevelopersMeGet
     * @summary Read Developer Me
     * @request GET:/api/v2/developers/me
     */
    readDeveloperMeApiV2DevelopersMeGet: (params: RequestParams = {}) =>
      this.request<UserOut, any>({
        path: `/api/v2/developers/me`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Developers, Developers
     * @name GetDeveloperApiV2DevelopersUserIdGet
     * @summary Get Developer
     * @request GET:/api/v2/developers/{user_id}
     */
    getDeveloperApiV2DevelopersUserIdGet: (
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<UserOut, HTTPValidationError>({
        path: `/api/v2/developers/${userId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Developers, Developers
     * @name UpdateDeveloperUserApiV2DevelopersUserIdPut
     * @summary Update Developer User
     * @request PUT:/api/v2/developers/{user_id}
     */
    updateDeveloperUserApiV2DevelopersUserIdPut: (
      userId: string,
      data: UserUpdate,
      params: RequestParams = {},
    ) =>
      this.request<UserResponse, HTTPValidationError>({
        path: `/api/v2/developers/${userId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Developers, Developers
     * @name DeleteDeveloperUserApiV2DevelopersUserIdDelete
     * @summary Delete Developer User
     * @request DELETE:/api/v2/developers/{user_id}
     */
    deleteDeveloperUserApiV2DevelopersUserIdDelete: (
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<UserResponse, HTTPValidationError>({
        path: `/api/v2/developers/${userId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Developers, Developers
     * @name UpdateDeveloperStatusApiV2DevelopersUserIdStatusPatch
     * @summary Update Developer Status
     * @request PATCH:/api/v2/developers/{user_id}/status
     */
    updateDeveloperStatusApiV2DevelopersUserIdStatusPatch: (
      userId: string,
      data: UserStatusUpdate,
      params: RequestParams = {},
    ) =>
      this.request<UserResponse, HTTPValidationError>({
        path: `/api/v2/developers/${userId}/status`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new API endpoint (admin only)
     *
     * @tags API Endpoints, API Endpoints
     * @name CreateApiEndpointApiV2ApiEndpointsPost
     * @summary Create Api Endpoint
     * @request POST:/api/v2/api-endpoints/
     */
    createApiEndpointApiV2ApiEndpointsPost: (
      data: APIEndpointCreate,
      params: RequestParams = {},
    ) =>
      this.request<APIEndpointOut, HTTPValidationError>({
        path: `/api/v2/api-endpoints/`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description List API endpoints with filtering and pagination (admin only)
     *
     * @tags API Endpoints, API Endpoints
     * @name ListApiEndpointsApiV2ApiEndpointsGet
     * @summary List Api Endpoints
     * @request GET:/api/v2/api-endpoints/
     */
    listApiEndpointsApiV2ApiEndpointsGet: (
      query?: {
        /**
         * Page
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * Per Page
         * @min 1
         * @max 100
         * @default 10
         */
        per_page?: number;
        /** Query */
        query?: string | null;
        /** Enabled */
        enabled?: boolean | null;
        /** Service Name */
        service_name?: string | null;
        /**
         * Sort By
         * @default "created_at"
         */
        sort_by?: string | null;
        /**
         * Sort Order
         * @default "desc"
         */
        sort_order?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<APIEndpointQueryResult, HTTPValidationError>({
        path: `/api/v2/api-endpoints/`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get API endpoint by ID (admin only)
     *
     * @tags API Endpoints, API Endpoints
     * @name GetApiEndpointApiV2ApiEndpointsEndpointIdGet
     * @summary Get Api Endpoint
     * @request GET:/api/v2/api-endpoints/{endpoint_id}
     */
    getApiEndpointApiV2ApiEndpointsEndpointIdGet: (
      endpointId: string,
      params: RequestParams = {},
    ) =>
      this.request<APIEndpointOut, HTTPValidationError>({
        path: `/api/v2/api-endpoints/${endpointId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update API endpoint (admin only)
     *
     * @tags API Endpoints, API Endpoints
     * @name UpdateApiEndpointApiV2ApiEndpointsEndpointIdPut
     * @summary Update Api Endpoint
     * @request PUT:/api/v2/api-endpoints/{endpoint_id}
     */
    updateApiEndpointApiV2ApiEndpointsEndpointIdPut: (
      endpointId: string,
      data: APIEndpointUpdate,
      params: RequestParams = {},
    ) =>
      this.request<APIEndpointOut, HTTPValidationError>({
        path: `/api/v2/api-endpoints/${endpointId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete API endpoint (admin only)
     *
     * @tags API Endpoints, API Endpoints
     * @name DeleteApiEndpointApiV2ApiEndpointsEndpointIdDelete
     * @summary Delete Api Endpoint
     * @request DELETE:/api/v2/api-endpoints/{endpoint_id}
     */
    deleteApiEndpointApiV2ApiEndpointsEndpointIdDelete: (
      endpointId: string,
      params: RequestParams = {},
    ) =>
      this.request<APIEndpointOut, HTTPValidationError>({
        path: `/api/v2/api-endpoints/${endpointId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * @description Enable or disable an API endpoint (admin only)
     *
     * @tags API Endpoints, API Endpoints
     * @name ToggleApiEndpointApiV2ApiEndpointsEndpointIdTogglePatch
     * @summary Toggle Api Endpoint
     * @request PATCH:/api/v2/api-endpoints/{endpoint_id}/toggle
     */
    toggleApiEndpointApiV2ApiEndpointsEndpointIdTogglePatch: (
      endpointId: string,
      data: APIEndpointToggle,
      params: RequestParams = {},
    ) =>
      this.request<APIEndpointOut, HTTPValidationError>({
        path: `/api/v2/api-endpoints/${endpointId}/toggle`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags API Keys, API Keys
     * @name CreateApiKeyApiV2ApiKeysCreatePost
     * @summary Create Api Key
     * @request POST:/api/v2/api-keys/create
     */
    createApiKeyApiV2ApiKeysCreatePost: (
      query: {
        /**
         * User Id
         * @format uuid
         */
        user_id: string;
        /** Environment */
        environment: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<APIKeyCreateResponse, HTTPValidationError>({
        path: `/api/v2/api-keys/create`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags API Keys
     * @name GetApiKeyApiV2ApiKeysApiKeyIdGet
     * @summary Get Api Key
     * @request GET:/api/v2/api-keys/{api_key_id}
     */
    getApiKeyApiV2ApiKeysApiKeyIdGet: (
      apiKeyId: string,
      params: RequestParams = {},
    ) =>
      this.request<APIKeyOut, HTTPValidationError>({
        path: `/api/v2/api-keys/${apiKeyId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description List all API keys with pagination and filtering. - Supports pagination via `page` and `per_page` parameters - Can filter by `status` (active, revoked, expired) - Can filter by `user_id` to get keys for a specific user - Supports sorting via `sort_by` and `sort_order` parameters
     *
     * @tags API Keys, API Keys
     * @name ListApiKeysApiV2ApiKeysGet
     * @summary List Api Keys
     * @request GET:/api/v2/api-keys/
     */
    listApiKeysApiV2ApiKeysGet: (
      query?: {
        /**
         * Page
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * Per Page
         * @min 1
         * @max 100
         * @default 10
         */
        per_page?: number;
        /** Status */
        status?: string | null;
        /** User Id */
        user_id?: string | null;
        /**
         * Sort By
         * @default "created_at"
         */
        sort_by?: string | null;
        /**
         * Sort Order
         * @default "desc"
         */
        sort_order?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<APIKeyQueryResult, HTTPValidationError>({
        path: `/api/v2/api-keys/`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags API Keys, API Keys
     * @name RevokeApiKeyApiV2ApiKeysApiKeyIdRevokePut
     * @summary Revoke Api Key
     * @request PUT:/api/v2/api-keys/{api_key_id}/revoke
     */
    revokeApiKeyApiV2ApiKeysApiKeyIdRevokePut: (
      apiKeyId: string,
      params: RequestParams = {},
    ) =>
      this.request<APIKeyRevokeResponse, HTTPValidationError>({
        path: `/api/v2/api-keys/${apiKeyId}/revoke`,
        method: "PUT",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags API Keys, API Keys
     * @name RegenerateApiKeyApiV2ApiKeysApiKeyIdRegeneratePost
     * @summary Regenerate Api Key
     * @request POST:/api/v2/api-keys/{api_key_id}/regenerate
     */
    regenerateApiKeyApiV2ApiKeysApiKeyIdRegeneratePost: (
      apiKeyId: string,
      params: RequestParams = {},
    ) =>
      this.request<APIKeyRegenerateResponse, HTTPValidationError>({
        path: `/api/v2/api-keys/${apiKeyId}/regenerate`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags API Keys, API Keys
     * @name GetApiKeyUsageApiV2ApiKeysApiKeyIdUsageGet
     * @summary Get Api Key Usage
     * @request GET:/api/v2/api-keys/{api_key_id}/usage
     */
    getApiKeyUsageApiV2ApiKeysApiKeyIdUsageGet: (
      apiKeyId: string,
      params: RequestParams = {},
    ) =>
      this.request<APIKeyUsageResponse, HTTPValidationError>({
        path: `/api/v2/api-keys/${apiKeyId}/usage`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags API Keys, API Keys
     * @name GetApiKeyPermissionsApiV2ApiKeysApiKeyIdPermissionsGet
     * @summary Get Api Key Permissions
     * @request GET:/api/v2/api-keys/{api_key_id}/permissions
     */
    getApiKeyPermissionsApiV2ApiKeysApiKeyIdPermissionsGet: (
      apiKeyId: string,
      params: RequestParams = {},
    ) =>
      this.request<APIKeyPermissionsResponse, HTTPValidationError>({
        path: `/api/v2/api-keys/${apiKeyId}/permissions`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Assign an API endpoint to a developer (admin only)
     *
     * @tags Developer Permissions, Developer Permissions
     * @name AssignEndpointToDeveloperApiV2DevelopersDeveloperIdPermissionsPost
     * @summary Assign Endpoint To Developer
     * @request POST:/api/v2/developers/{developer_id}/permissions
     */
    assignEndpointToDeveloperApiV2DevelopersDeveloperIdPermissionsPost: (
      developerId: string,
      data: DeveloperPermissionCreate,
      params: RequestParams = {},
    ) =>
      this.request<DeveloperPermissionOut, HTTPValidationError>({
        path: `/api/v2/developers/${developerId}/permissions`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description List all permissions (assigned endpoints) for a developer (admin only)
     *
     * @tags Developer Permissions, Developer Permissions
     * @name ListDeveloperPermissionsApiV2DevelopersDeveloperIdPermissionsGet
     * @summary List Developer Permissions
     * @request GET:/api/v2/developers/{developer_id}/permissions
     */
    listDeveloperPermissionsApiV2DevelopersDeveloperIdPermissionsGet: (
      developerId: string,
      query?: {
        /**
         * Status Filter
         * Filter by status: 'active' or 'inactive'
         */
        status_filter?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<DeveloperPermissionListResponse, HTTPValidationError>({
        path: `/api/v2/developers/${developerId}/permissions`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Bulk assign multiple endpoints to a developer (admin only)
     *
     * @tags Developer Permissions, Developer Permissions
     * @name BulkAssignEndpointsToDeveloperApiV2DevelopersDeveloperIdPermissionsBulkPost
     * @summary Bulk Assign Endpoints To Developer
     * @request POST:/api/v2/developers/{developer_id}/permissions/bulk
     */
    bulkAssignEndpointsToDeveloperApiV2DevelopersDeveloperIdPermissionsBulkPost:
      (
        developerId: string,
        data: DeveloperPermissionBulkCreate,
        params: RequestParams = {},
      ) =>
        this.request<DeveloperPermissionOut[], HTTPValidationError>({
          path: `/api/v2/developers/${developerId}/permissions/bulk`,
          method: "POST",
          body: data,
          type: ContentType.Json,
          format: "json",
          ...params,
        }),

    /**
     * @description Get permission by ID (admin only)
     *
     * @tags Developer Permissions, Developer Permissions
     * @name GetPermissionApiV2PermissionsPermissionIdGet
     * @summary Get Permission
     * @request GET:/api/v2/permissions/{permission_id}
     */
    getPermissionApiV2PermissionsPermissionIdGet: (
      permissionId: string,
      params: RequestParams = {},
    ) =>
      this.request<DeveloperPermissionOut, HTTPValidationError>({
        path: `/api/v2/permissions/${permissionId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Revoke endpoint access from developer (admin only)
     *
     * @tags Developer Permissions, Developer Permissions
     * @name RevokePermissionApiV2PermissionsPermissionIdDelete
     * @summary Revoke Permission
     * @request DELETE:/api/v2/permissions/{permission_id}
     */
    revokePermissionApiV2PermissionsPermissionIdDelete: (
      permissionId: string,
      params: RequestParams = {},
    ) =>
      this.request<DeveloperPermissionOut, HTTPValidationError>({
        path: `/api/v2/permissions/${permissionId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * @description Activate or deactivate a permission (admin only)
     *
     * @tags Developer Permissions, Developer Permissions
     * @name TogglePermissionStatusApiV2PermissionsPermissionIdStatusPatch
     * @summary Toggle Permission Status
     * @request PATCH:/api/v2/permissions/{permission_id}/status
     */
    togglePermissionStatusApiV2PermissionsPermissionIdStatusPatch: (
      permissionId: string,
      data: DeveloperPermissionToggle,
      params: RequestParams = {},
    ) =>
      this.request<DeveloperPermissionOut, HTTPValidationError>({
        path: `/api/v2/permissions/${permissionId}/status`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Revoke specific endpoint access from developer (admin only)
     *
     * @tags Developer Permissions, Developer Permissions
     * @name RevokeEndpointFromDeveloperApiV2DevelopersDeveloperIdPermissionsEndpointIdDelete
     * @summary Revoke Endpoint From Developer
     * @request DELETE:/api/v2/developers/{developer_id}/permissions/{endpoint_id}
     */
    revokeEndpointFromDeveloperApiV2DevelopersDeveloperIdPermissionsEndpointIdDelete:
      (developerId: string, endpointId: string, params: RequestParams = {}) =>
        this.request<DeveloperPermissionOut, HTTPValidationError>({
          path: `/api/v2/developers/${developerId}/permissions/${endpointId}`,
          method: "DELETE",
          format: "json",
          ...params,
        }),

    /**
     * No description
     *
     * @tags Admin Logs, Logs
     * @name GetApiRequestLogsApiV2AdminLogsRequestsGet
     * @summary Get Api Request Logs
     * @request GET:/api/v2/admin/logs/requests
     */
    getApiRequestLogsApiV2AdminLogsRequestsGet: (
      query?: {
        /**
         * Skip
         * @min 0
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @min 1
         * @max 100
         * @default 100
         */
        limit?: number;
        /** Developer Id */
        developer_id?: string | null;
        /** Endpoint Path */
        endpoint_path?: string | null;
        /** Status Code */
        status_code?: number | null;
        /** Start Date */
        start_date?: string | null;
        /** End Date */
        end_date?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<APIRequestLogOut[], HTTPValidationError>({
        path: `/api/v2/admin/logs/requests`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Logs, Logs
     * @name GetApiRequestLogApiV2AdminLogsRequestRequestIdGet
     * @summary Get Api Request Log
     * @request GET:/api/v2/admin/logs/request/{request_id}
     */
    getApiRequestLogApiV2AdminLogsRequestRequestIdGet: (
      requestId: string,
      params: RequestParams = {},
    ) =>
      this.request<APIRequestLogOut, HTTPValidationError>({
        path: `/api/v2/admin/logs/request/${requestId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Logs, Logs
     * @name DeleteApiRequestLogApiV2AdminLogsRequestRequestIdDelete
     * @summary Delete Api Request Log
     * @request DELETE:/api/v2/admin/logs/request/{request_id}
     */
    deleteApiRequestLogApiV2AdminLogsRequestRequestIdDelete: (
      requestId: string,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, any>, HTTPValidationError>({
        path: `/api/v2/admin/logs/request/${requestId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin Logs, Logs
     * @name GetAuditLogsApiV2AdminLogsAuditLogsGet
     * @summary Get Audit Logs
     * @request GET:/api/v2/admin/logs/audit-logs
     */
    getAuditLogsApiV2AdminLogsAuditLogsGet: (
      query?: {
        /**
         * Skip
         * @min 0
         * @default 0
         */
        skip?: number;
        /**
         * Limit
         * @min 1
         * @max 100
         * @default 100
         */
        limit?: number;
        /** Admin User Id */
        admin_user_id?: string | null;
        /** Action */
        action?: string | null;
        /** Entity Type */
        entity_type?: string | null;
        /** Entity Id */
        entity_id?: string | null;
        /** Start Date */
        start_date?: string | null;
        /** End Date */
        end_date?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<AuditLogOut[], HTTPValidationError>({
        path: `/api/v2/admin/logs/audit-logs`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Fieldworkers
     * @name RegisterFieldworkerApiV2FieldworkersRegisterFieldworkersPost
     * @summary Register a new FieldWorker (Admin/Employee)
     * @request POST:/api/v2/fieldworkers/register/fieldworkers
     */
    registerFieldworkerApiV2FieldworkersRegisterFieldworkersPost: (
      data: UserCreate,
      params: RequestParams = {},
    ) =>
      this.request<UserResponse, HTTPValidationError>({
        path: `/api/v2/fieldworkers/register/fieldworkers`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Fieldworkers
     * @name ListManagerFieldworkersApiV2FieldworkersManagerFieldworkersGet
     * @summary List Fieldworkers for a Manager (Employee)
     * @request GET:/api/v2/fieldworkers/manager/fieldworkers
     */
    listManagerFieldworkersApiV2FieldworkersManagerFieldworkersGet: (
      params: RequestParams = {},
    ) =>
      this.request<UserQueryResult, any>({
        path: `/api/v2/fieldworkers/manager/fieldworkers`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Fieldworkers
     * @name UpdateFieldworkerApiV2FieldworkersManagerFieldworkersUserIdPatch
     * @summary Update Fieldworker Profile (Admin/Employee)
     * @request PATCH:/api/v2/fieldworkers/manager/fieldworkers/{user_id}
     */
    updateFieldworkerApiV2FieldworkersManagerFieldworkersUserIdPatch: (
      userId: string,
      data: UserUpdate,
      params: RequestParams = {},
    ) =>
      this.request<UserResponse, HTTPValidationError>({
        path: `/api/v2/fieldworkers/manager/fieldworkers/${userId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Upload one or more geometry files. Creates one Site record per file. Supported formats: .zip (shapefile), .kmz, .kml, .geojson, .json, .shp Multipolygon handling: If a file contains multiple polygon features (e.g. a shapefile with 300 polygons), the boundary CF dissolves all of them via unary_union into a single combined geometry. One site record is created per file regardless of how many polygon features it contains. polygon_count stores the original feature count for reference. Batch upload: Multiple files may be uploaded in one request. Each file becomes its own site record with its own boundary CF background task. Returns pending site records immediately. Frontend polls GET /projects/{id}/sites/{id}/status to track boundary_status and tool computation progress.
     *
     * @tags Sites
     * @name UploadSitesFromFileApiV2ProjectsProjectIdSitesFileUploadPost
     * @summary Upload geometry files and create sites
     * @request POST:/api/v2/projects/{project_id}/sites/file-upload
     */
    uploadSitesFromFileApiV2ProjectsProjectIdSitesFileUploadPost: (
      projectId: string,
      data: BodyUploadSitesFromFileApiV2ProjectsProjectIdSitesFileUploadPost,
      params: RequestParams = {},
    ) =>
      this.request<SiteResponse[], HTTPValidationError>({
        path: `/api/v2/projects/${projectId}/sites/file-upload`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Receive a metrics_computed Pub/Sub push message from a tool microservice. GCP calls this endpoint when a tool microservice publishes to the metrics_computed topic. This endpoint: 1. Unpacks the Pub/Sub envelope 2. Decodes base64 → JSON payload 3. Validates payload with Pydantic 4. Upserts computation_log row (pending → completed/failed) Auth: GCP push subscriptions include an OIDC token in Authorization header. Restrict this endpoint to GCP internal traffic via Cloud Run ingress settings for additional security (no token verification needed in application code).
     *
     * @tags Internal
     * @name ReceiveMetricsComputedApiV2InternalEventsMetricsComputedPost
     * @summary Pub/Sub push: receive metrics_computed events from tool microservices
     * @request POST:/api/v2/internal/events/metrics-computed
     */
    receiveMetricsComputedApiV2InternalEventsMetricsComputedPost: (
      params: RequestParams = {},
    ) =>
      this.request<Record<string, any>, any>({
        path: `/api/v2/internal/events/metrics-computed`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description Returns combined status for a site — boundary + all tool computations. This is a simple DB read — no Pub/Sub involved. The data is already in the DB, updated by: - boundary_status: updated by the boundary pipeline background task - tools[]: rows pre-created at site_processed publish time (pending), updated to completed/failed when metrics_computed events arrive at POST /internal/events/metrics-computed Frontend polls every 5 seconds. Stops when: boundary_status = completed AND all tool statuses = completed or failed
     *
     * @tags Sites
     * @name GetSiteStatusApiV2ProjectsProjectIdSitesSiteIdStatusGet
     * @summary Poll boundary processing and tool computation status for a site
     * @request GET:/api/v2/projects/{project_id}/sites/{site_id}/status
     */
    getSiteStatusApiV2ProjectsProjectIdSitesSiteIdStatusGet: (
      projectId: string,
      siteId: string,
      params: RequestParams = {},
    ) =>
      this.request<SiteStatusResponse, HTTPValidationError>({
        path: `/api/v2/projects/${projectId}/sites/${siteId}/status`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Returns 404 if the site doesn't exist, 409 if the site exists but its boundary hasn't finished processing yet (boundary_status != completed) -- a caller hitting this before boundary processing completes is a sequencing bug on the caller's side, not a transient condition worth retrying blindly.
     *
     * @tags Internal
     * @name GetSiteHydrationApiV2InternalSitesSiteIdGet
     * @summary Hydrate site geometry, area, project type, and enabled tools for a tool microservice
     * @request GET:/api/v2/internal/sites/{site_id}
     */
    getSiteHydrationApiV2InternalSitesSiteIdGet: (
      siteId: string,
      params: RequestParams = {},
    ) =>
      this.request<SiteHydrationResponse, HTTPValidationError>({
        path: `/api/v2/internal/sites/${siteId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tools, Tools
     * @name ListToolsApiV2ToolsGet
     * @summary List all tools in system catalog
     * @request GET:/api/v2/tools
     */
    listToolsApiV2ToolsGet: (
      query?: {
        /** Module */
        module?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<ToolList, HTTPValidationError>({
        path: `/api/v2/tools`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tools, Tools
     * @name CreateToolApiV2ToolsPost
     * @summary Register a new tool in the catalog (Admin only)
     * @request POST:/api/v2/tools
     */
    createToolApiV2ToolsPost: (data: ToolCreate, params: RequestParams = {}) =>
      this.request<ToolResponse, HTTPValidationError>({
        path: `/api/v2/tools`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Enabling a tool here is what site_hydration on the tool microservice side actually reads (live, not cached) -- there is no tool_enabled event, so this write is the entire mechanism, not just a UI-facing convenience.
     *
     * @tags Project Tools
     * @name EnableProjectToolApiV2ProjectsProjectIdToolsPost
     * @summary Enable a tool for a project
     * @request POST:/api/v2/projects/{project_id}/tools
     */
    enableProjectToolApiV2ProjectsProjectIdToolsPost: (
      projectId: string,
      data: ProjectToolEnable,
      params: RequestParams = {},
    ) =>
      this.request<ProjectToolResponse, HTTPValidationError>({
        path: `/api/v2/projects/${projectId}/tools`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project Tools
     * @name ListProjectToolsApiV2ProjectsProjectIdToolsGet
     * @summary List tools enabled for a project
     * @request GET:/api/v2/projects/{project_id}/tools
     */
    listProjectToolsApiV2ProjectsProjectIdToolsGet: (
      projectId: string,
      params: RequestParams = {},
    ) =>
      this.request<ProjectToolList, HTTPValidationError>({
        path: `/api/v2/projects/${projectId}/tools`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project Tools
     * @name DisableProjectToolApiV2ProjectsProjectIdToolsProjectToolIdDelete
     * @summary Disable a tool for a project
     * @request DELETE:/api/v2/projects/{project_id}/tools/{project_tool_id}
     */
    disableProjectToolApiV2ProjectsProjectIdToolsProjectToolIdDelete: (
      projectId: string,
      projectToolId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/v2/projects/${projectId}/tools/${projectToolId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organisation Tools
     * @name ProvisionOrganisationToolApiV2OrganisationsOrgIdToolsPost
     * @summary Provision a tool for an organisation
     * @request POST:/api/v2/organisations/{org_id}/tools
     */
    provisionOrganisationToolApiV2OrganisationsOrgIdToolsPost: (
      orgId: string,
      data: OrganisationToolProvision,
      params: RequestParams = {},
    ) =>
      this.request<OrganisationToolResponse, HTTPValidationError>({
        path: `/api/v2/organisations/${orgId}/tools`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organisation Tools
     * @name ListOrganisationToolsApiV2OrganisationsOrgIdToolsGet
     * @summary List tools provisioned for an organisation
     * @request GET:/api/v2/organisations/{org_id}/tools
     */
    listOrganisationToolsApiV2OrganisationsOrgIdToolsGet: (
      orgId: string,
      params: RequestParams = {},
    ) =>
      this.request<OrganisationToolList, HTTPValidationError>({
        path: `/api/v2/organisations/${orgId}/tools`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organisation Tools
     * @name GetOrganisationToolApiV2OrganisationsToolsOrgToolIdGet
     * @summary Get details of a specific organisation tool
     * @request GET:/api/v2/organisations/tools/{org_tool_id}
     */
    getOrganisationToolApiV2OrganisationsToolsOrgToolIdGet: (
      orgToolId: string,
      params: RequestParams = {},
    ) =>
      this.request<OrganisationToolResponse, HTTPValidationError>({
        path: `/api/v2/organisations/tools/${orgToolId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organisation Tools
     * @name UpdateOrganisationToolApiV2OrganisationsToolsOrgToolIdPatch
     * @summary Update configuration or status of an organisation tool
     * @request PATCH:/api/v2/organisations/tools/{org_tool_id}
     */
    updateOrganisationToolApiV2OrganisationsToolsOrgToolIdPatch: (
      orgToolId: string,
      data: OrganisationToolUpdate,
      params: RequestParams = {},
    ) =>
      this.request<OrganisationToolResponse, HTTPValidationError>({
        path: `/api/v2/organisations/tools/${orgToolId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organisation Tools
     * @name SuspendOrganisationToolApiV2OrganisationsToolsOrgToolIdSuspendPatch
     * @summary Suspend an organisation tool
     * @request PATCH:/api/v2/organisations/tools/{org_tool_id}/suspend
     */
    suspendOrganisationToolApiV2OrganisationsToolsOrgToolIdSuspendPatch: (
      orgToolId: string,
      params: RequestParams = {},
    ) =>
      this.request<OrganisationToolResponse, HTTPValidationError>({
        path: `/api/v2/organisations/tools/${orgToolId}/suspend`,
        method: "PATCH",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organisation Tools
     * @name ActivateOrganisationToolApiV2OrganisationsToolsOrgToolIdActivatePatch
     * @summary Activate an organisation tool
     * @request PATCH:/api/v2/organisations/tools/{org_tool_id}/activate
     */
    activateOrganisationToolApiV2OrganisationsToolsOrgToolIdActivatePatch: (
      orgToolId: string,
      params: RequestParams = {},
    ) =>
      this.request<OrganisationToolResponse, HTTPValidationError>({
        path: `/api/v2/organisations/tools/${orgToolId}/activate`,
        method: "PATCH",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tools, Tools
     * @name GetToolApiV2ToolsToolIdGet
     * @summary Get details of a specific tool
     * @request GET:/api/v2/tools/{tool_id}
     */
    getToolApiV2ToolsToolIdGet: (toolId: string, params: RequestParams = {}) =>
      this.request<ToolResponse, HTTPValidationError>({
        path: `/api/v2/tools/${toolId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tools, Tools
     * @name UpdateToolApiV2ToolsToolIdPatch
     * @summary Update a tool in system catalog (Admin only)
     * @request PATCH:/api/v2/tools/{tool_id}
     */
    updateToolApiV2ToolsToolIdPatch: (
      toolId: string,
      data: ToolUpdate,
      params: RequestParams = {},
    ) =>
      this.request<ToolResponse, HTTPValidationError>({
        path: `/api/v2/tools/${toolId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
